<template>
  <svg
    id="building"
    viewBox="0 0 1283 934.37"
    :class="currentClass"
  >
    <defs>
      <clipPath id="clippath-1">
        <rect
          class="cls-24"
          x="730.5"
          y="445.64"
          width="12"
          height="111"
          rx=".19"
          ry=".19"
        />
      </clipPath>
      <clipPath id="clippath-2">
        <rect
          class="cls-24"
          x="599.5"
          y="446.64"
          width="12"
          height="111"
          rx=".19"
          ry=".19"
        />
      </clipPath>
      <clipPath id="clippath-3">
        <rect
          class="cls-24"
          x="612"
          y="446.22"
          width="118"
          height="110.96"
          rx=".19"
          ry=".19"
        />
      </clipPath>
      <clipPath id="clippath-4">
        <rect
          class="cls-24"
          x="612"
          y="446.22"
          width="118"
          height="110.96"
          rx=".19"
          ry=".19"
        />
      </clipPath>
      <clipPath id="clippath-5">
        <rect
          class="cls-24"
          x="701.5"
          y="292.64"
          width="12"
          height="110"
          rx=".35"
          ry=".35"
        />
      </clipPath>
      <clipPath id="clippath-6">
        <rect
          class="cls-24"
          x="784.5"
          y="292.64"
          width="12"
          height="111"
          rx=".35"
          ry=".35"
        />
      </clipPath>
      <clipPath id="clippath-7">
        <rect
          class="cls-24"
          x="713.29"
          y="286.3"
          width="70.71"
          height="122.96"
          rx=".35"
          ry=".35"
        />
      </clipPath>
      <clipPath id="clippath-8">
        <rect
          class="cls-24"
          x="681.19"
          y="604.68"
          width="149.58"
          height="110.96"
          rx=".29"
          ry=".29"
        />
      </clipPath>
      <clipPath id="clippath-9">
        <rect
          class="cls-24"
          x="669.5"
          y="604.64"
          width="12"
          height="111"
          rx=".19"
          ry=".19"
        />
      </clipPath>
      <clipPath id="clippath-10">
        <rect
          class="cls-24"
          x="830.5"
          y="604.64"
          width="12"
          height="111"
          rx=".19"
          ry=".19"
        />
      </clipPath>
      <clipPath id="clippath-11">
        <path
          class="cls-24"
          d="M1124.76,756.64h16.19c.31,0,.55.25.55.55v137.89c0,.31-.25.55-.55.55h-16.19c-.14,0-.26-.12-.26-.26v-138.48c0-.14.12-.26.26-.26Z"
        />
      </clipPath>
      <clipPath id="clippath-12">
        <rect
          class="cls-24"
          x="519.19"
          y="110.36"
          width="13"
          height="216"
          rx=".43"
          ry=".43"
        />
      </clipPath>
      <clipPath id="clippath-14">
        <rect
          class="cls-24"
          x="519.19"
          y="110.36"
          width="13"
          height="216"
          rx=".43"
          ry=".43"
        />
      </clipPath>
    </defs>
    <g
      id="_0"
      data-name="0"
    >
      <g id="background">
        <path
          class="cls-35"
          d="M0,873.84V315.16c0-2.02,1.86-3.65,4.12-3.61l384.92,7.33c2.26.04,4.12-1.59,4.12-3.61v-16.98c0-2.49,2.75-4.23,5.37-3.41l27.49,8.65c.07.02.14.05.21.07l656.77,243.66c2.01.75,4.32-.07,5.22-1.85l54.71-108.19c.64-1.28,2.05-2.1,3.62-2.12l125.24-1.57c2.23-.03,4.06,1.57,4.09,3.56l7.12,459.3c.03,2-1.77,3.65-4,3.66l-1256.97,8.08H4.03c-2.23,0-4.03-1.62-4.03-3.61v-30.69Z"
        />
        <path
          class="cls-4"
          d="M433.07,902.22l-4.97-890.47c0-1.61,1.28-2.92,2.9-2.95l203.07-3.86c1.66-.03,3.01,1.29,3.01,2.94v42.66c0,1.83,1.67,3.21,3.48,2.89L934.6.55c1.81-.33,3.48,1.06,3.48,2.89v352.31c0,1.14.67,2.18,1.71,2.66l126.08,58.09c1.04.48,1.71,1.52,1.71,2.66v296.51c0,1.62,1.32,2.93,2.95,2.94l140.16.41c1.61,0,2.92,1.28,2.95,2.88l3.52,180.24c.03,1.64-1.3,2.99-2.96,2.99H436.03c-1.63,0-2.95-1.3-2.96-2.92Z"
        />
        <rect
          class="cls-4"
          x="432.5"
          y="900.64"
          width="785"
          height="12"
          rx="2.38"
          ry="2.38"
        />
      </g>
      <g id="brique">
        <g>
          <rect
            class="cls-4"
            x="796.83"
            y="314.43"
            width="39.5"
            height="13.17"
          />
          <rect
            class="cls-4"
            x="796.83"
            y="327.59"
            width="19.75"
            height="13.17"
          />
          <rect
            class="cls-4"
            x="796.83"
            y="301.26"
            width="19.75"
            height="13.17"
          />
        </g>
        <g>
          <rect
            class="cls-4"
            x="560.2"
            y="488.41"
            width="39.5"
            height="13.17"
            transform="translate(1159.89 989.99) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="521.7"
            y="488.41"
            width="39.5"
            height="13.17"
            transform="translate(1082.89 989.99) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="579.95"
            y="501.58"
            width="19.75"
            height="13.17"
            transform="translate(1179.64 1016.32) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="540.45"
            y="501.58"
            width="39.5"
            height="13.17"
            transform="translate(1120.39 1016.32) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="579.95"
            y="475.24"
            width="19.75"
            height="13.17"
            transform="translate(1179.64 963.65) rotate(-180)"
          />
        </g>
        <g>
          <rect
            class="cls-4"
            x="885.7"
            y="455.83"
            width="39.5"
            height="13.17"
            transform="translate(1810.89 924.82) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="846.2"
            y="455.83"
            width="39.5"
            height="13.17"
            transform="translate(1731.89 924.82) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="865.95"
            y="468.99"
            width="39.5"
            height="13.17"
            transform="translate(1771.39 951.15) rotate(-180)"
          />
        </g>
        <g>
          <rect
            class="cls-4"
            x="603.63"
            y="269.04"
            width="39.5"
            height="13.17"
            transform="translate(1246.75 551.24) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="565.13"
            y="269.04"
            width="39.5"
            height="13.17"
            transform="translate(1169.75 551.24) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="623.38"
            y="282.2"
            width="19.75"
            height="13.17"
            transform="translate(1266.5 577.57) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="583.88"
            y="282.2"
            width="39.5"
            height="13.17"
            transform="translate(1207.25 577.57) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="623.38"
            y="255.87"
            width="19.75"
            height="13.17"
            transform="translate(1266.5 524.9) rotate(-180)"
          />
        </g>
        <g>
          <rect
            class="cls-4"
            x="825.13"
            y="112.45"
            width="39.5"
            height="13.17"
            transform="translate(1689.75 238.07) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="785.63"
            y="112.45"
            width="39.5"
            height="13.17"
            transform="translate(1610.75 238.07) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="805.38"
            y="125.62"
            width="39.5"
            height="13.17"
            transform="translate(1650.25 264.4) rotate(-180)"
          />
        </g>
        <g>
          <rect
            class="cls-4"
            x="480.38"
            y="156.04"
            width="39.5"
            height="13.17"
            transform="translate(1000.25 325.24) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="500.13"
            y="169.2"
            width="19.75"
            height="13.17"
            transform="translate(1020 351.57) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="500.13"
            y="142.87"
            width="19.75"
            height="13.17"
            transform="translate(1020 298.9) rotate(-180)"
          />
        </g>
        <g>
          <rect
            class="cls-4"
            x="840.53"
            y="651.26"
            width="39.5"
            height="13.17"
          />
          <rect
            class="cls-4"
            x="879.03"
            y="651.26"
            width="39.5"
            height="13.17"
          />
          <rect
            class="cls-4"
            x="840.53"
            y="664.42"
            width="19.75"
            height="13.17"
          />
          <rect
            class="cls-4"
            x="860.28"
            y="664.42"
            width="39.5"
            height="13.17"
          />
          <rect
            class="cls-4"
            x="840.53"
            y="638.09"
            width="19.75"
            height="13.17"
          />
        </g>
        <g>
          <rect
            class="cls-4"
            x="1141.49"
            y="817.71"
            width="39.5"
            height="13.17"
          />
          <rect
            class="cls-4"
            x="1141.49"
            y="830.88"
            width="19.75"
            height="13.17"
          />
          <rect
            class="cls-4"
            x="1141.49"
            y="804.54"
            width="19.75"
            height="13.17"
          />
        </g>
        <g>
          <rect
            class="cls-4"
            x="838.27"
            y="815.81"
            width="39.5"
            height="13.17"
          />
          <rect
            class="cls-4"
            x="838.27"
            y="828.98"
            width="19.75"
            height="13.17"
          />
          <rect
            class="cls-4"
            x="838.27"
            y="802.65"
            width="19.75"
            height="13.17"
          />
        </g>
        <g>
          <rect
            class="cls-4"
            x="566"
            y="799.81"
            width="39.5"
            height="13.17"
            transform="translate(1171.5 1612.78) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="527.5"
            y="799.81"
            width="39.5"
            height="13.17"
            transform="translate(1094.5 1612.78) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="585.75"
            y="812.97"
            width="19.75"
            height="13.17"
            transform="translate(1191.25 1639.12) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="546.25"
            y="812.97"
            width="39.5"
            height="13.17"
            transform="translate(1132 1639.12) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="585.75"
            y="786.64"
            width="19.75"
            height="13.17"
            transform="translate(1191.25 1586.45) rotate(-180)"
          />
        </g>
        <g>
          <rect
            class="cls-4"
            x="485.58"
            y="852.71"
            width="39.5"
            height="13.17"
            transform="translate(1010.66 1718.58) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="446.08"
            y="852.71"
            width="39.5"
            height="13.17"
            transform="translate(931.66 1718.58) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="465.83"
            y="865.87"
            width="39.5"
            height="13.17"
            transform="translate(971.16 1744.91) rotate(-180)"
          />
        </g>
        <g>
          <rect
            class="cls-4"
            x="566.58"
            y="655.12"
            width="39.5"
            height="13.17"
            transform="translate(1172.66 1323.41) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="527.08"
            y="655.12"
            width="39.5"
            height="13.17"
            transform="translate(1093.66 1323.41) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="546.83"
            y="668.29"
            width="39.5"
            height="13.17"
            transform="translate(1133.16 1349.75) rotate(-180)"
          />
        </g>
        <g>
          <rect
            class="cls-4"
            x="950.28"
            y="770.48"
            width="39.5"
            height="13.17"
            transform="translate(1940.07 1554.12) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="910.78"
            y="770.48"
            width="39.5"
            height="13.17"
            transform="translate(1861.07 1554.12) rotate(-180)"
          />
          <rect
            class="cls-4"
            x="930.53"
            y="783.64"
            width="39.5"
            height="13.17"
            transform="translate(1900.57 1580.45) rotate(-180)"
          />
        </g>
      </g>
      <g
        id="fenêtre_milieu"
        data-name="fenêtre milieu"
      >
        <rect
          class="cls-5"
          x="612"
          y="440.22"
          width="118"
          height="122.96"
          rx=".19"
          ry=".19"
        />
        <rect
          class="cls-15"
          x="612"
          y="446.22"
          width="118"
          height="110.96"
          rx=".19"
          ry=".19"
        />
        <rect
          class="cls-7"
          x="612"
          y="446.22"
          width="118"
          height="110.96"
          rx=".19"
          ry=".19"
        />
        <path
          class="cls-49"
          d="M633.3,455.89v-1.21h-.82v-7.74h-.27v7.74h-.82v1.21c-1.75,1.06-2.8,4.88-2.94,7.4h7.77c-.13-2.53-1.18-6.35-2.94-7.4Z"
        />
        <g>
          <g class="cls-91">
            <g>
              <rect
                class="cls-24"
                x="671"
                y="273.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="671.5"
                  y1="273.14"
                  x2="671.5"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="678.73"
                  y1="273.14"
                  x2="678.73"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="685.95"
                  y1="273.14"
                  x2="685.95"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="693.18"
                  y1="273.14"
                  x2="693.18"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="700.4"
                  y1="273.14"
                  x2="700.4"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="707.63"
                  y1="273.14"
                  x2="707.63"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="714.85"
                  y1="273.14"
                  x2="714.85"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="722.08"
                  y1="273.14"
                  x2="722.08"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="729.31"
                  y1="273.14"
                  x2="729.31"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="736.53"
                  y1="273.14"
                  x2="736.53"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="743.76"
                  y1="273.14"
                  x2="743.76"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="750.98"
                  y1="273.14"
                  x2="750.98"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="758.21"
                  y1="273.14"
                  x2="758.21"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="765.44"
                  y1="273.14"
                  x2="765.44"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="772.66"
                  y1="273.14"
                  x2="772.66"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="779.89"
                  y1="273.14"
                  x2="779.89"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="787.11"
                  y1="273.14"
                  x2="787.11"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="794.34"
                  y1="273.14"
                  x2="794.34"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="801.56"
                  y1="273.14"
                  x2="801.56"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="808.79"
                  y1="273.14"
                  x2="808.79"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="816.02"
                  y1="273.14"
                  x2="816.02"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="823.24"
                  y1="273.14"
                  x2="823.24"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="830.47"
                  y1="273.14"
                  x2="830.47"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="837.69"
                  y1="273.14"
                  x2="837.69"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="844.92"
                  y1="273.14"
                  x2="844.92"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="852.15"
                  y1="273.14"
                  x2="852.15"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="859.37"
                  y1="273.14"
                  x2="859.37"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="866.6"
                  y1="273.14"
                  x2="866.6"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="873.82"
                  y1="273.14"
                  x2="873.82"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="881.05"
                  y1="273.14"
                  x2="881.05"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="888.27"
                  y1="273.14"
                  x2="888.27"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="895.5"
                  y1="273.14"
                  x2="895.5"
                  y2="497.14"
                />
              </g>
            </g>
            <g>
              <rect
                class="cls-24"
                x="671"
                y="497.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="671.5"
                  y1="497.14"
                  x2="671.5"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="678.73"
                  y1="497.14"
                  x2="678.73"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="685.95"
                  y1="497.14"
                  x2="685.95"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="693.18"
                  y1="497.14"
                  x2="693.18"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="700.4"
                  y1="497.14"
                  x2="700.4"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="707.63"
                  y1="497.14"
                  x2="707.63"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="714.85"
                  y1="497.14"
                  x2="714.85"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="722.08"
                  y1="497.14"
                  x2="722.08"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="729.31"
                  y1="497.14"
                  x2="729.31"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="736.53"
                  y1="497.14"
                  x2="736.53"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="743.76"
                  y1="497.14"
                  x2="743.76"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="750.98"
                  y1="497.14"
                  x2="750.98"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="758.21"
                  y1="497.14"
                  x2="758.21"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="765.44"
                  y1="497.14"
                  x2="765.44"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="772.66"
                  y1="497.14"
                  x2="772.66"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="779.89"
                  y1="497.14"
                  x2="779.89"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="787.11"
                  y1="497.14"
                  x2="787.11"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="794.34"
                  y1="497.14"
                  x2="794.34"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="801.56"
                  y1="497.14"
                  x2="801.56"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="808.79"
                  y1="497.14"
                  x2="808.79"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="816.02"
                  y1="497.14"
                  x2="816.02"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="823.24"
                  y1="497.14"
                  x2="823.24"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="830.47"
                  y1="497.14"
                  x2="830.47"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="837.69"
                  y1="497.14"
                  x2="837.69"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="844.92"
                  y1="497.14"
                  x2="844.92"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="852.15"
                  y1="497.14"
                  x2="852.15"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="859.37"
                  y1="497.14"
                  x2="859.37"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="866.6"
                  y1="497.14"
                  x2="866.6"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="873.82"
                  y1="497.14"
                  x2="873.82"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="881.05"
                  y1="497.14"
                  x2="881.05"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="888.27"
                  y1="497.14"
                  x2="888.27"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="895.5"
                  y1="497.14"
                  x2="895.5"
                  y2="721.14"
                />
              </g>
            </g>
          </g>
          <path
            class="cls-75"
            d="M742.31,557.14h-11.62c-.38,0-.69-.31-.69-.69v-110.62c0-.38.31-.69.69-.69h11.62c.38,0,.69.31.69.69v110.62c0,.38-.31.69-.69.69ZM731,556.14h11v-110h-11v110Z"
          />
        </g>
        <g>
          <g class="cls-94">
            <g>
              <rect
                class="cls-24"
                x="446"
                y="273.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="446.5"
                  y1="273.14"
                  x2="446.5"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="453.73"
                  y1="273.14"
                  x2="453.73"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="460.95"
                  y1="273.14"
                  x2="460.95"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="468.18"
                  y1="273.14"
                  x2="468.18"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="475.4"
                  y1="273.14"
                  x2="475.4"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="482.63"
                  y1="273.14"
                  x2="482.63"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="489.85"
                  y1="273.14"
                  x2="489.85"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="497.08"
                  y1="273.14"
                  x2="497.08"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="504.31"
                  y1="273.14"
                  x2="504.31"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="511.53"
                  y1="273.14"
                  x2="511.53"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="518.76"
                  y1="273.14"
                  x2="518.76"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="525.98"
                  y1="273.14"
                  x2="525.98"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="533.21"
                  y1="273.14"
                  x2="533.21"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="540.44"
                  y1="273.14"
                  x2="540.44"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="547.66"
                  y1="273.14"
                  x2="547.66"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="554.89"
                  y1="273.14"
                  x2="554.89"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="562.11"
                  y1="273.14"
                  x2="562.11"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="569.34"
                  y1="273.14"
                  x2="569.34"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="576.56"
                  y1="273.14"
                  x2="576.56"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="583.79"
                  y1="273.14"
                  x2="583.79"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="591.02"
                  y1="273.14"
                  x2="591.02"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="598.24"
                  y1="273.14"
                  x2="598.24"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="605.47"
                  y1="273.14"
                  x2="605.47"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="612.69"
                  y1="273.14"
                  x2="612.69"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="619.92"
                  y1="273.14"
                  x2="619.92"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="627.15"
                  y1="273.14"
                  x2="627.15"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="634.37"
                  y1="273.14"
                  x2="634.37"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="641.6"
                  y1="273.14"
                  x2="641.6"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="648.82"
                  y1="273.14"
                  x2="648.82"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="656.05"
                  y1="273.14"
                  x2="656.05"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="663.27"
                  y1="273.14"
                  x2="663.27"
                  y2="497.14"
                />
                <line
                  class="cls-6"
                  x1="670.5"
                  y1="273.14"
                  x2="670.5"
                  y2="497.14"
                />
              </g>
            </g>
            <g>
              <rect
                class="cls-24"
                x="446"
                y="497.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="446.5"
                  y1="497.14"
                  x2="446.5"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="453.73"
                  y1="497.14"
                  x2="453.73"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="460.95"
                  y1="497.14"
                  x2="460.95"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="468.18"
                  y1="497.14"
                  x2="468.18"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="475.4"
                  y1="497.14"
                  x2="475.4"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="482.63"
                  y1="497.14"
                  x2="482.63"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="489.85"
                  y1="497.14"
                  x2="489.85"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="497.08"
                  y1="497.14"
                  x2="497.08"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="504.31"
                  y1="497.14"
                  x2="504.31"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="511.53"
                  y1="497.14"
                  x2="511.53"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="518.76"
                  y1="497.14"
                  x2="518.76"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="525.98"
                  y1="497.14"
                  x2="525.98"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="533.21"
                  y1="497.14"
                  x2="533.21"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="540.44"
                  y1="497.14"
                  x2="540.44"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="547.66"
                  y1="497.14"
                  x2="547.66"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="554.89"
                  y1="497.14"
                  x2="554.89"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="562.11"
                  y1="497.14"
                  x2="562.11"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="569.34"
                  y1="497.14"
                  x2="569.34"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="576.56"
                  y1="497.14"
                  x2="576.56"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="583.79"
                  y1="497.14"
                  x2="583.79"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="591.02"
                  y1="497.14"
                  x2="591.02"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="598.24"
                  y1="497.14"
                  x2="598.24"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="605.47"
                  y1="497.14"
                  x2="605.47"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="612.69"
                  y1="497.14"
                  x2="612.69"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="619.92"
                  y1="497.14"
                  x2="619.92"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="627.15"
                  y1="497.14"
                  x2="627.15"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="634.37"
                  y1="497.14"
                  x2="634.37"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="641.6"
                  y1="497.14"
                  x2="641.6"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="648.82"
                  y1="497.14"
                  x2="648.82"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="656.05"
                  y1="497.14"
                  x2="656.05"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="663.27"
                  y1="497.14"
                  x2="663.27"
                  y2="721.14"
                />
                <line
                  class="cls-6"
                  x1="670.5"
                  y1="497.14"
                  x2="670.5"
                  y2="721.14"
                />
              </g>
            </g>
          </g>
          <path
            class="cls-75"
            d="M611.31,558.14h-11.62c-.38,0-.69-.31-.69-.69v-110.62c0-.38.31-.69.69-.69h11.62c.38,0,.69.31.69.69v110.62c0,.38-.31.69-.69.69ZM600,557.14h11v-110h-11v110Z"
          />
        </g>
        <g class="cls-93">
          <g>
            <path
              class="cls-74"
              d="M649.55,497.63c-.49,1.55-2.38,6.97-3.34,10.85-.65,2.6-.83,4.76-.97,5.33,0,0,6.11-2.85,7.48-2.94,2.1-.13,5.69,5.6,4.9,6.2-1.25.94-7.37,4.3-12.34,5.19-4.08.74-8.19-1.73-7.97-5.59.21-3.86,6.95-14.65,9.41-17.66,1.27-1.56,3.44-3.26,2.84-1.38Z"
            />
            <path
              class="cls-69"
              d="M637.08,517.53c.93,4.45,4.71,5.07,6.71,5.08,3.45,0,13.82-3.94,13.82-3.94l-4.86-8.36s-7.34,3.42-7.51,3.49h0c.05-.21,1.39-6.82,2.04-9.02.03-.12.07-.25.11-.38.19-.61.45-1.42.73-2.29h0c.16-.49.33-.99.49-1.49h0c.72-2.16,1.43-4.22,1.43-4.22-1.17.26-2.3.96-4.1,3.08-1.79,2.12-9.8,13.58-8.87,18.04Z"
            />
            <path
              class="cls-74"
              d="M645.13,513.85c.54-.02,1.82-.34,2.32.07,3.05,2.55,3.93,1.94,4.56,2.26,4.92,2.45,11.05,5.81,13.32,5.69,3.44-.18,5.74-3.23,5-5.92-1.45-5.32-10.04-15.82-13.5-18.42-1.83-1.37-1.56.85-.69,3.23.51,1.4,1.37,3.46,2.25,5.49.78,1.81,2.83,6.42,2.87,6.53h0s0,.01,0,.02c0,.01,0,.02-.04,0-.15-.02-4.33-1.69-8.48-2.5-1.46-.28-3.4-.37-4.48.12-2.66,1.21-3.14,3.42-3.14,3.42Z"
            />
            <path
              class="cls-69"
              d="M655.84,510.95c-.77-.21-1.11-.19-1.11-.19l-4.14,7.57s11.96,3.57,14.39,3.68,5.81-1.98,5.68-5.02c-.19-4.27-8.13-14.21-11.87-17.97-1.71-1.72-3.66-2.93-4.12-2.6-.54.39.62,2.61,1.26,4.28,1.18,3.09,4.75,11.88,4.75,11.88,0,0-3.92-1.37-4.83-1.62Z"
            />
            <path
              class="cls-84"
              d="M641.82,586.76c-.15-.07,1.95-19.78,2.27-30.01.22-7.03,3.76-38.77,3.69-40.38,0-.01,16.1,0,16.1,0,0,0,3.47,7.77-1.85,14.59,0,0-3.31,24.96-3.11,28.19.36,5.75-1.4,27.8-1.12,27.95l-15.98-.32Z"
            />
            <path
              class="cls-84"
              d="M664.41,553.07c.06.21,11.15,23.48,11.15,23.48l-14.09,7.45s-9.85-22.8-10.9-25.64c-1.38-3.74-9.78-20.61-6.57-42h17.01s-.15,8.01-3.8,13.8c0,0,6.84,21.55,7.2,22.91Z"
            />
            <path
              class="cls-74"
              d="M654.2,496.31c-.13.32-.55,1.88-2.1,1.67-1.45-.2-1.58-2.6-1.58-2.6v-.21s-.18-2.95-.18-2.95l3.7-1.59.53-.2s0,.81-.03,1.82c0,.05,0,.09,0,.14,0,.06,0,.11,0,.16,0,.15,0,.3,0,.46,0,.12,0,.23-.01.35,0,.12-.01.24-.02.37-.07,1.21-.25,2.45-.31,2.59Z"
            />
            <path
              class="cls-65"
              d="M654.54,492.23c-1.19,2.13-3.15,2.75-4.04,2.93l-.16-2.95,3.7-1.59.53-.2s0,.81-.03,1.82Z"
            />
            <path
              class="cls-74"
              d="M647.61,487.57c-1.18,5.05,1.69,6.38,2.8,6.58,1,.18,4.39.89,6.08-4.01,1.7-4.9-.28-7.05-2.51-7.69-2.23-.65-5.19.07-6.37,5.13Z"
            />
            <path
              class="cls-59"
              d="M642.72,520s18.5.26,22.85-.05c0,0-4.54-17.69-9.21-22.77-2.34-2.54-5.97-2.6-8.01,1.34-4.32,8.33-5.62,21.48-5.62,21.48Z"
            />
            <path
              class="cls-65"
              d="M643.81,502.83c.18.01,1.02.07,2.25.16.47-.76,1.04-2.13.92-4.1-.02-.33.66,1.58.22,4.19,2.38.17,5.61.41,8.44.58.11-1.1.26-2.12.26-2.12.06.8.19,1.53.36,2.16.39.03.77.05,1.13.07,0-1.72.44-4.69.44-4.69.15,2.09.74,3.78,1.17,4.78,1.8.09,2.98.12,2.91.03-2.56-3.25-.49-4.94-1.13-7.72-.77-3.33-3.57-3.99-3.37-6.46.16-2.01.59-5.64-1.91-6.54,0,0-1.95-2.36-5.26-1.27-4.08,1.34-2.8,7.61-3.13,8.86-.48,1.78-1.36,2.37-2.1,4.39-.75,2.05.12,3.47.16,4.88.03,1.41-1.8,2.76-1.35,2.79Z"
            />
            <path
              class="cls-65"
              d="M662,503.46c-.34-.57-.63-1.18-.79-1.8-.18-.62-.06-1.24.1-1.89.15-.64.33-1.29.43-1.97.09-.68.1-1.39-.1-2.08-.18-.68-.54-1.32-.99-1.83-.45-.53-.97-.96-1.48-1.39-.5-.43-1-.86-1.36-1.39-.37-.53-.58-1.16-.63-1.83-.06.66.08,1.36.43,1.96.34.6.82,1.1,1.3,1.56.48.46.97.9,1.37,1.4.4.5.71,1.05.86,1.66.15.6.17,1.24.1,1.88-.07.64-.22,1.28-.34,1.94-.06.33-.11.67-.11,1.02,0,.35.06.71.18,1.03.24.64.61,1.22,1.04,1.72Z"
            />
            <path
              class="cls-65"
              d="M647.86,484.1c-.35.75-.51,1.57-.66,2.37-.14.81-.24,1.62-.34,2.44l-.15,1.21c-.05.4-.12.78-.24,1.15-.24.74-.69,1.38-1.2,2.02-.25.33-.5.67-.71,1.04-.21.37-.38.77-.5,1.18-.11.42-.19.82-.24,1.24-.05.42-.05.85,0,1.27.05.42.15.82.23,1.22.08.39.13.79.13,1.19.02.78-.43,1.54-1.09,2.02.72-.38,1.27-1.15,1.34-2.01.03-.42,0-.84-.04-1.25-.05-.41-.13-.81-.16-1.2-.06-.78.08-1.58.3-2.33.12-.37.28-.73.47-1.06.19-.34.43-.66.68-.98.24-.32.5-.66.72-1.02.22-.36.41-.76.53-1.17.12-.41.19-.84.22-1.25.04-.41.07-.82.1-1.23.06-.82.1-1.63.18-2.44.07-.81.17-1.62.4-2.4Z"
            />
            <path
              class="cls-65"
              d="M657.97,576.09c-.07,0-.14-.04-.18-.11-8.84-16.13-13.69-37.99-13.74-38.21-.02-.11.05-.22.15-.24.11-.02.22.05.24.15.05.22,4.89,22.02,13.7,38.1.05.1.02.22-.08.28-.03.02-.06.02-.1.02Z"
            />
            <rect
              class="cls-65"
              x="660.48"
              y="577.55"
              width="13.5"
              height=".41"
              transform="translate(-181.92 337.07) rotate(-25.06)"
            />
            <path
              class="cls-65"
              d="M651.69,530.63c-2.21,0-3.35-.35-3.45-.38-.11-.03-.17-.15-.13-.26s.15-.16.25-.13c.05.01,4.73,1.44,13.73-1.58.11-.04.22.02.26.13.04.11-.02.22-.13.26-4.7,1.57-8.21,1.97-10.54,1.97Z"
            />
            <path
              class="cls-65"
              d="M660.27,540.31c-.09,0-.17-.06-.19-.14l-3.05-10.3c-.03-.11.03-.22.14-.25.11-.04.22.03.25.14l3.05,10.3c.03.11-.03.22-.14.25-.02,0-.04,0-.06,0Z"
            />
            <path
              class="cls-57"
              d="M643.55,520.21s-.04,0-.06,0l-1.19-.35,3.62-16.1c.02-.11.13-.18.24-.15.11.02.18.13.15.24l-3.54,15.72.83.25c.11.03.17.14.14.25-.03.09-.11.14-.19.14Z"
            />
            <path
              class="cls-57"
              d="M664.85,520.18c-.1,0-.18-.07-.2-.17-.02-.11.05-.22.16-.24l.43-.08-5.11-15.53c-.04-.11.02-.22.13-.26.11-.04.22.02.26.13l5.25,15.97-.89.16s-.02,0-.04,0Z"
            />
          </g>
        </g>
        <g>
          <rect
            class="cls-5"
            x="677.65"
            y="470.97"
            width="36.13"
            height="41.17"
          />
          <g>
            <rect
              class="cls-49"
              x="685.34"
              y="477.26"
              width="9.57"
              height="24.96"
              transform="translate(1179.87 -200.38) rotate(90)"
            />
            <path
              class="cls-58"
              d="M687.72,470.97c.43,2.05.83,4.11,1.28,6.16.43,2.05.86,4.1,1.31,6.15.46,2.04.92,4.08,1.45,6.1.27,1.01.54,2.01.86,3l.25.73c.09.24.18.48.27.71.1.23.2.46.31.68.05.11.11.21.18.31.05.1.13.19.21.29.61.78,1.37,1.49,2.16,2.15.79.66,1.63,1.28,2.48,1.86,1.71,1.16,3.52,2.22,5.43,2.95.48.18.97.33,1.45.4.24.03.48.05.7.01.23-.04.46-.1.69-.2.92-.38,1.76-1.02,2.56-1.67,1.61-1.32,3.06-2.84,4.47-4.39-.63.84-1.29,1.65-1.99,2.44-.7.79-1.42,1.55-2.2,2.27-.79.7-1.61,1.39-2.61,1.87-.25.12-.52.21-.81.27-.3.06-.59.04-.87.02-.56-.07-1.08-.21-1.59-.38-1.02-.34-1.99-.79-2.93-1.29-.94-.5-1.85-1.04-2.74-1.62-.89-.58-1.74-1.21-2.56-1.89-.82-.68-1.61-1.4-2.3-2.27-.08-.11-.17-.22-.25-.35-.08-.13-.16-.25-.21-.38-.13-.25-.24-.5-.34-.75-.1-.25-.19-.5-.29-.75l-.25-.76c-.32-1.01-.6-2.03-.85-3.05-.5-2.05-.94-4.1-1.32-6.17-.79-4.12-1.43-8.27-1.95-12.44Z"
            />
            <path
              class="cls-58"
              d="M694.18,470.97c.59,1.92,1.14,3.85,1.66,5.78.53,1.93,1.03,3.87,1.52,5.81.25.97.48,1.94.72,2.92.24.97.47,1.95.7,2.92.46,1.95.9,3.9,1.33,5.86l-.52-.21,1.86-1.11,1.88-1.09,1.89-1.08c.63-.36,1.27-.71,1.9-1.05-.59.43-1.18.85-1.77,1.26l-1.79,1.23-1.8,1.22-1.81,1.2-.39.26-.12-.47c-.5-1.94-1-3.88-1.47-5.82-.24-.97-.48-1.94-.7-2.92-.23-.98-.46-1.95-.68-2.93-.44-1.95-.87-3.91-1.28-5.87-.41-1.96-.79-3.93-1.13-5.9Z"
            />
            <path
              class="cls-58"
              d="M702.24,486.45c-.08-1.04.11-2.11.5-3.11.21-.49.48-.97.8-1.41.33-.44.71-.82,1.17-1.16.47-.31.98-.56,1.52-.69.54-.14,1.08-.22,1.63-.24.54-.02,1.09.02,1.62.09.54.08,1.06.17,1.6.33l.4.12-.12.39c-.29.99-.65,1.94-1.11,2.86-.48.9-1.03,1.82-1.97,2.45l-.38.2c-.13.05-.25.09-.38.14-.25.08-.51.14-.76.18-.51.09-1.02.13-1.52.13-1.01,0-2.02-.08-3-.28ZM702.24,486.45c1,.02,1.99,0,2.97-.13.49-.05.97-.14,1.43-.26.23-.06.46-.14.68-.22.11-.05.22-.09.32-.14l.27-.17c.7-.54,1.2-1.39,1.62-2.26.4-.87.76-1.8,1.01-2.72l.28.51c-.93-.27-1.96-.43-2.94-.42-.99-.01-1.97.19-2.8.68-.4.25-.77.59-1.1.96-.33.37-.61.79-.85,1.23-.47.89-.78,1.89-.88,2.93Z"
            />
            <path
              class="cls-58"
              d="M690.82,483.57c.14-.6.37-1.17.68-1.72.32-.53.7-1.08,1.36-1.4.33-.16.68-.21,1.02-.21.34-.01.66.02.98.08.32.05.63.13.93.23.3.1.59.2.9.33l.28.12-.04.31c-.05.37-.14.68-.26,1.01-.12.32-.27.64-.46.93-.19.29-.43.56-.71.79-.28.23-.61.4-.95.51-.34.09-.69.16-1.04.14-.34-.02-.68-.07-1-.17-.63-.21-1.21-.53-1.69-.97ZM690.82,483.57c.58.27,1.18.47,1.78.55.6.09,1.2.02,1.72-.19.25-.12.48-.26.68-.45.2-.19.37-.41.51-.66.28-.48.48-1.07.57-1.62l.24.43c-.51-.23-1.08-.42-1.62-.55-.28-.07-.55-.11-.82-.12-.27,0-.54,0-.76.08-.47.17-.9.58-1.27,1.03-.38.45-.7.96-1.01,1.49Z"
            />
            <path
              class="cls-58"
              d="M694.7,482.14c.19.77-.11,1.51-.68,1.66-.57.14-1.19-.36-1.39-1.13-.19-.77.11-1.51.68-1.66.57-.14,1.19.36,1.39,1.13Z"
            />
            <path
              class="cls-58"
              d="M708.49,482.93c.36,1.41-.2,2.77-1.25,3.03-1.05.26-2.18-.66-2.54-2.08-.36-1.41.2-2.77,1.25-3.03,1.05-.26,2.18.66,2.54,2.08Z"
            />
            <path
              class="cls-78"
              d="M700.2,479.97s2.5-3.91,4.52-4.71c2.03-.8,6.5.24,6.5.24"
            />
            <rect
              class="cls-78"
              x="703"
              y="496.7"
              width="10.78"
              height="10.78"
            />
          </g>
        </g>
        <g class="cls-92">
          <g>
            <path
              class="cls-78"
              d="M739.23,586.89l-19.25.15s-5.14-58.19-.57-73.43h13.81s3.71,6.47,1.59,13.76l.66,26.2,3.75,33.33Z"
            />
            <path
              class="cls-78"
              d="M725.23,528.72s-5.68,21.05-5.52,24.16c.16,3.2-1.83,36.02-1.83,36.02l-19.19.1s1.62-33.47,1.92-36.8c.56-6.23,6.95-23.34,11.52-38.58h20.69s-.18,7.98-4.43,13.76c0,0-1.92.76-3.16,1.35Z"
            />
            <path
              class="cls-65"
              d="M722.13,582.79c-.13,0-.24-.1-.25-.24-.02-.33-1.59-33.37-1.74-34.33-.16-1.01,3.54-17.07,3.96-18.89.03-.13.16-.22.3-.19.13.03.22.17.19.3-1.64,7.12-4.05,17.98-3.96,18.71.15.99,1.68,33.02,1.74,34.39,0,.14-.1.25-.24.26h-.01Z"
            />
            <line
              class="cls-11"
              x1="719.91"
              y1="547.92"
              x2="718.88"
              y2="572.33"
            />
            <path
              class="cls-63"
              d="M726.35,492.89c6.65,6.74,10.66,16.07,10.53,18.25-.15,2.4-7.46,10.85-11,14.74-.45.5-3.1.22-5.32-.89-2.33-1.17-4.21-3.2-3.73-3.79,1.82-2.18,9.71-10.77,9.72-12.12,0-1.25-3.15-8.95-4.3-13.39-1.11-4.27,1-5.95,4.1-2.81Z"
            />
            <path
              class="cls-71"
              d="M728.37,525.89l-10.91-6.19s8.81-9.54,8.85-10.57c.04-1.03-3.01-9.22-4.14-12.99-1.13-3.77.34-7.9,5.62-2.11,5.28,5.79,8.92,14.25,9.39,16.5.47,2.25-8.81,15.36-8.81,15.36Z"
            />
            <g>
              <path
                class="cls-63"
                d="M718.59,494.94c1.08.17,3.63-1.3,4.76-2.66.08-.09.04-1.16.06-2.46.02-.79.06-1.66.17-2.46l-6.02.65s.35,1.73.16,3.12c-.02.12-.05.22-.08.32,0,.01-.01.03-.02.05-.24,1.99-.72,3.17.97,3.44Z"
              />
              <path
                class="cls-63"
                d="M717.63,491.44s-.01.03-.02.05c.18.04.38.07.6.09,3.49.27,4.89-3.36,5.16-4.21l-5.82.63s.35,1.73.16,3.12c-.02.12-.05.22-.09.32Z"
              />
            </g>
            <path
              class="cls-36"
              d="M721.76,490.05s0,0,0,0"
            />
            <path
              class="cls-63"
              d="M724.58,480.6c.65,1.78-.4,6.95-1.88,8.11-2.14,1.68-5.67,1.87-7.34-.34-1.63-2.13-.11-8.85,1.54-9.9,2.43-1.56,6.72-.5,7.68,2.13Z"
            />
            <path
              class="cls-63"
              d="M715.34,481.21s-.72,1.91-1.45,3.8h.78s-.29.85-.29.85c0,0,.78.27,1.65-.13l-.7-4.52Z"
            />
            <g>
              <g>
                <path
                  class="cls-65"
                  d="M715.91,483.4s.03.02.02.04c-.1.34-.15.75.19.93.01,0,0,.02,0,.02-.43-.14-.36-.68-.21-.99Z"
                />
                <path
                  class="cls-65"
                  d="M716.36,483.11c.66.08.43,1.2-.18,1.13-.6-.07-.37-1.19.18-1.13Z"
                />
              </g>
              <path
                class="cls-65"
                d="M716.97,482.75c-.17-.07-.32-.15-.48-.23-.18-.09-.34-.14-.44-.31-.05-.09,0-.23.1-.28.23-.12.48-.06.71.04.24.11.4.25.51.46.11.21-.18.4-.4.32Z"
              />
              <path
                class="cls-65"
                d="M715.87,486.73c-.11.07-.23.16-.38.15-.14-.01-.3-.09-.42-.15-.01,0-.03,0-.02.02.08.15.28.27.48.27.19,0,.31-.12.38-.26.01-.02-.02-.03-.04-.02Z"
              />
              <path
                class="cls-65"
                d="M716.17,485.68c-.45.32-.83.43-1.48.26-.03,0-.04-.04-.03-.03.52.03.91-.01,1.5-.27.03-.02.04.02.01.04Z"
              />
            </g>
            <g>
              <path
                class="cls-65"
                d="M715.61,477.31c-.78,1.09-.37,3.38,3.71,3.31,0,0-.43.76-.25,1.7.09.51.65.66.65.66-.16.43-.4,1.26-.33,1.34.21.24.56.19.6.19,0,0,2.55,3.03,3.67,2.82.63-1.1,3.44-4.44,2.5-6.86-.48-1.24-2.28-1.84-2.28-1.84-3.31-3.03-7.01-3.08-8.26-1.33Z"
              />
              <path
                class="cls-65"
                d="M719.32,480.61c-.2.45-.39.9-.43,1.36-.02.22.02.45.16.63.15.18.4.28.67.37-.28-.02-.58-.08-.8-.28-.22-.2-.26-.48-.25-.73.02-.25.1-.49.21-.72.11-.22.25-.44.43-.63Z"
              />
              <path
                class="cls-65"
                d="M723.87,478.64c.81.16,1.59.5,2.15,1.05.28.27.48.61.59.96.11.36.12.72.09,1.08-.07.72-.33,1.41-.67,2.07-.35.65-.77,1.27-1.27,1.83.43-.61.81-1.24,1.12-1.89.3-.65.55-1.33.61-2.03.03-.34.03-.7-.07-1.03-.1-.33-.28-.64-.53-.91-.51-.54-1.25-.91-2.03-1.14Z"
              />
            </g>
            <g>
              <path
                class="cls-63"
                d="M719.98,484.51s1.39-1.65,2.27-1.23c.88.42-.18,2.83-1.22,3.15-1.04.32-1.41-.5-1.41-.5l.37-1.42Z"
              />
              <path
                class="cls-63"
                d="M721.92,483.97s.02.02,0,.02c-.73.24-1.12.82-1.4,1.41.22-.23.52-.35.88-.13.02.01,0,.04-.02.03-.3-.06-.51-.02-.72.19-.14.14-.25.33-.35.49-.03.06-.15.02-.13-.04,0,0,0,0,0-.01,0-.79.73-1.9,1.73-1.97Z"
              />
            </g>
            <g>
              <path
                class="cls-79"
                d="M718.56,488.44c1.02-.36,2.05-.79,2.74-1.59.48-.56.88-1.19,1.03-1.94-.1.27-.23.55-.41.8-.19.26-.42.5-.69.68t0,0c-.56.79-1.57,1.53-2.71,1.9-.1.04-.06.18.04.15Z"
              />
              <path
                class="cls-79"
                d="M719.72,485.14c.19-.19.77-1.17,1.29-1.53,0,0,0,0,0,0,.08-.06.16-.13.25-.18.15-.1.31-.17.47-.2-.13-.05-.27-.07-.44-.04-.78.11-1.34,1.42-1.63,1.91-.02.03.03.08.07.05Z"
              />
              <path
                class="cls-79"
                d="M719.9,484.92c.11-.24-1.61.52-3.41.15-.83-.17-1.88-1.25-2.17-1.17-.27.08-.82.6-1.1,1.5-.13.42-.18,1.97.48,3.04.22.35,2.01,1.09,2.59,1.16,1.38.18,2.28-.69,2.65-1.16.3-.38-.14-1.21.95-3.53Z"
              />
              <g>
                <path
                  class="cls-82"
                  d="M713.78,484.48c.24-.01.49,0,.73.08.22.11.39.25.59.38.19.13.37.27.57.39.2.12.39.23.63.26.47.08.96.07,1.44.04.48-.03.97-.08,1.45-.15-.47.11-.95.18-1.44.23-.49.04-.98.06-1.47-.03-.25-.04-.47-.16-.67-.28-.2-.12-.38-.26-.57-.4-.18-.13-.36-.29-.56-.39-.22-.09-.46-.12-.71-.12Z"
                />
                <path
                  class="cls-82"
                  d="M713.82,488.08c.38.21.78.4,1.18.58.41.17.82.33,1.26.39.43.08.89,0,1.3-.15.41-.16.79-.38,1.11-.65-.29.3-.66.54-1.08.71-.41.16-.89.25-1.35.18-.46-.07-.88-.24-1.28-.42-.4-.19-.78-.4-1.14-.64Z"
                />
                <path
                  class="cls-82"
                  d="M713.46,486.51c.4.21.82.38,1.24.54.43.15.87.28,1.33.33.45.06.92.03,1.38-.03.45-.07.91-.18,1.34-.33-.83.36-1.78.56-2.73.45-.47-.06-.92-.19-1.34-.36-.43-.17-.83-.37-1.21-.6Z"
                />
                <path
                  class="cls-82"
                  d="M713.61,485.48c.38.23.78.45,1.18.64.41.19.83.37,1.29.42.46.04.93,0,1.39-.05.46-.05.92-.12,1.38-.2-.45.11-.91.21-1.37.27-.46.06-.94.11-1.41.07-.48-.06-.91-.24-1.32-.45-.41-.21-.79-.44-1.14-.7Z"
                />
                <path
                  class="cls-82"
                  d="M713.67,487.38c.37.21.77.4,1.18.55.41.15.84.28,1.27.32.44.06.88,0,1.31-.1.43-.11.84-.26,1.24-.44-.38.21-.78.38-1.22.51-.43.12-.9.18-1.35.12-.91-.12-1.73-.49-2.44-.97Z"
                />
              </g>
            </g>
            <path
              class="cls-84"
              d="M736.52,520.35c-.06.06-26.73.5-26.98.27-.35-.32,3.12-22.88,8.23-27.22,1.26-1.07,4.58-3.34,5.8-2.46,4.78,3.46,6.16,7.43,7.35,9.95.88,1.86,1.95,5.04,2.91,8.3,1.59,5.37,2.91,10.94,2.69,11.16Z"
            />
            <path
              class="cls-65"
              d="M734.64,511.65c-.27-1.09-.56-2.18-.87-3.27-.59-2.08-1.29-4.13-2.04-6.17.03-.83-.12-1.65-.39-2.46-.01-.04-.08-.02-.07.01.14.64.22,1.29.27,1.94-.43-1.14-.92-2.27-1.42-3.39-.03-.06-.14-.04-.12.03,1.5,4.31,2.94,8.63,4.17,13,.35,1.23.73,2.45,1.08,3.67.01.04.07.02.06-.01-.21-1.12-.4-2.24-.68-3.35Z"
            />
            <path
              class="cls-63"
              d="M723.34,493.95c5.16,7.64,7.19,17.42,6.61,19.55-.64,2.34-6.15,10.01-10.44,13.31-.55.42-3.1-.25-5.05-1.67-2.05-1.5-3.49-3.79-2.89-4.29,2.24-1.87,8.35-9.59,8.63-10.92.26-1.23-1.25-9.28-1.47-13.83-.21-4.37,2.21-5.71,4.61-2.15Z"
            />
            <path
              class="cls-71"
              d="M723.75,526.89l-11.25-7.44s7.2-8.51,7.46-9.52c.25-1.01-1.07-9.52-1.4-13.41-.33-3.88,1.96-7.73,5.97-1.23,4,6.49,5.85,15.37,5.85,17.65s-6.62,13.95-6.62,13.95Z"
            />
            <path
              class="cls-78"
              d="M710.43,520.14s1.04,7.44,9.31,7.54"
            />
            <path
              class="cls-65"
              d="M712.78,519.49c-.07,0-.15-.03-.2-.09-.09-.11-.07-.27.04-.35.08-.06,7.65-6.09,7.3-10.23-.37-4.27-1.08-9.18-1.09-9.23-.02-.14.07-.26.21-.28.13-.03.26.07.28.21,0,.05.72,4.98,1.09,9.26.38,4.41-7.17,10.41-7.49,10.67-.05.04-.1.05-.15.05Z"
            />
            <path
              class="cls-65"
              d="M726.9,520.49s-.08,0-.12-.03c-.12-.06-.17-.21-.1-.34.03-.06,3.31-6.32,3.27-8.57-.04-2.27-3.09-10.58-3.12-10.67-.05-.13.02-.27.15-.32.13-.05.27.02.32.15.13.35,3.12,8.47,3.16,10.83.04,2.38-3.19,8.55-3.33,8.81-.04.08-.13.13-.22.13Z"
            />
            <line
              class="cls-13"
              x1="730.01"
              y1="498.35"
              x2="735.32"
              y2="515"
            />
            <path
              class="cls-65"
              d="M705.61,584.64c-.13,0-.25-.11-.25-.24,0-.26-.74-26.14,1.33-35.97,2.06-9.82,6.15-20.73,6.19-20.84.05-.13.19-.2.32-.15.13.05.19.19.15.32-.04.11-4.11,10.99-6.16,20.77-2.05,9.77-1.32,35.59-1.32,35.85,0,.14-.1.25-.24.26h0Z"
            />
            <path
              class="cls-65"
              d="M721.87,530.14c-.14,0-.25-.11-.25-.25,0-.14.11-.25.24-.25,1.99-.04,9.47-3.92,9.55-3.96.12-.06.27-.02.34.11.06.12.02.27-.11.34-.31.16-7.67,3.97-9.77,4.01h0Z"
            />
          </g>
        </g>
        <path
          class="cls-49"
          d="M668.02,455.45v-1.21h-.82v-7.74h-.27v7.74h-.82v1.21c-1.75,1.06-2.8,4.88-2.94,7.4h7.77c-.13-2.53-1.18-6.35-2.94-7.4Z"
        />
        <path
          class="cls-49"
          d="M709.02,455.45v-1.21h-.82v-7.74h-.27v7.74h-.82v1.21c-1.75,1.06-2.8,4.88-2.94,7.4h7.77c-.13-2.53-1.18-6.35-2.94-7.4Z"
        />
      </g>
      <g
        id="fnetre_gauche_droite"
        data-name="fnetre gauche droite"
      >
        <rect
          class="cls-9"
          x="713.29"
          y="292.3"
          width="70.71"
          height="110.96"
          rx=".35"
          ry=".35"
        />
        <rect
          class="cls-7"
          x="713.29"
          y="286.3"
          width="70.71"
          height="122.96"
          rx=".35"
          ry=".35"
        />
        <g>
          <path
            class="cls-38"
            d="M740.19,296.03v-1.31h-1.03v-8.46h-.34v8.46h-1.03v1.32c-2.21,1.16-3.53,5.34-3.7,8.11h9.79c-.17-2.77-1.49-6.95-3.7-8.11Z"
          />
          <path
            class="cls-38"
            d="M759.3,296.03v-1.31h-1.03v-8.46h-.34v8.46h-1.03v1.32c-2.21,1.16-3.53,5.34-3.7,8.11h9.79c-.17-2.77-1.49-6.95-3.7-8.11Z"
          />
        </g>
        <g>
          <rect
            class="cls-5"
            x="747.9"
            y="309.53"
            width="30.1"
            height="34.3"
          />
          <rect
            class="cls-19"
            x="766.08"
            y="331.94"
            width="8.98"
            height="8.98"
          />
          <path
            class="cls-58"
            d="M747.9,329.47c1.97-1.6,3.95-3.19,5.93-4.77l2.97-2.38.37-.3c.12-.1.27-.2.4-.29.27-.17.56-.33.84-.48.57-.3,1.14-.57,1.73-.83,1.17-.52,2.35-.99,3.57-1.39.61-.19,1.22-.38,1.89-.47.17-.02.34-.03.55,0,.05.01.11.03.17.05.05.03.1.06.15.1.09.08.17.19.2.31.07.23.03.43-.02.61-.05.18-.12.34-.21.49-.34.6-.79,1.08-1.26,1.52-.48.44-.99.84-1.52,1.21-1.06.73-.59-.18.98-.83.79-.32,1.58-.62,2.4-.88.41-.13.82-.24,1.25-.34.43-.09.86-.16,1.32-.16.23,0,.47.03.72.11.25.09.52.25.66.58.07.16.07.34.04.48-.03.15-.08.27-.14.39-.12.23-.26.41-.42.58-.61.66-1.31,1.16-2.02,1.64-1.42.95-1.54.88.09.49.81-.19,1.63-.36,2.48-.44.42-.04.86-.06,1.31,0,.23.03.46.07.7.18.24.1.5.3.62.62.06.16.06.35.02.5-.04.15-.1.28-.17.39-.14.22-.31.38-.48.53-.34.29-.7.52-1.06.74-.73.43-1.48.79-2.25,1.12-1.53.67-1.26.32.56.06.91-.12,1.83-.23,2.77-.21.24,0,.48.02.72.07.25.05.51.1.78.3.07.05.13.12.19.2.06.08.08.14.11.22.06.15.07.33.04.49-.05.33-.23.56-.4.75-.36.38-.77.63-1.17.87-.41.23-.83.43-1.26.61-.85.36-1.72.67-2.59.95-1.75.56-3.52,1.01-5.31,1.4l-.03-.52c1.4.14,2.78.35,4.14.73.34.1.68.21,1.01.35.33.14.66.31.95.57.14.13.28.3.35.53.07.22.03.48-.09.66-.11.19-.26.32-.42.43-.15.11-.32.2-.48.28-.66.31-1.34.48-2.03.63-.69.15-1.38.25-2.07.33-1.39.16-2.78.23-4.17.22l.07-.03-3.31,2.69-3.32,2.68,3.23-2.78,3.24-2.77.03-.03h.04c1.38-.02,2.76-.13,4.13-.32.68-.1,1.36-.21,2.03-.36.67-.15,1.33-.34,1.93-.63.29-.14.58-.33.71-.56.13-.22.04-.46-.19-.66-.23-.2-.53-.35-.83-.48-.31-.13-.63-.23-.96-.32-1.32-.35-2.69-.53-4.06-.65l-1.64-.14,1.61-.38c1.76-.41,3.52-.9,5.23-1.46.86-.28,1.71-.59,2.53-.94.41-.18.81-.37,1.2-.59.38-.22.75-.46,1.02-.75.13-.14.23-.3.24-.43,0-.06,0-.12-.02-.18-.01-.03-.03-.07-.04-.08,0-.01-.02-.03-.05-.05-.1-.08-.3-.14-.49-.17-.2-.03-.42-.05-.63-.05-.87-.02-1.78.09-2.67.21-1.78.26-4.03.33-5.78.76,0,0,3.37-1.44,4.86-2.09.74-.33,1.48-.68,2.17-1.09.34-.21.68-.42.96-.67.14-.12.27-.25.35-.38.08-.13.1-.23.08-.28-.02-.07-.11-.16-.24-.22-.14-.06-.31-.1-.49-.12-.37-.04-.76-.03-1.16,0-.79.07-1.59.23-2.38.41-1.58.37-5.12.97-5.12.97,1.49-.75,3.13-1.75,4.52-2.67.69-.46,1.37-.95,1.91-1.53.13-.14.25-.3.33-.44.04-.07.07-.15.08-.2.01-.06,0-.1,0-.14-.03-.07-.13-.16-.28-.21-.15-.05-.33-.07-.52-.08-.38,0-.79.06-1.18.14-.4.08-.8.19-1.19.32-.79.24-1.58.54-2.35.85-1.55.63-3.05.9-4.55,1.66,0,0,2-1.15,3.03-1.84.52-.35,1.01-.72,1.47-1.14.45-.42.88-.87,1.18-1.38.07-.13.13-.26.17-.38.04-.13.05-.25.02-.33-.01-.04-.03-.06-.05-.09-.01-.01-.03-.02-.05-.03-.01,0-.03-.01-.06-.02-.11-.02-.26-.02-.4,0-.59.06-1.21.24-1.8.42-1.2.37-2.38.83-3.54,1.32-.58.25-1.16.51-1.72.79-.28.14-.56.29-.82.45-.14.08-.25.16-.38.26l-.38.29-3.03,2.31c-2.02,1.54-4.04,3.07-6.07,4.6Z"
          />
          <rect
            class="cls-18"
            x="751.92"
            y="309.53"
            width="7.97"
            height="20.8"
          />
        </g>
        <g>
          <g class="cls-98">
            <g>
              <rect
                class="cls-24"
                x="671"
                y="274.31"
                width="225"
                height="221.98"
              />
              <g>
                <line
                  class="cls-3"
                  x1="671.5"
                  y1="274.31"
                  x2="671.5"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="678.73"
                  y1="274.31"
                  x2="678.73"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="685.95"
                  y1="274.31"
                  x2="685.95"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="693.18"
                  y1="274.31"
                  x2="693.18"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="700.4"
                  y1="274.31"
                  x2="700.4"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="707.63"
                  y1="274.31"
                  x2="707.63"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="714.85"
                  y1="274.31"
                  x2="714.85"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="722.08"
                  y1="274.31"
                  x2="722.08"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="729.31"
                  y1="274.31"
                  x2="729.31"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="736.53"
                  y1="274.31"
                  x2="736.53"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="743.76"
                  y1="274.31"
                  x2="743.76"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="750.98"
                  y1="274.31"
                  x2="750.98"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="758.21"
                  y1="274.31"
                  x2="758.21"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="765.44"
                  y1="274.31"
                  x2="765.44"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="772.66"
                  y1="274.31"
                  x2="772.66"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="779.89"
                  y1="274.31"
                  x2="779.89"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="787.11"
                  y1="274.31"
                  x2="787.11"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="794.34"
                  y1="274.31"
                  x2="794.34"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="801.56"
                  y1="274.31"
                  x2="801.56"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="808.79"
                  y1="274.31"
                  x2="808.79"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="816.02"
                  y1="274.31"
                  x2="816.02"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="823.24"
                  y1="274.31"
                  x2="823.24"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="830.47"
                  y1="274.31"
                  x2="830.47"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="837.69"
                  y1="274.31"
                  x2="837.69"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="844.92"
                  y1="274.31"
                  x2="844.92"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="852.15"
                  y1="274.31"
                  x2="852.15"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="859.37"
                  y1="274.31"
                  x2="859.37"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="866.6"
                  y1="274.31"
                  x2="866.6"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="873.82"
                  y1="274.31"
                  x2="873.82"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="881.05"
                  y1="274.31"
                  x2="881.05"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="888.27"
                  y1="274.31"
                  x2="888.27"
                  y2="496.29"
                />
                <line
                  class="cls-3"
                  x1="895.5"
                  y1="274.31"
                  x2="895.5"
                  y2="496.29"
                />
              </g>
            </g>
          </g>
          <path
            fill="#D6D5D2"
            d="M713.15,403.14h-11.3c-.47,0-.85-.38-.85-.85v-109.3c0-.47.38-.85.85-.85h11.3c.47,0,.85.38.85.85v109.3c0,.47-.38.85-.85.85ZM702,402.14h11v-109h-11v109Z"
          />
        </g>
        <g>
          <g class="cls-97">
            <g>
              <rect
                class="cls-24"
                x="754"
                y="274.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="754.5"
                  y1="274.14"
                  x2="754.5"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="761.73"
                  y1="274.14"
                  x2="761.73"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="768.95"
                  y1="274.14"
                  x2="768.95"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="776.18"
                  y1="274.14"
                  x2="776.18"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="783.4"
                  y1="274.14"
                  x2="783.4"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="790.63"
                  y1="274.14"
                  x2="790.63"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="797.85"
                  y1="274.14"
                  x2="797.85"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="805.08"
                  y1="274.14"
                  x2="805.08"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="812.31"
                  y1="274.14"
                  x2="812.31"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="819.53"
                  y1="274.14"
                  x2="819.53"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="826.76"
                  y1="274.14"
                  x2="826.76"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="833.98"
                  y1="274.14"
                  x2="833.98"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="841.21"
                  y1="274.14"
                  x2="841.21"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="848.44"
                  y1="274.14"
                  x2="848.44"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="855.66"
                  y1="274.14"
                  x2="855.66"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="862.89"
                  y1="274.14"
                  x2="862.89"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="870.11"
                  y1="274.14"
                  x2="870.11"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="877.34"
                  y1="274.14"
                  x2="877.34"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="884.56"
                  y1="274.14"
                  x2="884.56"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="891.79"
                  y1="274.14"
                  x2="891.79"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="899.02"
                  y1="274.14"
                  x2="899.02"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="906.24"
                  y1="274.14"
                  x2="906.24"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="913.47"
                  y1="274.14"
                  x2="913.47"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="920.69"
                  y1="274.14"
                  x2="920.69"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="927.92"
                  y1="274.14"
                  x2="927.92"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="935.15"
                  y1="274.14"
                  x2="935.15"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="942.37"
                  y1="274.14"
                  x2="942.37"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="949.6"
                  y1="274.14"
                  x2="949.6"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="956.82"
                  y1="274.14"
                  x2="956.82"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="964.05"
                  y1="274.14"
                  x2="964.05"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="971.27"
                  y1="274.14"
                  x2="971.27"
                  y2="498.14"
                />
                <line
                  class="cls-6"
                  x1="978.5"
                  y1="274.14"
                  x2="978.5"
                  y2="498.14"
                />
              </g>
            </g>
          </g>
          <path
            fill="#D6D5D2"
            d="M796.15,404.14h-11.3c-.47,0-.85-.38-.85-.85v-110.3c0-.47.38-.85.85-.85h11.3c.47,0,.85.38.85.85v110.3c0,.47-.38.85-.85.85ZM785,403.14h11v-110h-11v110Z"
          />
        </g>
        <g class="cls-95">
          <g>
            <path
              class="cls-55"
              d="M721.42,347.94c.55,1.14.92,2.39.85,3.65-.06,1.26-.6,2.53-1.6,3.31-.19.15-.42.28-.66.25-.24-.03-.46-.3-.34-.52-.21.37-.49.69-.83.95-.11.08-.24.17-.38.15-.2-.02-.33-.24-.33-.44,0-.2.1-.39.19-.57-.25-.01-.46.16-.68.27s-.54.15-.67-.06c-.12-.19,0-.43.12-.61.54-.85,1.09-1.74,1.18-2.74.06-.71-.11-1.44.04-2.14.18-.85.86-1.58,1.71-1.81.48-.13,1.07-.08,1.39.31"
            />
            <g>
              <g>
                <path
                  class="cls-30"
                  d="M726.74,353.54c.48-.66,1.41-.88,1.79-1.6.68-1.27.59-2.45.54-3.88-.03-.99.06-2.39-.54-3.16-.43-.55-.73-.88-1.11-1.46-.42-.64-.85-1.39-.45-2.04"
                />
                <path
                  class="cls-30"
                  d="M726.55,353.56c.28-.29.69-.46,1.09-.44.2,0,.41.07.59.16l-1.25-12.05c.55-.07,1.83.66,2.19,1.08s.58.93.79,1.44c.86,2.09,1.33,4.19.38,6.09l.05.89c.08,1.35-.47,2.65-1.43,3.6,0,0-.01,0-.02.01-.04.04-.09.09-.14.14-.31.31-.45.75-.38,1.18,0,0,0,.01,0,.02.02.13.05.25.03.38-.02.13-.09.25-.2.3-.19.07-.39-.1-.48-.29-.09-.19-.12-.4-.25-.56-.15.2-.19.47-.31.68-.12.22-.42.39-.62.24-.09-.06-.13-.16-.17-.26-.18-.43-.32-.88-.33-1.35,0-.46.13-.95.45-1.28Z"
                />
              </g>
              <path
                class="cls-75"
                d="M720.03,346.44l.39,10.46c.07,1.78,1.61,3.14,3.38,2.99h0c1.66-.14,2.81-1.54,2.75-3.2-.03-.79-.01-1.72-.01-1.8,0,0,2.62-.59,2.72-3.23.05-1.28.02-3.42-.12-5.81-.15-2.56-2.24-4.58-4.8-4.64h-.26c-2.75.09-4.21,2.48-4.04,5.23Z"
              />
              <path
                class="cls-17"
                d="M726.55,354.9s-1.67.1-3.42-1.06c0,0,.77,1.92,3.41,1.75v-.69Z"
              />
              <path
                class="cls-61"
                d="M727.98,348.03c0,.31-.2.56-.46.57-.26,0-.47-.23-.47-.54,0-.31.2-.56.46-.57.26,0,.47.23.47.54Z"
              />
              <path
                class="cls-61"
                d="M724.35,348.01c0,.31-.2.56-.46.57-.26,0-.47-.23-.47-.54,0-.31.2-.56.46-.57.26,0,.47.23.47.54Z"
              />
              <path
                class="cls-61"
                d="M725.94,350.16s.25-.06.66-.1c.1,0,.2-.03.22-.1.03-.07-.01-.19-.06-.31-.09-.25-.19-.52-.29-.8-.4-1.13-.69-2.07-.64-2.08.05-.02.41.89.81,2.03.1.28.19.55.28.8.04.12.1.25.04.41-.03.08-.11.13-.17.15-.07.02-.13.02-.18.02-.41.01-.67,0-.67-.01Z"
              />
              <path
                class="cls-61"
                d="M724.74,350.42c.07,0,.06.44.43.76.37.32.84.28.84.35,0,.03-.11.08-.31.08-.19,0-.48-.07-.7-.26-.23-.2-.32-.46-.33-.64-.01-.18.04-.29.07-.29Z"
              />
              <path
                class="cls-61"
                d="M724.49,345.82c-.04.11-.45.05-.93.09-.48.04-.87.17-.93.07-.03-.05.04-.15.2-.25.16-.1.4-.2.69-.22.29-.02.55.03.72.1.17.07.26.16.24.22Z"
              />
              <path
                class="cls-61"
                d="M728.41,345.95c-.07.09-.35-.01-.69-.02-.34-.02-.62.05-.69-.05-.03-.05.02-.14.15-.22.12-.08.33-.15.56-.14.23.01.43.1.54.2.12.1.15.19.12.24Z"
              />
              <path
                class="cls-30"
                d="M716.14,350.15c.08-.51.13-1.01.19-1.52.09-.89,1.97-4.08,1.97-4.08.6-1.26,1.3-2.48,2.31-3.43s2.36-1.58,3.72-1.47c1.37.11,2.69,1.08,3,2.44l-.23-.34c.05.48-.46.85-.94.88-.47.04-.94-.13-1.42-.15-.93-.03-1.8.55-2.33,1.32-.53.77-.76,1.72-.88,2.66-.12.94-.13,1.89-.27,2.82-.15,1-.71,1.35-1.47,2.01-.7.61-1.4,1.37-1.96,2.1-.2.27-.74.51-1.04.44-.3-.07-.38-.51-.42-.82-.04-.34.17-.68.19-1.14-.29-.13-.46-.45-.5-.77-.04-.32.02-.64.07-.96Z"
              />
              <g>
                <path
                  class="cls-75"
                  d="M720.43,348.99s-1.8-.58-1.79,1.23c.02,1.81,1.83,1.42,1.83,1.37,0-.05-.04-2.6-.04-2.6Z"
                />
                <path
                  class="cls-17"
                  d="M719.92,350.91s-.03.02-.08.05c-.05.02-.14.04-.24,0-.19-.07-.36-.37-.37-.7,0-.16.03-.32.08-.45.05-.13.14-.23.24-.24.1-.02.16.03.19.08.02.05.01.09.02.09,0,0,.04-.03.02-.11,0-.04-.03-.08-.07-.11-.04-.03-.11-.05-.17-.04-.14.01-.26.14-.33.28-.07.14-.11.32-.1.51.01.36.2.7.47.78.13.03.23,0,.29-.05.06-.05.06-.09.06-.09Z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  class="cls-75"
                  d="M730.58,364.51s9.31-8.22,10.18-8.69c1.6-.83,5.9-11.58,5.9-11.58l-4.63-1.3-4.5,9.1-10.14,6.35,3.19,6.12Z"
                />
                <path
                  class="cls-75"
                  d="M742.92,344.23s-1.14-.55-1.33-1.22c-.2-.67-.03-4.65-.03-4.65,0,0,.86-.11,1.25.66.28.57.52,1.84.52,1.84,0,0,1.25-2.22,1.69-2.98.4-.67,1.08-1.66,1.71-1.65.63.01-.15,1.3-.29,1.87-.14.57-.37,1.38-.37,1.38-.04.04,1.75-2.6,2.58-3.24.61-.47,1.47,0,.94.59,0,0,.95-.48,1,.06.04.54-1.89,3.08-1.59,3.11.29.03,2.07-1.99,2.66-2.06.34-.04.46.23.03.75-.43.52-3.51,4.46-4.1,4.96-.57.5-1.03.6-1.03.6h-3.64Z"
                />
                <path
                  class="cls-17"
                  d="M746.9,341.92s-.28-.02-.73.06c-.45.08-1.05.24-1.63.54l.18.04s0-.03-.01-.05c-.14-.45-.42-.81-.67-1.05-.26-.24-.47-.36-.49-.35-.06.03.68.58.94,1.44,0,.02,0,.03.01.04l.03.11.14-.07c1.11-.56,2.25-.67,2.23-.71Z"
                />
                <path
                  class="cls-17"
                  d="M749.67,336.73c-.06-.01-.69.69-1.4,1.58-.7.89-1.08,1.66-1.01,1.66.06,0,.54-.72,1.24-1.61.71-.89,1.25-1.62,1.18-1.64Z"
                />
              </g>
              <path
                class="cls-39"
                d="M724.67,359.31l11.73-6.94s-.05-.45.35-.68c.4-.23.6.1.6.1l4.51,2.17c.41.21.44.72.08,1.09-.98,1.04-2.68,2.93-3.51,3.58-.78.65-8.41,7.5-8.41,7.5l-5.35-6.82Z"
              />
              <path
                class="cls-61"
                d="M752.81,342.96s.09-.06.21-.17c.13-.11.3-.29.49-.5.39-.43.84-1.05,1.13-1.75.29-.7.35-1.33.3-1.78-.02-.22-.06-.4-.11-.52-.04-.12-.07-.18-.09-.18-.04,0,.03.28.03.72,0,.44-.07,1.07-.35,1.75-.28.69-.7,1.3-1.05,1.73-.34.43-.6.69-.57.7Z"
              />
              <path
                class="cls-61"
                d="M756.04,341.24s.08-.06.18-.19c.11-.12.24-.3.39-.53.3-.45.61-1.09.74-1.79.12-.7.02-1.31-.13-1.74-.08-.21-.16-.38-.24-.49-.07-.11-.12-.17-.14-.17-.04,0,.09.27.21.7.12.43.19,1.04.07,1.72-.12.69-.4,1.31-.66,1.76-.25.45-.45.72-.42.73Z"
              />
              <path
                class="cls-61"
                d="M738.84,341.97s.06-.28.15-.72c.09-.44.25-1.05.54-1.71.29-.66.65-1.23.95-1.64.3-.41.51-.66.48-.67-.02,0-.28.23-.62.63-.33.4-.72.98-1.01,1.65-.29.67-.43,1.29-.48,1.74-.05.45-.03.73,0,.73Z"
              />
              <path
                class="cls-61"
                d="M736.44,342.48s.01-.35.07-.92c.06-.57.23-1.34.62-2.17.41-.82.98-1.52,1.45-2,.48-.48.84-.76.81-.77-.01,0-.11.06-.28.18-.17.12-.4.31-.66.54-.51.47-1.11,1.18-1.52,2.01-.4.83-.54,1.63-.56,2.2-.01.29,0,.52.02.68.02.16.04.25.05.25Z"
              />
            </g>
            <path
              class="cls-33"
              d="M721.03,370.01l3.3,15.75-6.69-.08-2.83-13.97-5.93-.07c-.49,0-.88-.41-.87-.89h0c0-.49.41-.88.89-.87l12.13.14Z"
            />
            <g>
              <path
                class="cls-61"
                d="M737.02,380.19s19.59.33,21.34.25c3.72-.17,5.17,2.39,5.67,6.02.16,1.11,2.96,25.48,2.96,25.48l-6.78,1.43-4.6-22.16s-18.1.66-19.81.96c-2.08.36-4.96,1.49-6.52.25-1.57-1.24-2.52-7.61-2.52-7.61l10.27-4.62Z"
              />
              <path
                class="cls-61"
                d="M735.5,380.19s17.55.29,19.31.21c3.72-.17,5.17,2.39,5.67,6.02.16,1.11,2.96,26.22,2.96,26.22l-6.61,1.5-4.77-22.97s-18.1.66-19.81.96c-2.08.36-4.96,1.49-6.52.25-1.57-1.24-2.52-7.61-2.52-7.61l12.3-4.59Z"
              />
            </g>
            <g>
              <path
                class="cls-39"
                d="M728.46,358.2l-8.07-2.12s-3.16,1.95-3.46,2.32c-.31.38-1.43,1.81-1.39,4.5.02,1.68,1.47,7.74,1.47,7.74l5.38,9.44,1.66,4.65,8.04.02,3.15-4.56s.4-.95-.65-2.4-2.69-3.92-2.69-3.92c0,0-.48-2.95-1-4.04-.52-1.09-.4-1.54-.4-1.54,0,0,.51-3.01,0-4.42-.52-1.41-2.02-5.67-2.02-5.67Z"
              />
              <path
                class="cls-39"
                d="M719.85,357.33c-1.94-.22-3.16.99-4.32,2.57-2.28,3.11-4.43,8.96-4.66,9.61-.32.92-.65,1.12-.76,1.57-.21.86-.13,2.17-.03,3.1.07.63.61,1.1,1.24,1.07l4.67.05c.55,0,1-.45.98-1l-.07-2.43s2.67-2.19,3.3-3.72c.63-1.53,2.92-2.94,2.92-2.94,0,0,1.81-2.79.54-5.1-.4-.72-3.12-2.71-3.82-2.79Z"
              />
              <path
                class="cls-16"
                d="M721.96,365.97s-.08.07-.2.22c-.14.17-.31.37-.52.62-.43.52-1.02,1.26-1.67,2.07-.65.81-1.2,1.57-1.69,2.04-.48.48-.87.66-.86.68,0,0,.1-.03.27-.13.17-.1.4-.25.65-.49.51-.46,1.08-1.22,1.73-2.02.65-.81,1.23-1.55,1.64-2.09.19-.25.35-.47.49-.64.11-.15.17-.24.16-.25Z"
              />
              <path
                class="cls-16"
                d="M713.5,370.41s.23,0,.58.01c.36.02.85.11,1.34.34.49.23.88.55,1.12.82.24.26.36.46.38.44.01,0-.08-.22-.31-.5-.23-.29-.62-.63-1.13-.87-.51-.24-1.03-.32-1.4-.32-.37,0-.59.07-.59.08Z"
              />
              <path
                class="cls-16"
                d="M715.83,368.12s.58.69.88,1.74c.31,1.05.15,1.94.19,1.94.01,0,.07-.21.1-.58.02-.36-.01-.87-.17-1.4-.16-.53-.4-.98-.62-1.27-.21-.29-.38-.44-.39-.43Z"
              />
              <path
                class="cls-16"
                d="M731.88,373.87s0-.06-.02-.16c-.01-.1-.04-.26-.07-.45-.07-.39-.17-.96-.34-1.65-.17-.69-.41-1.5-.75-2.38-.18-.43-.24-.91-.21-1.42.02-.5.1-1.03.13-1.57.1-2.18-.33-4.13-.79-5.47-.23-.67-.46-1.2-.63-1.56-.08-.18-.16-.31-.21-.41-.05-.09-.08-.14-.08-.14,0,0,.02.05.06.15.04.1.11.23.19.42.16.36.38.89.59,1.57.44,1.34.84,3.28.75,5.44-.03.54-.11,1.06-.13,1.57-.02.51.04,1.03.23,1.46.34.87.59,1.68.77,2.36.18.68.29,1.25.38,1.63.04.18.07.33.09.45.02.1.04.16.04.15Z"
              />
            </g>
            <path
              class="cls-33"
              d="M717.58,383.56l.33,12.5,28.04.09c1.5,0,2.73-1.2,2.75-2.71h0c.02-1.49-1.16-2.72-2.65-2.77l-2.43-.08.13-5.33c.02-.78-.6-1.42-1.38-1.43l-24.8-.28Z"
            />
            <rect
              class="cls-33"
              x="727.97"
              y="392.67"
              width="1.64"
              height="16.51"
              transform="translate(4.58 -8.21) rotate(.65)"
            />
            <rect
              class="cls-33"
              x="727.89"
              y="407.86"
              width="23.29"
              height="1.38"
              transform="translate(4.66 -8.33) rotate(.65)"
            />
            <path
              class="cls-61"
              d="M729.9,418.58c-8.6-.1-15.51-7.17-15.41-15.77.05-4.16,1.71-8.06,4.69-10.97,2.98-2.91,6.9-4.49,11.08-4.44,8.6.1,15.51,7.17,15.41,15.77-.05,4.16-1.71,8.06-4.69,10.97-2.93,2.87-6.8,4.44-10.89,4.44-.06,0-.12,0-.18,0ZM719.35,392.02c-2.93,2.86-4.57,6.7-4.62,10.8-.05,4.1,1.51,7.97,4.37,10.9,2.86,2.93,6.7,4.57,10.8,4.62,4.1.05,7.97-1.51,10.9-4.37,2.93-2.87,4.57-6.7,4.62-10.8.1-8.46-6.71-15.42-15.17-15.52-.06,0-.12,0-.18,0-4.03,0-7.83,1.55-10.72,4.37Z"
            />
            <g>
              <g>
                <path
                  class="cls-42"
                  d="M737.88,403.22c-4.26-.05-7.7-.09-7.7-.1,0,0,3.45.04,7.7.09,4.25.05,7.7.09,7.7.1,0,0-3.45-.04-7.7-.09Z"
                />
                <path
                  class="cls-42"
                  d="M745.57,403.45v-.02c.09,0,.1-.01.11-.02l.04-.04v-.06c0-.09,0-.12-.15-.14h0s-.06,0-.15,0c-.11,0-.25,0-.45,0l-1.65-.02c-1.39-.02-3.32-.04-5.45-.07-4.19-.05-6.12-.07-7.01-.08-.42,0-.66,0-.68-.01v.02c-.09,0-.1.01-.11.02l-.04.04v.06c0,.09,0,.12.15.14h0s.06,0,.15,0c.11,0,.25,0,.45,0l1.65.02c1.39.02,3.32.04,5.45.07h0s0,0,0,0c4.19.05,6.12.07,7.01.08.42,0,.66,0,.68.01Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M737.76,404.49c-4.19-.74-7.59-1.34-7.59-1.35,0,0,3.4.59,7.59,1.33,4.19.74,7.59,1.34,7.58,1.35,0,0-3.4-.59-7.59-1.33Z"
                />
                <path
                  class="cls-42"
                  d="M745.31,405.97h0c.15,0,.16-.03.18-.12.01-.09.02-.12-.13-.17h0s-.06-.02-.16-.04c-.1-.02-.24-.05-.43-.08l-1.63-.29c-1.37-.24-3.27-.58-5.36-.95-2.1-.37-3.99-.7-5.37-.95l-1.63-.29c-.19-.03-.33-.06-.44-.07-.09-.02-.14-.03-.15-.03h0c-.15,0-.16.03-.18.12,0,.09-.01.12.13.17h0s.07.02.16.04c.1.02.24.05.43.08l1.63.29c1.37.24,3.27.58,5.37.95,2.09.37,3.99.7,5.36.95l1.63.29c.19.03.33.06.44.07.09.02.14.03.15.03Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M737.43,405.72c-4.01-1.42-7.26-2.57-7.26-2.57,0,0,3.25,1.14,7.27,2.56,4.01,1.42,7.26,2.57,7.26,2.57,0,0-3.25-1.14-7.26-2.56Z"
                />
                <path
                  class="cls-42"
                  d="M744.74,408.43c.06,0,.07-.03.1-.09.03-.09.04-.12-.1-.19h0s-.06-.03-.15-.06c-.1-.04-.23-.09-.41-.15l-1.56-.55c-1.31-.47-3.13-1.11-5.13-1.82-2.01-.71-3.82-1.35-5.14-1.81l-1.56-.55c-.18-.06-.32-.11-.42-.14-.09-.03-.14-.05-.15-.05h0c-.15-.03-.16,0-.19.08-.03.09-.04.12.1.19h0s.06.03.15.06c.1.04.23.09.41.15l1.56.55c1.31.47,3.13,1.11,5.14,1.82h0c2,.71,3.82,1.35,5.14,1.81l1.56.55c.18.06.32.11.42.14.09.03.14.05.15.05h0s.07,0,.09,0Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M736.91,406.89c-3.73-2.06-6.74-3.73-6.74-3.73,0,0,3.02,1.66,6.75,3.72,3.72,2.06,6.74,3.73,6.74,3.73,0,0-3.02-1.66-6.75-3.72Z"
                />
                <path
                  class="cls-42"
                  d="M743.69,410.76s.06-.03.09-.07c.04-.08.06-.12-.06-.2h0s-.06-.04-.15-.09c-.09-.05-.21-.12-.38-.21l-1.44-.8c-1.22-.68-2.91-1.61-4.77-2.63-3.52-1.95-5.22-2.88-6.05-3.33-.42-.24-.67-.37-.69-.39v.02c-.1-.04-.11-.04-.12-.03l-.13.04.03.13s0,.03.09.08v.02s.26.14.67.37c.81.46,2.51,1.39,6.06,3.35h0c1.86,1.03,3.55,1.96,4.77,2.63l1.45.8c.17.09.29.16.39.21.08.05.13.07.14.08h0c.05.01.09.02.11.02Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M736.2,407.95c-3.34-2.64-6.05-4.78-6.04-4.78,0,0,2.71,2.13,6.05,4.77,3.34,2.64,6.05,4.77,6.04,4.78,0,0-2.71-2.13-6.05-4.77Z"
                />
                <path
                  class="cls-42"
                  d="M742.28,412.88s.05-.02.09-.06c.05-.07.08-.1-.03-.21h0s-.05-.05-.13-.11c-.08-.07-.19-.15-.34-.27l-1.3-1.02c-1.09-.86-2.6-2.06-4.27-3.38-3.19-2.52-4.71-3.72-5.44-4.29-.37-.3-.59-.46-.6-.48h-.01c-.08-.04-.09-.04-.1-.03l-.14.02v.14s.02.03.09.09h-.01s.23.19.59.48c.72.58,2.24,1.78,5.45,4.31h0c1.67,1.32,3.18,2.51,4.28,3.37l1.3,1.02c.15.12.26.21.35.27.07.06.12.09.13.1h0c.06.03.09.04.12.04Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M735.33,408.89c-2.87-3.14-5.19-5.69-5.19-5.69s2.33,2.54,5.2,5.69c2.87,3.14,5.19,5.69,5.19,5.69,0,0-2.33-2.54-5.2-5.69Z"
                />
                <path
                  class="cls-42"
                  d="M740.67,414.73v-.14s.01-.03-.05-.1h.01s-.19-.22-.49-.55c-.61-.68-1.91-2.11-4.69-5.15-1.43-1.57-2.73-2.99-3.67-4.02l-1.11-1.22c-.13-.14-.23-.25-.3-.32-.06-.07-.1-.11-.11-.12h0c-.11-.1-.14-.07-.2-.02l-.05.04v.06s0,.03.05.1h-.01s.19.21.48.54c.61.67,1.91,2.1,4.71,5.17h0s0,0,0,0c2.77,3.03,4.07,4.46,4.69,5.13.31.34.48.53.5.55h.01c.07.05.08.05.09.05h.14Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M734.32,409.67c-2.32-3.57-4.2-6.46-4.2-6.46,0,0,1.89,2.89,4.21,6.46,2.32,3.57,4.2,6.46,4.2,6.46,0,0-1.89-2.89-4.2-6.45Z"
                />
                <path
                  class="cls-42"
                  d="M738.64,416.29l.03-.14s0-.03-.04-.11h.02s-.16-.26-.41-.64c-.5-.78-1.55-2.4-3.78-5.83-1.16-1.78-2.21-3.4-2.97-4.57l-.9-1.38c-.11-.16-.18-.28-.24-.37-.05-.08-.08-.12-.08-.13h0c-.09-.11-.12-.09-.19-.05-.07.05-.11.08-.04.21h0s.04.06.09.15c.05.09.13.21.23.36l.9,1.39c.76,1.17,1.81,2.78,2.97,4.57,2.21,3.4,3.27,5.02,3.78,5.8.26.39.41.63.42.65h.02c.06.07.07.07.09.07l.14.02Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M733.2,410.28c-1.71-3.9-3.09-7.06-3.09-7.06,0,0,1.39,3.16,3.1,7.06,1.71,3.9,3.09,7.06,3.08,7.06,0,0-1.39-3.16-3.09-7.05Z"
                />
                <path
                  class="cls-42"
                  d="M736.3,417.49l.06-.02c.08-.04.11-.05.06-.2h0s-.03-.06-.06-.15c-.04-.1-.1-.23-.17-.4l-.66-1.51c-.56-1.28-1.33-3.04-2.18-4.99-1.67-3.8-2.44-5.57-2.81-6.4-.17-.4-.27-.63-.28-.65h-.02c-.04-.07-.05-.08-.07-.08l-.06-.02-.06.02c-.08.04-.11.05-.06.2h0s.03.06.07.15c.04.1.1.23.17.4l.66,1.51c.56,1.28,1.33,3.04,2.18,4.99h0c1.66,3.79,2.43,5.56,2.81,6.39.18.4.28.64.29.66h.02c.04.07.05.08.07.08l.06.02Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M731.99,410.69c-1.04-4.13-1.89-7.47-1.88-7.47,0,0,.85,3.34,1.89,7.47,1.04,4.12,1.89,7.47,1.88,7.47,0,0-.85-3.34-1.89-7.47Z"
                />
                <path
                  class="cls-42"
                  d="M733.94,418.35l.07-.12s.01-.02,0-.12h.02s-.07-.29-.19-.74c-.22-.9-.69-2.78-1.69-6.73-.52-2.06-.99-3.93-1.34-5.28l-.41-1.6c-.05-.19-.08-.32-.11-.43-.02-.09-.04-.14-.04-.15h0c-.05-.14-.08-.13-.17-.11-.09.03-.12.04-.1.18h0s.02.07.04.17c.02.1.06.24.1.42l.4,1.6c.34,1.35.81,3.22,1.33,5.28,1,3.95,1.47,5.83,1.71,6.73.11.45.18.71.18.73h.02c.03.09.04.09.05.1l.12.07Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M730.73,410.9c-.35-4.24-.64-7.68-.64-7.68,0,0,.29,3.44.65,7.68.35,4.24.64,7.68.64,7.68,0,0-.29-3.44-.65-7.68Z"
                />
                <path
                  class="cls-42"
                  d="M731.39,418.78l.1-.1s.02-.02.02-.12h.02s-.03-.31-.07-.78c-.07-.93-.23-2.86-.57-6.89-.34-4.1-.5-6.03-.59-6.94-.04-.44-.06-.7-.06-.73h-.02c-.01-.09-.02-.1-.04-.11l-.05-.04h-.06c-.09.01-.12.02-.12.17h0s0,.07.01.16c0,.11.02.25.03.44l.14,1.65c.12,1.39.28,3.31.45,5.43h.01s-.01,0-.01,0c.35,4.13.51,6.06.59,6.96.04.43.06.69.06.71h.02c.01.09.02.1.04.11l.11.09Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M729.45,410.9c.33-4.24.61-7.68.61-7.68s-.26,3.44-.6,7.68c-.33,4.24-.6,7.68-.61,7.68,0,0,.26-3.44.6-7.68Z"
                />
                <path
                  class="cls-42"
                  d="M728.9,418.74l.05-.04s.02-.02.04-.11h.02s.02-.26.05-.67c.08-.89.23-2.81.56-7,.32-4.1.47-6.03.54-6.95.04-.44.06-.7.06-.73h-.02c0-.1,0-.11-.02-.12l-.1-.1-.11.09s-.02.02-.04.11h-.02s-.02.26-.05.67c-.08.89-.23,2.81-.56,7h0c-.17,2.12-.32,4.04-.42,5.43l-.13,1.65c-.01.19-.03.34-.03.44,0,.09-.01.14-.01.15h0c0,.15.04.16.12.17h.06Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M728.19,410.7c1.02-4.13,1.85-7.48,1.85-7.48,0,0-.82,3.35-1.84,7.48-1.02,4.13-1.85,7.48-1.85,7.48,0,0,.82-3.35,1.84-7.48Z"
                />
                <path
                  class="cls-42"
                  d="M726.3,418.38l.12-.07s.02-.01.05-.1h.02s.07-.27.17-.7c.23-.88.69-2.76,1.68-6.77.99-4.02,1.46-5.9,1.67-6.78.11-.42.17-.67.17-.69h-.02c.02-.1,0-.11,0-.12l-.08-.12-.12.07s-.02.01-.05.1h-.02s-.07.27-.18.72c-.23.89-.69,2.77-1.68,6.75h0c-.99,4-1.45,5.87-1.66,6.76-.11.43-.17.68-.18.71h.02c-.02.1,0,.11,0,.12l.08.12Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M726.98,410.29c1.69-3.91,3.06-7.07,3.06-7.07,0,0-1.36,3.17-3.05,7.08-1.69,3.91-3.05,7.07-3.06,7.07,0,0,1.36-3.17,3.05-7.07Z"
                />
                <path
                  class="cls-42"
                  d="M723.95,417.52s.07-.03.11-.11h0s.03-.06.06-.14c.04-.1.1-.23.18-.4l.66-1.52c.55-1.28,1.32-3.05,2.16-5,1.65-3.81,2.41-5.59,2.76-6.42.17-.4.27-.63.28-.65h-.02c.03-.1.03-.11.02-.12l-.06-.13-.14.05s-.03.01-.07.09h-.02s-.1.24-.27.62c-.36.82-1.13,2.59-2.79,6.43-.84,1.95-1.61,3.72-2.16,5l-.65,1.52c-.08.18-.13.31-.17.41-.04.08-.06.13-.06.14h0c-.05.15-.01.16.06.2.03.01.06.02.08.02Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M725.85,409.69c2.3-3.58,4.17-6.48,4.17-6.48,0,0-1.86,2.9-4.17,6.48-2.3,3.58-4.17,6.48-4.17,6.47,0,0,1.86-2.9,4.16-6.48Z"
                />
                <path
                  class="cls-42"
                  d="M721.69,416.33s.06-.02.12-.09h0s.04-.05.09-.13c.06-.09.14-.21.24-.37l.9-1.39c.76-1.17,1.8-2.79,2.95-4.58,1.15-1.79,2.19-3.41,2.95-4.58l.89-1.39c.1-.16.18-.28.24-.37.05-.08.08-.12.09-.13h0c.07-.14.04-.16-.03-.21-.08-.05-.11-.07-.2.05h0s-.03.05-.09.13c-.06.09-.14.21-.24.37l-.89,1.39c-.76,1.17-1.8,2.79-2.95,4.58h0c-2.2,3.42-3.25,5.05-3.74,5.83-.26.4-.4.62-.42.64h.02c-.05.09-.04.11-.04.12v.06s.07.03.07.03c.03.02.06.04.08.04Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M724.84,408.91c2.85-3.16,5.17-5.71,5.17-5.71,0,0-2.31,2.56-5.16,5.72-2.85,3.16-5.17,5.71-5.17,5.71,0,0,2.31-2.56,5.16-5.72Z"
                />
                <path
                  class="cls-42"
                  d="M719.66,414.79s.06-.02.12-.07h0s.04-.04.11-.11c.07-.08.17-.18.3-.32l1.11-1.22c.94-1.03,2.23-2.46,3.65-4.04,1.43-1.58,2.72-3.01,3.65-4.04l1.11-1.23c.13-.14.22-.25.29-.33.06-.07.1-.11.11-.12h0c.09-.13.06-.15,0-.21-.07-.06-.1-.08-.21.02h0s-.05.05-.11.12c-.07.08-.17.18-.29.32l-1.11,1.22c-.94,1.03-2.23,2.46-3.66,4.04-2.77,3.06-4.07,4.5-4.67,5.18-.3.33-.47.52-.49.53h.01c-.06.09-.06.1-.06.11v.06s.05.04.05.04c.03.03.06.05.08.05Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M723.96,407.98c3.33-2.65,6.03-4.8,6.03-4.8s-2.69,2.15-6.02,4.81c-3.33,2.65-6.03,4.8-6.03,4.8,0,0,2.69-2.15,6.02-4.81Z"
                />
                <path
                  class="cls-42"
                  d="M717.93,412.94s.03,0,.1-.05h.01s.22-.17.58-.45c.72-.57,2.23-1.77,5.45-4.33,3.2-2.55,4.71-3.76,5.43-4.34.36-.29.57-.45.59-.47h-.01c.07-.08.07-.09.07-.11v-.14s-.13-.02-.13-.02c-.01,0-.03,0-.1.05h-.01s-.22.17-.58.45c-.72.57-2.23,1.77-5.45,4.33h0c-3.2,2.55-4.71,3.76-5.43,4.34-.36.28-.57.45-.59.46h.01c-.07.08-.07.09-.07.11v.14s.13.02.13.02c0,0,0,0,0,0Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M723.25,406.92c3.72-2.08,6.73-3.76,6.73-3.75,0,0-3.01,1.69-6.72,3.76-3.71,2.07-6.73,3.76-6.73,3.75,0,0,3.01-1.69,6.72-3.76Z"
                />
                <path
                  class="cls-42"
                  d="M716.5,410.83s.04,0,.09-.03v.02s.26-.14.65-.36c.8-.44,2.49-1.38,6.08-3.39,3.59-2,5.27-2.95,6.07-3.4.39-.22.62-.35.65-.36v-.02c.07-.05.07-.06.08-.08l.04-.14-.14-.04s-.03,0-.11.03v-.02s-.25.13-.63.35c-.79.44-2.48,1.38-6.1,3.4-1.86,1.04-3.54,1.98-4.75,2.66l-1.44.81c-.17.09-.29.16-.38.22-.08.05-.13.07-.14.08h0c-.12.09-.11.12-.07.2l.03.06.06.02s0,0,.01,0Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M722.72,405.76c4.01-1.44,7.25-2.6,7.25-2.6,0,0-3.24,1.17-7.25,2.61-4,1.44-7.25,2.6-7.25,2.6,0,0,3.24-1.17,7.25-2.61Z"
                />
                <path
                  class="cls-42"
                  d="M715.44,408.51s.05,0,.09-.01h0s.06-.01.16-.05c.1-.03.23-.08.41-.14l1.55-.56c1.31-.47,3.12-1.12,5.13-1.84,2-.72,3.82-1.37,5.13-1.84l1.55-.56c.18-.07.31-.11.41-.15.09-.03.14-.05.15-.05h0c.14-.07.13-.11.1-.19-.03-.08-.05-.12-.19-.08h0s-.06.01-.15.05c-.1.03-.23.08-.41.14l-1.55.56c-1.31.47-3.13,1.12-5.13,1.84h0c-2,.72-3.81,1.37-5.13,1.84l-1.55.56c-.18.06-.31.11-.41.15-.09.03-.14.05-.15.05h0c-.14.07-.13.11-.1.19.03.06.04.09.1.09Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M722.39,404.53c4.19-.76,7.58-1.38,7.58-1.38,0,0-3.39.62-7.58,1.39-4.18.76-7.58,1.38-7.58,1.37,0,0,3.39-.62,7.58-1.39Z"
                />
                <path
                  class="cls-42"
                  d="M714.85,406.06s.06-.01.15-.03c.11-.02.25-.04.44-.08l1.62-.29c1.37-.25,3.27-.59,5.36-.97,4.06-.74,5.96-1.09,6.86-1.26.44-.08.69-.12.71-.13v-.02c.09-.02.09-.03.1-.05l.08-.12-.11-.08s-.02-.02-.12,0v-.02s-.3.06-.77.14c-.92.16-2.83.51-6.81,1.23h0c-4.09.74-5.99,1.09-6.87,1.26-.42.08-.67.12-.7.12v.02c-.09.02-.09.03-.1.05l-.03.05v.06c.03.08.03.12.19.11h0Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M722.27,403.26c4.26-.07,7.7-.13,7.7-.12,0,0-3.45.06-7.7.13-4.25.07-7.7.13-7.7.12,0,0,3.45-.06,7.7-.13Z"
                />
                <path
                  class="cls-42"
                  d="M714.57,403.54s.28,0,.72-.01c.91,0,2.84-.04,6.98-.11,2.13-.04,4.05-.07,5.45-.09l1.65-.03c.19,0,.33,0,.44-.01.09,0,.15,0,.16,0h0c.15-.03.15-.06.15-.15,0-.09-.01-.12-.16-.14h0s-.07,0-.17,0c-.11,0-.25,0-.43,0l-1.65.03c-1.39.02-3.32.05-5.45.09-2.13.04-4.05.07-5.45.09l-1.65.03c-.19,0-.33,0-.44.01-.09,0-.15,0-.16,0h0c-.15.03-.15.06-.15.15v.06s.04.04.04.04c.01.01.02.02.11.02v.02Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M722.35,401.98c4.21.62,7.62,1.12,7.62,1.12,0,0-3.41-.49-7.62-1.11-4.21-.62-7.62-1.12-7.62-1.12,0,0,3.41.49,7.62,1.11Z"
                />
                <path
                  class="cls-42"
                  d="M729.94,403.25h0c.15,0,.16-.04.17-.12,0-.09.01-.13-.13-.17h0s-.07-.02-.16-.03c-.1-.02-.24-.04-.43-.07l-1.63-.24c-1.38-.2-3.29-.48-5.39-.79-2.1-.31-4.01-.59-5.39-.79l-1.63-.24c-.19-.03-.34-.05-.44-.06-.09-.01-.14-.02-.15-.02h0c-.15,0-.16.04-.17.12,0,.09-.01.13.13.17h0s.07.02.16.03c.1.02.24.04.43.07l1.63.24c1.38.2,3.28.48,5.39.79,2.11.31,4.01.59,5.39.79l1.63.24c.19.03.33.05.44.06.09.01.14.02.15.02Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M722.64,400.74c4.05,1.3,7.34,2.35,7.34,2.36,0,0-3.29-1.05-7.34-2.35-4.05-1.3-7.33-2.35-7.33-2.36,0,0,3.29,1.05,7.34,2.35Z"
                />
                <path
                  class="cls-42"
                  d="M730.01,403.24c.07,0,.08-.03.1-.1.03-.08.04-.12-.1-.18h0s-.06-.03-.15-.06c-.1-.04-.24-.08-.42-.14l-1.57-.51c-1.33-.43-3.16-1.02-5.19-1.66-3.98-1.27-5.81-1.86-6.67-2.13-.4-.13-.64-.21-.66-.21v.02c-.1-.02-.11-.02-.12,0l-.05.03-.02.06c-.02.08-.04.12.11.18h0s.06.03.15.05c.1.04.24.08.42.14l1.57.51c1.33.43,3.16,1.01,5.19,1.66,2.03.65,3.86,1.24,5.19,1.66l1.57.5c.18.06.32.1.42.13.09.03.14.05.15.05h0s.07,0,.09,0Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M723.13,399.56c3.78,1.95,6.85,3.53,6.85,3.53,0,0-3.07-1.57-6.85-3.52-3.78-1.95-6.85-3.53-6.85-3.53,0,0,3.07,1.57,6.85,3.52Z"
                />
                <path
                  class="cls-42"
                  d="M730.02,403.23s.06-.03.09-.08c.04-.08.05-.12-.07-.2h0s-.06-.04-.15-.08c-.09-.05-.22-.11-.39-.2l-1.47-.76c-1.24-.64-2.95-1.52-4.84-2.49h0c-3.61-1.86-5.33-2.74-6.16-3.16-.42-.21-.66-.34-.68-.35v.02c-.1-.04-.11-.03-.12-.03l-.13.05.04.14s0,.03.09.07v.02s.25.13.65.33c.81.43,2.53,1.31,6.19,3.19,1.89.97,3.61,1.85,4.85,2.49l1.47.75c.17.09.3.15.39.2.08.04.13.07.14.07h0s.08.02.11.02Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M723.8,398.47c3.42,2.54,6.18,4.6,6.18,4.6s-2.77-2.05-6.19-4.59c-3.41-2.54-6.18-4.6-6.18-4.6,0,0,2.77,2.05,6.19,4.59Z"
                />
                <path
                  class="cls-42"
                  d="M730,403.22s0,0,.01,0l.14-.03-.02-.14s0-.03-.07-.09h0s-.22-.18-.58-.44c-.72-.55-2.27-1.7-5.6-4.17-1.71-1.27-3.25-2.42-4.37-3.25l-1.33-.98c-.15-.11-.27-.2-.36-.26-.07-.06-.12-.09-.13-.09h0c-.13-.07-.15-.04-.21.03l-.04.05v.06s.01.03.08.09h0s.23.18.59.45c.73.55,2.28,1.71,5.58,4.16,3.22,2.39,4.78,3.55,5.54,4.11.4.3.62.47.64.48v-.02c.07.04.1.05.11.05Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M724.64,397.51c2.96,3.06,5.36,5.54,5.35,5.54,0,0-2.4-2.48-5.36-5.53-2.96-3.06-5.36-5.54-5.35-5.54,0,0,2.4,2.48,5.36,5.53Z"
                />
                <path
                  class="cls-42"
                  d="M730.06,403.2l.04-.04c.06-.06.09-.09,0-.21h0s-.05-.05-.11-.12c-.07-.08-.17-.18-.3-.32l-1.15-1.19c-.97-1-2.31-2.39-3.79-3.92h0c-2.84-2.94-4.19-4.33-4.83-4.98-.32-.33-.5-.52-.52-.54h-.01c-.07-.05-.08-.05-.1-.05h-.06s-.04.04-.04.04c-.06.06-.09.09,0,.21h0s.05.05.11.12c.07.08.17.18.3.32l1.15,1.19c.97,1,2.31,2.39,3.79,3.92,2.85,2.95,4.2,4.34,4.84,4.99.32.33.5.52.52.54h.01c.07.05.08.05.1.05h.06Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M725.63,396.7c2.42,3.5,4.39,6.33,4.39,6.34,0,0-1.97-2.83-4.39-6.33-2.42-3.5-4.39-6.33-4.38-6.33,0,0,1.97,2.83,4.39,6.33Z"
                />
                <path
                  class="cls-42"
                  d="M730.13,403.21l.03-.14s0-.03-.04-.11h.02s-.17-.26-.44-.64c-.52-.77-1.63-2.36-3.94-5.7h0c-2.33-3.36-3.43-4.95-3.96-5.71-.26-.38-.41-.6-.42-.62h-.02c-.06-.06-.07-.06-.09-.07l-.14-.02-.03.14s0,.03.04.11h-.02s.18.26.45.66c.53.77,1.63,2.37,3.93,5.68,2.32,3.35,3.42,4.94,3.96,5.7.26.38.42.61.43.63h.02c.06.06.07.06.09.07l.14.02Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M726.74,396.06c1.82,3.85,3.3,6.97,3.29,6.97s-1.48-3.12-3.3-6.96c-1.82-3.84-3.29-6.96-3.29-6.96s1.48,3.12,3.3,6.96Z"
                />
                <path
                  class="cls-42"
                  d="M730.01,403.19s.05-.01.08-.02l.06-.03.02-.06s0-.03-.02-.11h.02s-.13-.27-.32-.68c-.39-.84-1.22-2.58-2.97-6.29h0c-.91-1.92-1.73-3.66-2.33-4.92l-.71-1.49c-.08-.17-.14-.3-.19-.4-.04-.09-.06-.13-.07-.14h0c-.08-.13-.11-.11-.19-.08l-.06.03-.02.06s0,.03.02.11h-.02s.13.27.32.68c.39.83,1.21,2.58,2.97,6.29.91,1.92,1.74,3.66,2.33,4.92l.71,1.49c.08.17.14.3.19.4.04.09.06.13.07.14h0c.05.08.08.1.11.1Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M727.93,395.61c1.17,4.09,2.11,7.41,2.11,7.41,0,0-.95-3.32-2.11-7.41-1.16-4.09-2.11-7.41-2.1-7.41,0,0,.95,3.32,2.11,7.41Z"
                />
                <path
                  class="cls-42"
                  d="M730.01,403.18s.04,0,.06,0c.09-.03.13-.04.1-.19h0s-.02-.07-.05-.16c-.03-.1-.06-.24-.12-.42l-.45-1.59c-.38-1.34-.91-3.19-1.49-5.24h0c-.58-2.05-1.11-3.9-1.49-5.24l-.45-1.59c-.05-.18-.09-.32-.12-.42-.03-.09-.04-.14-.04-.15h0c-.05-.13-.09-.13-.16-.11-.09.03-.13.04-.1.19h-.01s.02.07.05.17c.03.1.06.24.11.41l.45,1.59c.38,1.34.91,3.19,1.49,5.24.58,2.05,1.11,3.9,1.49,5.24l.45,1.59c.05.18.09.32.12.42.03.09.04.14.04.15h0c.04.1.07.12.11.12Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M729.18,395.37c.48,4.23.86,7.66.86,7.66,0,0-.39-3.43-.87-7.66-.48-4.23-.86-7.65-.86-7.65,0,0,.39,3.43.87,7.65Z"
                />
                <path
                  class="cls-42"
                  d="M730.07,403.22l.09-.11s.02-.02.01-.11h.02s-.03-.28-.08-.71c-.09-.9-.31-2.82-.78-6.94-.24-2.11-.46-4.03-.61-5.41l-.19-1.64c-.02-.19-.04-.33-.05-.43-.01-.1-.02-.15-.02-.16h0c-.03-.15-.07-.15-.16-.14h-.06s-.04.05-.04.05c0,.01-.02.02-.01.11h-.02s.03.28.08.72c.1.91.31,2.83.78,6.93.46,4.02.67,5.95.79,6.88.05.47.08.75.09.77h.02c.02.09.03.1.04.11l.11.08Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M730.46,395.33c-.21,4.25-.38,7.7-.38,7.7,0,0,.16-3.45.37-7.7.21-4.25.38-7.69.38-7.69,0,0-.16,3.45-.37,7.69Z"
                />
                <path
                  class="cls-42"
                  d="M730.07,403.22l.11-.09s.02-.02.03-.11h.02s.01-.28.03-.71c.05-.9.15-2.83.35-6.98h0c.2-4.14.3-6.07.34-6.97.02-.44.04-.69.04-.71h-.02c0-.1-.01-.1-.02-.12l-.1-.1-.11.09s-.02.02-.03.11h-.02s-.01.28-.03.71c-.05.91-.15,2.84-.35,6.97-.2,4.13-.3,6.06-.34,6.97-.02.44-.04.7-.04.72h.02c0,.1.01.1.02.12l.1.1Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M731.73,395.49c-.9,4.16-1.63,7.53-1.63,7.53,0,0,.72-3.37,1.62-7.53.9-4.16,1.63-7.53,1.63-7.53,0,0-.72,3.37-1.62,7.53Z"
                />
                <path
                  class="cls-42"
                  d="M730.13,403.18s.07-.03.11-.13h0s.01-.06.03-.15c.03-.1.06-.24.1-.43l.35-1.61c.3-1.36.7-3.25,1.15-5.33.88-4.08,1.29-5.97,1.47-6.85.09-.42.14-.65.15-.68h-.02c.01-.1,0-.11,0-.12l-.03-.05h-.06c-.08-.03-.12-.04-.17.11h0s-.01.06-.03.15c-.03.1-.06.24-.1.43l-.35,1.61c-.3,1.36-.7,3.24-1.15,5.32-.88,4.09-1.29,5.98-1.47,6.85-.09.41-.14.65-.15.67h.02c-.01.1,0,.11,0,.12l.03.05h.06s.04.02.06.02Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M732.95,395.86c-1.57,3.96-2.85,7.16-2.85,7.16,0,0,1.27-3.21,2.84-7.16,1.57-3.95,2.84-7.16,2.85-7.16s-1.27,3.21-2.84,7.16Z"
                />
                <path
                  class="cls-42"
                  d="M730.1,403.18l.06-.02s.03-.01.07-.09h.02s.11-.26.28-.7c.35-.86,1.06-2.66,2.57-6.45h0c1.51-3.79,2.22-5.59,2.55-6.45.17-.43.27-.68.28-.7h-.02c.03-.1.02-.11.02-.12l-.06-.13-.13.05s-.03.01-.07.09h-.02s-.1.26-.27.68c-.35.85-1.06,2.65-2.58,6.47-.79,1.98-1.5,3.77-2.01,5.06l-.61,1.54c-.07.18-.12.31-.16.41-.03.09-.06.14-.06.15h0c-.04.15,0,.16.07.2l.06.03Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M734.1,396.43c-2.2,3.65-3.98,6.6-3.98,6.6,0,0,1.78-2.96,3.97-6.6,2.2-3.64,3.98-6.6,3.98-6.59,0,0-1.78,2.96-3.97,6.6Z"
                />
                <path
                  class="cls-42"
                  d="M730.12,403.19s.07-.02.12-.09h0s.03-.05.08-.14c.06-.09.13-.21.23-.37l.85-1.41c.72-1.19,1.72-2.84,2.81-4.67,2.14-3.55,3.14-5.2,3.6-5.99.22-.37.36-.59.37-.61h-.01c.04-.09.04-.1.04-.12l-.04-.14-.14.03s-.03,0-.08.08h-.02s-.15.24-.37.62c-.48.78-1.48,2.43-3.6,5.96-1.1,1.82-2.09,3.47-2.81,4.67l-.85,1.42c-.1.16-.17.29-.22.38-.05.08-.08.13-.08.14h0c-.07.14-.04.16.04.21.03.02.06.03.08.03Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M735.13,397.18c-2.76,3.24-5,5.86-5,5.86,0,0,2.23-2.63,4.99-5.87,2.76-3.24,5-5.86,5-5.86,0,0-2.23,2.63-4.99,5.87Z"
                />
                <path
                  class="cls-42"
                  d="M730,403.2h.14s.03-.01.09-.08h.01s.18-.2.46-.53c.59-.69,1.85-2.16,4.54-5.31h0c1.38-1.62,2.63-3.08,3.53-4.15l1.07-1.26c.12-.15.22-.25.28-.34.06-.07.1-.11.1-.12h0c.09-.13.06-.15,0-.21-.07-.06-.1-.08-.21.02h0s-.04.05-.11.12c-.07.08-.16.19-.28.33l-1.07,1.26c-.91,1.06-2.15,2.53-3.53,4.14-2.61,3.07-3.87,4.54-4.47,5.26-.32.37-.5.58-.52.6h.01c-.06.09-.05.1-.05.12l.02.14Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M736.03,398.08c-3.25,2.75-5.88,4.98-5.89,4.97,0,0,2.63-2.23,5.88-4.98,3.25-2.75,5.88-4.97,5.88-4.97,0,0-2.63,2.23-5.88,4.98Z"
                />
                <path
                  class="cls-42"
                  d="M730.13,403.21s.06-.01.11-.05h0s.05-.04.13-.1c.08-.07.19-.16.33-.27l1.26-1.07c1.07-.9,2.54-2.14,4.16-3.52h0c3.11-2.63,4.59-3.88,5.29-4.49.36-.3.56-.47.58-.49h-.01c.07-.08.07-.09.07-.11v-.14s-.13-.02-.13-.02c-.02,0-.03,0-.1.05h-.01s-.23.19-.6.49c-.72.6-2.2,1.85-5.28,4.46-1.62,1.37-3.1,2.62-4.16,3.52l-1.26,1.07c-.15.12-.25.22-.33.29-.07.06-.11.1-.12.1h0c-.1.11-.08.14-.03.21.04.04.06.06.1.06Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M736.78,399.12c-3.65,2.18-6.61,3.95-6.62,3.95s2.96-1.77,6.61-3.96c3.65-2.18,6.61-3.95,6.61-3.95,0,0-2.96,1.78-6.61,3.96Z"
                />
                <path
                  class="cls-42"
                  d="M730.12,403.22s.06-.01.11-.03h0s.06-.03.14-.08c.09-.05.21-.12.37-.22l1.42-.85c1.2-.71,2.85-1.7,4.68-2.8h0c3.53-2.11,5.19-3.1,5.97-3.58.39-.23.61-.36.63-.38v-.02c.07-.05.07-.06.07-.08l.03-.14-.14-.04s-.03,0-.11.03v-.02s-.26.15-.65.38c-.79.47-2.45,1.46-5.97,3.56-1.83,1.09-3.48,2.08-4.68,2.8l-1.42.85c-.16.1-.29.17-.38.23-.08.05-.13.08-.14.08h0c-.12.1-.1.13-.06.2.03.05.05.08.09.08Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M737.34,400.27c-3.96,1.56-7.17,2.82-7.17,2.82s3.21-1.27,7.17-2.82c3.96-1.56,7.17-2.82,7.17-2.81,0,0-3.21,1.27-7.17,2.82Z"
                />
                <path
                  class="cls-42"
                  d="M730.13,403.22s.04,0,.09-.02v.02s.29-.11.73-.29c.87-.33,2.67-1.04,6.45-2.53h0c3.85-1.51,5.65-2.22,6.49-2.56.41-.16.65-.25.67-.26v-.02c.08-.04.08-.05.09-.06l.06-.14-.13-.06s-.03-.01-.11.02v-.02s-.27.1-.68.27c-.85.33-2.65,1.03-6.49,2.55-3.87,1.52-5.66,2.23-6.5,2.57-.4.16-.64.25-.66.26v.02c-.08.04-.08.05-.09.06l-.06.13.13.06s.01,0,.02,0Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M737.71,401.49c-4.16.89-7.54,1.6-7.54,1.6s3.37-.72,7.54-1.61c4.16-.89,7.53-1.6,7.54-1.6,0,0-3.37.72-7.53,1.61Z"
                />
                <path
                  class="cls-42"
                  d="M730.21,403.23s.06-.01.16-.03c.1-.02.24-.05.43-.09l1.62-.34c1.36-.29,3.25-.69,5.33-1.13h0c4.05-.86,5.94-1.26,6.83-1.46.43-.09.68-.14.7-.15v-.02c.09-.03.09-.04.1-.05l.08-.12-.12-.08s-.02-.01-.11,0v-.02s-.28.06-.73.16c-.9.18-2.79.59-6.8,1.44-2.08.44-3.97.84-5.33,1.14l-1.61.35c-.19.04-.32.07-.43.09-.09.02-.15.03-.16.03h0c-.15.06-.14.09-.12.18.02.09.03.12.18.11h0Z"
                />
              </g>
              <g>
                <path
                  class="cls-42"
                  d="M737.87,402.76c-4.25.19-7.7.35-7.7.35s3.45-.16,7.7-.36c4.25-.19,7.7-.35,7.7-.35s-3.45.16-7.69.36Z"
                />
                <path
                  class="cls-42"
                  d="M730.19,403.25s.29-.02.76-.04c.92-.04,2.86-.12,6.94-.31h0c4.12-.19,6.05-.28,6.96-.33.44-.02.7-.03.73-.03v-.02c.09-.01.1-.02.11-.03l.04-.05v-.06c0-.09,0-.12-.16-.13h0s-.06,0-.16,0c-.11,0-.25,0-.44.02l-1.65.07c-1.39.06-3.32.15-5.44.25-4.08.19-6.01.28-6.93.33-.46.02-.73.03-.76.03v.02c-.09.01-.1.02-.11.03l-.09.11.1.1s.02.02.11.02v.02Z"
                />
              </g>
            </g>
            <path
              class="cls-33"
              d="M731.32,403.14c0,.62-.52,1.12-1.14,1.12s-1.12-.52-1.12-1.14.52-1.12,1.14-1.12c.62,0,1.12.52,1.12,1.14Z"
            />
            <path
              class="cls-61"
              d="M750.53,412.27c-2.43-.03-4.43,1.92-4.45,4.35-.03,2.43,1.92,4.43,4.35,4.45,2.43.03,4.43-1.92,4.45-4.35.03-2.43-1.92-4.43-4.35-4.45ZM750.44,420.09c-1.89-.02-3.4-1.57-3.38-3.46s1.57-3.4,3.46-3.38,3.4,1.57,3.38,3.46c-.02,1.89-1.57,3.4-3.46,3.38Z"
            />
            <polygon
              class="cls-33"
              points="751.1 416.25 750.04 416.24 750.3 392.76 746.59 392.72 746.6 391.67 751.37 391.72 751.1 416.25"
            />
            <path
              class="cls-33"
              d="M756,418.41c0-.13.15-19.4.1-23.05-.01-.75-.26-1.33-.76-1.76-1.44-1.23-4.39-.84-4.42-.84l-.15-1.05c.14-.02,3.45-.46,5.26,1.08.74.63,1.12,1.48,1.13,2.54.06,3.66-.1,22.94-.1,23.08h-1.06Z"
            />
            <rect
              class="cls-33"
              x="755.93"
              y="417.6"
              width="8.47"
              height="1.03"
              transform="translate(4.77 -8.56) rotate(.65)"
            />
            <path
              class="cls-61"
              d="M730.27,385.14c-9.86-.11-17.94,7.79-18.05,17.65-.11,9.86,7.79,17.94,17.65,18.05,9.86.11,17.94-7.79,18.05-17.65.11-9.86-7.79-17.94-17.65-18.05ZM729.88,419.92c-9.16-.1-16.5-7.77-16.4-17.12.11-9.35,7.62-16.85,16.78-16.74,9.16.1,16.5,7.77,16.4,17.12-.11,9.35-7.62,16.85-16.78,16.74Z"
            />
            <path
              class="cls-75"
              d="M711.02,375.17s.14.31.47,1.54c.33,1.23,7.76,12.06,7.76,12.06,0,0,.54,1.57,1.22,1.99.69.42,3.39,1.33,3.39,1.33l1.02-.67s.77.48,1.26.01c.49-.47.54-.88.54-.88,0,0,.36.75.71.35.35-.4.35-.74.35-.74l-.73-2.39-.9-.42s1.24.22,2.08-.11c0,0,.82-.34.87-.63l-.23-.37s-1.05.22-1.63.11c-.58-.11-2.66-.63-2.66-.63l-2.28.35-5.07-10.18-.35-1.23c-2.14-1.02-4.17-1.49-5.81-.07v.57Z"
            />
            <path
              class="cls-45"
              d="M727.05,357.83s-.1-1.71-.3-1.97c-.21-.26-6.49-1.56-6.61-1.13-.12.43,0,1.51,0,1.51,0,0,6.1,1.7,6.92,1.59Z"
            />
            <path
              class="cls-61"
              d="M740.59,355.8c.08,0,.13-.01.15-.02.08-.02.12-.11.1-.19-.02-.08-.1-.12-.18-.1-.03,0-1.21.22-2.96-3.76-.03-.08-.12-.11-.2-.08-.07.03-.11.12-.08.2,1.57,3.58,2.74,3.95,3.16,3.95Z"
            />
            <path
              class="cls-61"
              d="M738.47,355.87s0,0,0,0c1.93-.08,2.33-2.24,2.33-2.26.01-.08-.04-.16-.12-.17-.08-.02-.16.04-.17.12-.01.08-.36,1.94-2.05,2.01-.08,0-.15.07-.14.15,0,.08.07.14.15.14Z"
            />
            <path
              class="cls-61"
              d="M737.12,354.15h0c1.17-.03,1.64-1.25,1.66-1.3.03-.08-.01-.16-.09-.19-.08-.03-.16.01-.19.09,0,.01-.42,1.09-1.38,1.11-.08,0-.15.07-.14.15,0,.08.07.14.15.14Z"
            />
            <path
              class="cls-61"
              d="M722.64,361.06s.05,0,.08-.02c.07-.04.09-.13.05-.2-.02-.04-2.38-3.81-5.68-2.45-.08.03-.11.12-.08.19.03.08.12.11.19.08,3.06-1.26,5.29,2.3,5.31,2.33.03.05.08.07.13.07Z"
            />
            <path
              class="cls-61"
              d="M723.6,357.29s.03,0,.04,0c.08-.02.12-.1.1-.18,0-.01-.4-1.47.5-1.94.07-.04.1-.13.06-.2-.04-.07-.13-.1-.2-.06-1.12.58-.67,2.21-.65,2.28.02.07.08.11.14.11Z"
            />
            <path
              class="cls-61"
              d="M725.58,357.33s.08-.02.11-.05c0,0,.68-.84.13-1.73-.04-.07-.14-.09-.2-.05-.07.04-.09.13-.05.2.44.71-.08,1.36-.1,1.39-.05.06-.04.16.02.21.03.02.06.03.09.03Z"
            />
            <path
              class="cls-46"
              d="M763.43,412.52c.08,0,.15-.07.15-.15,0-.06,0-6.13-.75-12.85-1-9.05-2.79-14.9-5.32-17.4-.95-.94-2.01-1.4-3.16-1.36-.08,0-.15.07-.15.16,0,.09.07.15.16.15,1.07-.04,2.05.39,2.94,1.27,5.92,5.85,5.98,29.79,5.98,30.03,0,.09.07.15.15.15Z"
            />
            <path
              class="cls-61"
              d="M721.96,356.83s.01,0,.02,0c.08-.01.14-.09.13-.17-.16-1.16.03-1.48.12-1.57.06-.05.11-.04.12-.04.08.02.16-.03.18-.11.02-.08-.02-.16-.1-.18-.02,0-.2-.06-.38.1-.29.24-.36.86-.23,1.84.01.07.07.13.15.13Z"
            />
          </g>
        </g>
      </g>
      <g
        id="fenêtre_centre_bas"
        data-name="fenêtre centre bas"
      >
        <rect
          class="cls-5"
          x="681.19"
          y="598.68"
          width="149.58"
          height="122.96"
          rx=".29"
          ry=".29"
        />
        <rect
          class="cls-12"
          x="681.19"
          y="604.68"
          width="149.58"
          height="110.96"
          rx=".29"
          ry=".29"
        />
        <g>
          <rect
            class="cls-79"
            x="701.78"
            y="618.44"
            width="31.67"
            height="42.22"
          />
          <g>
            <rect
              class="cls-81"
              x="704.81"
              y="621.39"
              width="25.64"
              height="36.01"
            />
            <path
              fill="#F5F5F5"
              d="M704.81,657.4h25.64v-9.44h-25.64v9.44Z"
            />
            <path
              class="cls-43"
              d="M720.46,637.57l.83,1.93s-1.89,1.38-1.62,3.51c.28,2.13,1.85,6.43,1.85,6.43h3.31s1.66-6,1.62-6.98c-.04-.99-1.46-2.92-1.46-2.92l.75-1.97s-2.96-1.81-5.29,0Z"
            />
            <path
              class="cls-43"
              d="M720.28,643.92c-.64-.58-1.44-1.3-1.7-2.27-.12-.46-.07-.86.14-1.15.21-.27.57-.42.97-.41.34.01.66.13.92.23l-.15.41c-.24-.09-.52-.19-.79-.2-.26,0-.49.08-.61.24-.18.23-.12.58-.07.77.23.85.97,1.53,1.57,2.06l-.29.32Z"
            />
            <path
              class="cls-43"
              d="M726.11,644.19l-.32-.29c.4-.45.72-.95.95-1.51.12-.3.18-.53.19-.75,0-.25-.06-.49-.2-.65-.16-.19-.43-.28-.71-.26-.26.03-.52.16-.73.37l-.31-.31c.28-.29.64-.46,1-.5.41-.04.83.11,1.08.4.21.24.32.58.31.95-.01.35-.13.66-.22.9-.25.6-.59,1.15-1.02,1.63Z"
            />
            <path
              class="cls-79"
              d="M725.74,637.59s-.28.11-.76.19c-.48.09-1.15.16-1.89.17-.74,0-1.41-.06-1.89-.14-.48-.08-.77-.16-.76-.18,0-.02.3.02.78.07.48.05,1.14.1,1.87.09.73,0,1.39-.06,1.87-.12.48-.06.77-.1.78-.08Z"
            />
            <path
              class="cls-79"
              d="M730.44,626.26c-.32-.44-1.85-.99-2.39-1.08-2.39-.39-4.88-.43-7.17.33s-4.37,2.4-5.27,4.64c-.46,1.16-.61,2.44-1.21,3.53-.77,1.39-2.17,2.28-3.24,3.45-1.35,1.48-2.16,3.44-2.24,5.44-.08,2,.56,4.02,1.79,5.61l6.44.08c-.16-2.53-.15-5.12.6-7.54.75-2.42,2.35-4.68,4.66-5.73,2.42-1.1,5.5-.83,8.14-.46l-.11-8.28Z"
            />
            <path
              class="cls-79"
              d="M714.13,621.39c.71,1.1-.2,2.89-1.14,3.81s-2.13,1.69-2.56,2.93c-.43,1.24,0,2.61-.2,3.91-.19,1.17-.95,2.23-1.99,2.78-1.04.56-2.34.6-3.42.11v-13.55h9.32Z"
            />
            <path
              class="cls-43"
              d="M711.58,644.83s.35.49.21.8c-.14.31-1.82,2.55-1.19,4.09.63,1.54,1.89,3.22,1.89,3.22h3.91s1.93-3.04,1.89-4.05c-.07-1.68-1.29-3.43-1.29-3.43l.31-.63s-3.63-1.05-5.73,0Z"
            />
          </g>
          <path
            class="cls-43"
            d="M730.44,657.4s0-.06,0-.17c0-.12,0-.29,0-.51,0-.45,0-1.11,0-1.97,0-1.72-.01-4.23-.02-7.4,0-6.34-.02-15.33-.04-25.96l.07.07c-7.75,0-16.46,0-25.63,0h0l.08-.08c0,13.49-.01,25.96-.02,36.01l-.07-.07c7.78.01,14.18.03,18.64.03,2.23,0,3.98.01,5.17.02.59,0,1.05,0,1.36,0,.31,0,.47,0,.47,0,0,0-.15,0-.46,0-.31,0-.76,0-1.35,0-1.19,0-2.93,0-5.16.02-4.47,0-10.89.02-18.68.03h-.07s0-.07,0-.07c0-10.05,0-22.52-.02-36.01v-.08s.08,0,.08,0h0c9.18,0,17.89,0,25.63,0h.07s0,.07,0,.07c-.01,10.65-.03,19.66-.04,26.01,0,3.16-.02,5.67-.02,7.38,0,.85,0,1.51,0,1.95,0,.22,0,.38,0,.5,0,.11,0,.17,0,.17Z"
          />
          <path
            class="cls-43"
            d="M733.45,618.44s-.6.73-1.45,1.53c-.85.8-1.53,1.45-1.56,1.42-.03-.03.6-.73,1.45-1.53.85-.8,1.53-1.45,1.56-1.42Z"
          />
          <path
            class="cls-43"
            d="M701.7,618.43s.76.61,1.62,1.43c.86.82,1.54,1.51,1.51,1.54-.03.03-.76-.6-1.62-1.43-.87-.82-1.54-1.51-1.51-1.54Z"
          />
          <path
            class="cls-43"
            d="M701.78,660.66s.61-.75,1.44-1.6c.83-.85,1.52-1.52,1.55-1.49.03.03-.61.75-1.44,1.6-.83.85-1.52,1.52-1.55,1.49Z"
          />
          <path
            class="cls-43"
            d="M733.35,660.71s-.57-.83-1.38-1.75c-.81-.93-1.58-1.56-1.55-1.6.01-.02.22.12.54.38.31.26.73.64,1.14,1.11.41.47.74.93.95,1.27.22.35.32.57.31.58Z"
          />
        </g>
        <g class="cls-96">
          <g>
            <g>
              <g>
                <path
                  class="cls-64"
                  d="M752.84,741.97c-.51.17-15.03.07-15.59-.28-.21-.13-.32-2.25-.38-4.81-.01-.55-1.56-9.4-1.56-9.4l9.72.04,1.21,9.4s5.55,2.52,6.11,2.98c.56.45,1,1.92.49,2.08Z"
                />
                <path
                  class="cls-64"
                  d="M752.84,741.97c-.51.17-15.03.07-15.58-.28-.18-.12-.29-1.78-.35-3.93,2.9.88,11.98,2.28,12.92,1.95.83-.29-.3-1.16-.86-1.53,1.49.7,3.09,1.48,3.38,1.71.56.45,1,1.91.49,2.08Z"
                />
                <path
                  class="cls-64"
                  d="M748.3,737.87s-2.3-.79-4.12,1.34"
                />
              </g>
              <path
                class="cls-64"
                d="M736.39,733.75h9.44s-1.81-16.31-1.92-17.03c-.89-5.51-4.58-22.41-4.58-22.41h-11.63s4.9,17.49,5.61,23.15c.65,5.17,3.08,16.29,3.08,16.29Z"
              />
            </g>
            <g>
              <path
                class="cls-44"
                d="M729.41,742.6c-.53-.02-14.09-5.23-14.49-5.76-.15-.2.49-2.22,1.34-4.64.18-.52.37-1.06.57-1.61,1.28-3.54,2.72-7.27,2.72-7.27l9.08,3.46-2.97,7.17-.65,1.58s4.3,4.32,4.67,4.94c.36.62.26,2.14-.27,2.12Z"
              />
              <path
                class="cls-67"
                d="M729.41,742.61c-.53-.02-14.09-5.24-14.48-5.76-.12-.16.28-1.54.9-3.36,2.45,1.72,10.72,5.89,11.73,5.87.64-.02.38-.65.03-1.19.99,1.03,1.94,2.04,2.1,2.32.36.62.26,2.14-.28,2.12Z"
              />
              <path
                class="cls-67"
                d="M726.65,737.2s-1.57-.93-3.61.28"
              />
            </g>
            <path
              class="cls-64"
              d="M717.13,729.8l8.95,3.17s4.41-8.71,5.23-12.98c.91-4.72,3.11-18.13,3.11-18.13l.65-.4c1.57-.99,3.16-5.73,3.34-7.13h-13.53s-2.32,4.57-1.22,9.26c0,0-2.37,12.65-2.9,15.46-.4,2.12-3.65,10.75-3.65,10.75Z"
            />
            <path
              class="cls-77"
              d="M743.31,710.73s0-.04,0-.06c0-.04,0-.09-.01-.14,0-.03,0-.06-.01-.1,0-.05-.01-.11-.02-.18,0-.05-.01-.1-.02-.15,0-.06-.02-.12-.03-.18-.01-.08-.03-.16-.05-.25,0-.05-.02-.09-.03-.14-.41-2.19-1.48-6.54-2.27-9.73-.54-2.18-.96-3.82-.96-3.85,0,0,.01-.03.01-.06,0,0,0-.01,0-.02,0-.03,0-.07,0-.11,0,0,0-.01,0-.02,0-.05,0-.11-.01-.19,0,0,0,0,0,0,0-.08-.01-.17-.02-.27,0,0,0,0,0-.01,0-.1-.02-.2-.03-.32,0-.01,0-.03,0-.04-.01-.1-.02-.21-.04-.33,0-.05-.01-.1-.02-.15-.01-.08-.02-.16-.03-.25-.01-.11-.03-.22-.05-.34,0-.02,0-.04,0-.06,0-.06-.02-.12-.03-.19,0-.05-.01-.11-.02-.16-.02-.12-.04-.26-.06-.39-.01-.1-.03-.19-.04-.3-.02-.11-.03-.22-.05-.33-.02-.15-.05-.3-.07-.45-.02-.1-.03-.19-.05-.29-.04-.25-.09-.52-.13-.78,0-.04-.02-.09-.02-.13-.04-.25-.09-.5-.14-.76-.01-.07-.02-.13-.04-.2-.11-.61-.23-1.24-.36-1.88-.01-.05-.02-.11-.03-.16-.13-.65-.27-1.31-.42-1.96-.01-.05-.02-.1-.03-.15-.07-.3-.14-.61-.21-.9,0-.03-.01-.05-.02-.08-.08-.32-.16-.64-.24-.96-.01-.05-.02-.09-.04-.13-.07-.28-.15-.56-.23-.83-.01-.04-.02-.09-.04-.13-.09-.3-.17-.6-.26-.89,0-.03-.02-.06-.03-.09-.08-.26-.16-.51-.25-.75-.02-.05-.03-.09-.05-.14-.09-.27-.19-.53-.28-.78,0,0,0,0,0-.01-.09-.24-.19-.46-.28-.68-.02-.04-.04-.08-.05-.12-.1-.22-.2-.43-.29-.62-.33-.64-1.62-1.55-2.95-1.34-.44.07-.89.26-1.31.63-.02.01-.03.03-.05.04-.17.15-.33.3-.49.47-.06.06-.11.12-.17.18-.12.13-.24.27-.36.41-.06.07-.12.14-.17.21-.13.15-.25.31-.37.47-.04.06-.09.12-.13.17-.34.46-.66.96-.98,1.48-.03.04-.05.09-.08.13-.13.23-.27.46-.4.69-.03.05-.05.09-.08.14-.15.27-.29.53-.43.81,0,0,0,0,0,.01-.17.34-.34.69-.51,1.04,0,0,0,0,0,.01-.02.05-.05.1-.07.15-.12.25-.23.5-.34.75-.03.06-.05.13-.08.19-.06.14-.12.29-.18.43,0,.02-.02.04-.03.06-.13.3-.25.61-.37.91-.01.03-.02.06-.04.09-1.07,2.73-1.86,5.39-2.29,7.16,0,0,0,.01,0,.02-.08.32-.15.6-.2.86,0,.02,0,.03-.01.05-.05.23-.09.43-.12.6,0,.02,0,.05-.01.07,0,.05-.02.09-.02.13,0,.03,0,.05-.01.07,0,.05-.01.09-.02.13,0,.02,0,.05,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,0,0,.01,0,0-.74,2.18-1.34,5.62,0,0,0,.02,0,.02,0,0,0,.01,0,.02-.34,1.92-.63,4.24-.73,6.79,0,.01,0,.03,0,.04-.02.41-.03.83-.03,1.26,0,.02,0,.04,0,.06,0,.43,0,.86,0,1.3h0s2.42.8,5.83,1.39c.04,0,.09.01.13.02,1.1.18,2.3.34,3.56.45.01,0,.02,0,.03,0,.22.02.45.03.67.05.1,0,.19.01.29.02.19.01.39.02.58.03.13,0,.26,0,.4.01.18,0,.35,0,.53,0,.16,0,.31,0,.47,0,.16,0,.33,0,.49,0,.18,0,.36-.01.54-.02.14,0,.29-.01.43-.02.24-.01.48-.03.73-.05.08,0,.17-.01.25-.02.32-.03.64-.07.96-.11.11-.01.22-.03.32-.05.21-.03.43-.07.64-.11.13-.02.25-.05.38-.08.19-.04.38-.08.57-.13.13-.03.27-.07.4-.1.18-.05.36-.1.54-.15.13-.04.27-.08.4-.12.17-.06.35-.12.52-.18.13-.05.26-.09.39-.15.17-.07.34-.14.51-.22.12-.05.25-.11.37-.16.2-.09.39-.2.58-.3.08-.04.16-.08.24-.13,0,0,0-.02.01-.03,0-.01.01-.02.01-.04,0-.02,0-.06,0-.09Z"
            />
            <g>
              <path
                class="cls-67"
                d="M735.65,666c4.07,3.32,5.45,9.54,1.8,15.46-3.32,5.38-10.53,7.48-14.27,5.45-3.97-2.15-4.54-6.97-2.22-9.46,2.24-2.4,5.39-2.74,6.57-5.07.57-1.11.46-3.22,1.23-4.9.86-1.87,4.28-3.61,6.9-1.48Z"
              />
              <path
                class="cls-67"
                d="M727.36,687.96c2.14-.08,4.25-.79,6.08-1.91,1.84-1.13,3.37-2.73,4.51-4.56,1.14-1.83,1.87-3.94,1.91-6.11.05-2.16-.52-4.31-1.58-6.17.96,1.91,1.48,4.04,1.38,6.17-.05,1.06-.24,2.11-.57,3.12-.33,1.01-.79,1.97-1.36,2.86-.57.89-1.21,1.75-1.95,2.51-.73.77-1.57,1.44-2.46,2.01-.89.57-1.85,1.05-2.86,1.4-1,.36-2.05.61-3.12.69Z"
              />
              <path
                class="cls-67"
                d="M720.21,677.98c.34-.57.79-1.06,1.29-1.49.5-.43,1.04-.8,1.63-1.1.59-.3,1.17-.62,1.75-.96.57-.34,1.13-.73,1.61-1.2.24-.24.47-.48.67-.77.2-.28.33-.6.45-.92.22-.64.33-1.3.47-1.95.14-.64.32-1.28.61-1.87.28-.59.69-1.12,1.18-1.58-.52.41-.96.93-1.28,1.52-.33.59-.53,1.24-.69,1.88-.17.65-.28,1.3-.5,1.91-.11.3-.24.6-.43.86-.18.26-.41.49-.65.72-.93.92-2.13,1.52-3.28,2.18-.58.33-1.13.73-1.62,1.18-.47.47-.91.99-1.2,1.59Z"
              />
            </g>
            <path
              class="cls-34"
              d="M743.31,710.73s0-.04,0-.06c0-.04,0-.09-.01-.14,0-.03,0-.06-.01-.1,0-.05-.01-.11-.02-.18,0-.05-.01-.1-.02-.15,0-.06-.02-.12-.03-.18-.01-.08-.03-.16-.05-.25,0-.05-.02-.09-.03-.14-.41-2.19-1.48-6.54-2.27-9.73-.54-2.18-.96-3.82-.96-3.85,0,0,.01-.03.01-.06,0,0,0-.01,0-.02,0-.03,0-.07,0-.11,0,0,0-.01,0-.02,0-.05,0-.11-.01-.19,0,0,0,0,0,0,0-.08-.01-.17-.02-.27,0,0,0,0,0-.01,0-.1-.02-.2-.03-.32,0-.01,0-.03,0-.04-.01-.1-.02-.21-.04-.33,0-.05-.01-.1-.02-.15-.01-.08-.02-.16-.03-.25-.01-.11-.03-.22-.05-.34,0-.02,0-.04,0-.06,0-.06-.02-.12-.03-.19,0-.05-.01-.11-.02-.16-.02-.12-.04-.26-.06-.39-.01-.1-.03-.19-.04-.3-.02-.11-.03-.22-.05-.33-.02-.15-.05-.3-.07-.45-.02-.1-.03-.19-.05-.29-.04-.25-.09-.52-.13-.78,0-.04-.02-.09-.02-.13-.04-.25-.09-.5-.14-.76-.01-.07-.02-.13-.04-.2-.11-.61-.23-1.24-.36-1.88-.01-.05-.02-.11-.03-.16-.13-.65-.27-1.31-.42-1.96-.01-.05-.02-.1-.03-.15-.07-.3-.14-.61-.21-.9,0-.03-.01-.05-.02-.08-.08-.32-.16-.64-.24-.96-.01-.05-.02-.09-.04-.13-.07-.28-.15-.56-.23-.83-.01-.04-.02-.09-.04-.13-.09-.3-.17-.6-.26-.89,0-.03-.02-.06-.03-.09-.08-.26-.16-.51-.25-.75-.02-.05-.03-.09-.05-.14-.09-.27-.19-.53-.28-.78,0,0,0,0,0-.01-.09-.24-.19-.46-.28-.68-.02-.04-.04-.08-.05-.12-.1-.22-.2-.43-.29-.62-.33-.64-1.62-1.55-2.95-1.34-.44.07-.89.26-1.31.63-.02.01-.03.03-.05.04-.17.15-.33.3-.49.47-.06.06-.11.12-.17.18-.12.13-.24.27-.36.41-.06.07-.12.14-.17.21-.13.15-.25.31-.37.47-.04.06-.09.12-.13.17-.34.46-.66.96-.98,1.48-.03.04-.05.09-.08.13-.13.23-.27.46-.4.69-.03.05-.05.09-.08.14-.15.27-.29.53-.43.81,0,0,0,0,0,.01-.17.34-.34.69-.51,1.04,0,0,0,0,0,.01-.02.05-.05.1-.07.15-.12.25-.23.5-.34.75-.03.06-.05.13-.08.19-.06.14-.12.29-.18.43,0,.02-.02.04-.03.06-.13.3-.25.61-.37.91-.01.03-.02.06-.04.09-1.07,2.73-1.86,5.39-2.29,7.16,0,0,0,.01,0,.02-.08.32-.15.6-.2.86,0,.02,0,.03-.01.05-.05.23-.09.43-.12.6,0,.02,0,.05-.01.07,0,.05-.02.09-.02.13,0,.03,0,.05-.01.07,0,.05-.01.09-.02.13,0,.02,0,.05,0,.06,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,0,0,0,0,.01,0,0-.74,2.18-1.34,5.62,0,0,0,.02,0,.02,0,0,0,.01,0,.02-.34,1.92-.63,4.24-.73,6.79,0,.01,0,.03,0,.04-.02.41-.03.83-.03,1.26,0,.02,0,.04,0,.06,0,.43,0,.86,0,1.3h0s2.42.8,5.83,1.39c.04,0,.09.01.13.02,1.1.18,2.3.34,3.56.45.01,0,.02,0,.03,0,.22.02.45.03.67.05.1,0,.19.01.29.02.19.01.39.02.58.03.13,0,.26,0,.4.01.18,0,.35,0,.53,0,.16,0,.31,0,.47,0,.16,0,.33,0,.49,0,.18,0,.36-.01.54-.02.14,0,.29-.01.43-.02.24-.01.48-.03.73-.05.08,0,.17-.01.25-.02.32-.03.64-.07.96-.11.11-.01.22-.03.32-.05.21-.03.43-.07.64-.11.13-.02.25-.05.38-.08.19-.04.38-.08.57-.13.13-.03.27-.07.4-.1.18-.05.36-.1.54-.15.13-.04.27-.08.4-.12.17-.06.35-.12.52-.18.13-.05.26-.09.39-.15.17-.07.34-.14.51-.22.12-.05.25-.11.37-.16.2-.09.39-.2.58-.3.08-.04.16-.08.24-.13,0,0,0-.02.01-.03,0-.01.01-.02.01-.04,0-.02,0-.06,0-.09Z"
            />
            <path
              class="cls-64"
              d="M734.1,680.21c1.96,1.33,8.04,4.28,11.3,3.91,2.19-.25,6.51-3,8.29-6.09.23-.41-1.05-2.53-2.65-3.75-1.19-.91-2.74-1.12-2.93-.81-.79,1.3-3.24,4.58-3.87,4.73-.63.16-6.22-.6-9.58-.47-2.09.08-1.66,1.73-.55,2.48Z"
            />
            <g>
              <path
                class="cls-34"
                d="M738.4,682.59l2.31-4.56s.59.3.43.76c-.16.46-.75.39-.75.39,0,0,.41.31.23.76-.18.45-.77.27-.77.27,0,0,.47.43.24.88-.22.45-.83.29-.83.29,0,0,.5.32.23.86-.33.64-1.09.36-1.09.36Z"
              />
              <path
                class="cls-34"
                d="M740.87,677.93l-2.41,4.82s-3.12-1.28-4.81-2.58c-1.69-1.3-.84-2.64,2.1-2.52,2.96.12,5.12.29,5.12.29Z"
              />
            </g>
            <g>
              <g>
                <path
                  class="cls-64"
                  d="M729.37,678.92c-1.69,1.25-9.43,7.6-10.22,10.82-.77,3.13-.97,4.61-1,6-.03,1.38,6.86,2.41,6.83,1.16-.03-1.73.27-5.48.23-6.2-.04-.72,4.49-6.85,6.24-9.88,1.58-2.73.76-3.99-2.08-1.89Z"
                />
                <g>
                  <path
                    class="cls-64"
                    d="M724.81,695.96s.47,2.57.7,4.26c.13.95.2,2.59-.02,3.32-.33,1.1-2.43,5.51-3.51,5.02-.98-.44,1.31-3.99,1.31-3.99,0,0-1.99,3.79-3.07,3.04s2.04-4.42,2.04-4.42c0,0-2.13,3.85-3.12,2.9-.75-.71,1.89-4.2,1.89-4.2,0,0-1.85,3.29-2.66,2.59-.89-.78,1.35-4.14,1.35-4.14-1.74-2.13-1.69-3.85-1.52-5.07.04-.3,6.61.68,6.61.68Z"
                  />
                  <g>
                    <path
                      class="cls-64"
                      d="M724.07,703.31c-.22.45-.43.91-.69,1.35-.26.43-.53.86-.83,1.26-.73,1-1.34,1.51-1.3,1.47.81-.84,1.76-2.38,2.01-2.81.26-.43.53-.85.79-1.28,0-.01.02,0,.02.01Z"
                    />
                    <path
                      class="cls-64"
                      d="M722.52,702.35c-.3.57-.58,1.14-.91,1.7-.33.55-.68,1.05-1.05,1.57-.03.04-.04.01-.01-.03.34-.54.62-1.07.95-1.61.33-.54.69-1.08,1.01-1.63,0,0,.02,0,.01,0Z"
                    />
                    <path
                      class="cls-64"
                      d="M721.34,701.29c-.42.89-1,1.7-1.59,2.49-.03.04-.04,0-.01-.04.54-.82.98-1.45,1.57-2.46,0-.02.04,0,.03.01Z"
                    />
                  </g>
                </g>
              </g>
              <g>
                <path
                  class="cls-34"
                  d="M725.27,681.86l4.86,1.59s-.21.63-.69.54c-.48-.09-.5-.68-.5-.68,0,0-.24.45-.71.34-.47-.11-.38-.72-.38-.72,0,0-.35.53-.83.37-.47-.15-.41-.78-.41-.78,0,0-.24.55-.81.36-.68-.23-.53-1.02-.53-1.02Z"
                />
                <path
                  class="cls-34"
                  d="M725.04,681.98l5.4,1.59s1.64-2.73,2.02-3.9c.58-1.78.54-2.72-1.81-1.68-2.47,1.09-5.61,4-5.61,4Z"
                />
                <path
                  class="cls-34"
                  d="M731.97,680.8c-.27.46-.51.93-.78,1.39-.13.23-.61,1.13-.72,1.34-.01,0-.43-.1-.53-.11-.03,0-.04.02-.01.03.09.03.59.23.6.22.02,0,.29-.46.43-.68.15-.23.28-.46.41-.71.02-.03.03-.06.05-.1.14-.15.28-.29.4-.46.12-.17.22-.35.31-.53,0-.01-.01-.02-.02-.01-.13.16-.27.32-.39.49-.06.08-.11.16-.16.23.17-.36.33-.72.44-1.1,0-.02-.02-.03-.03-.01Z"
                />
              </g>
            </g>
            <path
              class="cls-82"
              d="M734.57,676.91c1.3.73,2.93,3.28,2.26,3.61-.66.33-1.65-.83-1.65-.83,0,0-.12,1.72-1.21,1.55-1.45-.21-1.92-2.48-1.88-3.27.03-.8.81-1.99,2.48-1.06Z"
            />
            <path
              class="cls-64"
              d="M732.39,677.81c.19.25,1.7,2.11,3.06,1.93.44-.06.22-2.5.22-2.5l.02-.18.34-2.57-3.58-1.86s-.39,4.77-.07,5.19Z"
            />
            <path
              class="cls-64"
              d="M739.11,669.95c1.4,4.64-1.22,6-2.22,6.3-.91.27-4.04,1.09-5.91-3.38-1.87-4.47-.16-6.59,1.88-7.32,2.04-.74,4.84-.24,6.24,4.4Z"
            />
            <path
              class="cls-67"
              d="M738.28,669.19c-.11.02-.22.01-.33.02-.13,0-.23.02-.34-.05-.06-.04-.08-.14-.05-.2.07-.15.23-.19.38-.2.17-.01.3.02.44.11.13.09.06.3-.09.32Z"
            />
            <path
              class="cls-67"
              d="M735.14,670.18c.11-.04.2-.1.3-.15.11-.06.21-.09.28-.21.03-.06,0-.16-.05-.2-.14-.09-.29-.05-.43.01-.15.07-.25.16-.32.32-.07.15.1.29.24.24Z"
            />
            <path
              class="cls-67"
              d="M735.73,670.67c-.52.11-.26,1.14.22,1.04.47-.1.22-1.13-.22-1.04Z"
            />
            <path
              class="cls-67"
              d="M738.02,669.98c.51-.16.8.86.33,1.01-.46.15-.75-.88-.33-1.01Z"
            />
            <path
              class="cls-67"
              d="M736.61,673.44c.09.06.19.15.31.14.11-.01.24-.09.33-.15,0,0,.02,0,.02.01-.06.14-.22.25-.38.26-.15,0-.25-.11-.31-.24,0-.02.01-.03.03-.02Z"
            />
            <path
              class="cls-67"
              d="M737.64,671.94s.19.46.25.68c0,.02-.05.05-.12.07,0,0,0,0,0,0-.38.17-.82.13-1.14-.13-.02-.02,0-.05.03-.04.35.14.7.11,1.05.03,0-.07-.35-.79-.32-.79.16-.01.44-.02.54-.02-.12-.3-.49-1.14-.7-1.69-.01-.03.04-.06.05-.03.44.79.66,1.21.93,1.85.02.05-.46.07-.56.06Z"
            />
            <g>
              <path
                class="cls-67"
                d="M737.71,672.53s-.1.37-.35.59c-.09.08-.2.14-.34.15-.27.03-.37-.2-.4-.41-.03-.18,0-.34,0-.34,0,0,.5.2,1.09,0Z"
              />
              <path
                class="cls-86"
                d="M737.35,673.12c-.09.08-.2.14-.34.15-.27.03-.37-.2-.4-.41.28-.08.61,0,.74.25Z"
              />
            </g>
            <path
              class="cls-67"
              d="M731.69,673.57c1.14-.42.3-4.08.19-4.53.08.28.53,1.75.66,1.77.03,0,.15-.07.34-.19h0c-.05-.17-.1-.35-.13-.54-.02-.08.09.17.24.47.06-.04.12-.08.19-.13-.11-.31-.22-.71-.26-1.15-.01-.15.23.46.54.96.72-.48,1.78-1.14,2.84-1.53.28-.11.53-.19.76-.25-.14-.43-.34-.87-.28-.79.19.25.34.51.45.74.12-.03.23-.06.34-.08-.17-.62-.78-1.49-.64-1.38.56.45.92,1,1.09,1.3.44-.06.58-.01.56-.13-.04-.2-.85-1.83-2.59-2.63-1.89-.88-4.88-.27-5.81,2.36,0,0-1.05,1.31-.79,2.79.25,1.47,1.65,3.17,2.3,2.93Z"
            />
            <g>
              <polygon
                class="cls-70"
                points="732.33 671.24 730.82 670.69 730.7 671.11 732.26 671.47 732.33 671.24"
              />
              <polygon
                class="cls-70"
                points="732.26 671.64 730.67 671.38 730.63 671.8 732.23 671.88 732.26 671.64"
              />
            </g>
            <g>
              <path
                class="cls-64"
                d="M731.83,673s-1.35-1.26-1.94-.75c-.59.51.63,2.49,1.48,2.62.85.13.98-.66.98-.66l-.53-1.21Z"
              />
              <path
                class="cls-64"
                d="M730.25,672.81s-.01.02,0,.02c.6.11,1,.56,1.31,1.05-.21-.17-.45-.24-.69.02-.01.01,0,.03.02.03.22-.1.39-.09.58.06.14.11.24.25.35.38.04.04.12,0,.09-.05,0,0,0,0,0-.01-.13-.71-.89-1.58-1.66-1.49Z"
              />
            </g>
            <g>
              <g>
                <g>
                  <path
                    class="cls-90"
                    d="M806.82,741.15c-.68.22-20.48-.08-21.21-.56-.09-.05-.1-1.84-.07-4.3l-.96-14.57,12.53.04.99,12.62s2.81,1.3,5.13,2.43c0,0,0,0,0,0,1.43.7,2.67,1.33,2.95,1.56.74.61,1.31,2.55.64,2.77Z"
                  />
                  <path
                    class="cls-87"
                    d="M806.82,741.15c-.68.22-20.48-.08-21.21-.56-.09-.05-.1-1.84-.07-4.3,4.89,1.09,17.93,2.86,18.32,1.83.15-.41-.16-.88-.63-1.31,1.43.7,2.67,1.33,2.95,1.56.74.61,1.31,2.55.64,2.77Z"
                  />
                </g>
                <path
                  class="cls-60"
                  d="M775.98,668.69s6.85,37.66,6.93,38.12c.01.06.04.76.07,1.89.2,6.21.38,25.59.38,25.59h14.89s-.67-22.95-1.23-28.3c-.71-6.83-8.39-37.29-8.39-37.29h-12.66Z"
                />
              </g>
              <path
                class="cls-90"
                d="M775.73,741.97c-.7-.13-17.94-9.88-18.35-10.64-.05-.09.79-1.67,1.99-3.81l5.46-13.62,11.04,5.84-4.56,12.12s1.85,2.48,3.34,4.59c0,0,0,0,0,0,.92,1.3,1.71,2.45,1.84,2.79.36.89-.07,2.87-.77,2.73Z"
              />
              <path
                class="cls-87"
                d="M775.73,741.97c-.7-.13-17.94-9.88-18.35-10.64-.05-.09.79-1.67,1.99-3.81,3.77,3.3,14.38,11.09,15.2,10.38.33-.29.28-.85.08-1.45.92,1.3,1.71,2.45,1.84,2.79.36.89-.07,2.87-.77,2.73Z"
              />
              <path
                class="cls-60"
                d="M758.5,725.45l14.03,6.59s9.16-20.29,9.76-28.21c.44-5.8.42-18.03.65-26.62,0,0,2.43-1.44,3.04-2.22.58-.74,1.17-3.61,2.38-6.31h-17.77c-4.25,8.25-1.05,11.92-1.05,13.72,0,8.68-.9,18.5-1.31,20.21-.87,3.57-9.73,22.84-9.73,22.84Z"
              />
            </g>
            <path
              class="cls-67"
              d="M777.6,634.67c-2.4,1.41-3.75,4.41-3.75,4.41,0,0-2.64,2.69-2.56,4.53.08,1.84,1.45,2.62,1.45,2.62l.06-.99s.3,1.37,2.23,2.39c1.93,1.02,4.81,1.08,6.4.72,1.6-.35,2.54-1.3,2.54-1.3l-.88,1.24s2.01.44,3.74-1.38c1.73-1.82-.9-5.74-1.02-6.47-.12-.73.73-5.61-4.51-6.07,0,0-2.05-.67-3.7.3Z"
            />
            <path
              class="cls-67"
              d="M772.04,645.91c-.42-.53-.82-1.11-.97-1.73-.16-.66-.12-1.35.16-1.97.34-.74.92-1.32,1.49-1.88.59-.58,1.22-1.13,1.79-1.72.03-.03-.02-.08-.05-.06-.59.39-1.13.87-1.67,1.33-.51.44-1.02.89-1.42,1.44-.36.5-.65,1.08-.68,1.7-.03.51.08,1.02.29,1.48.25.56.65.97,1.03,1.44.02.03.06,0,.04-.04Z"
            />
            <path
              class="cls-67"
              d="M787.81,644.83c-.15-1.92-1.45-3.44-2.02-5.22-.31-.97-.48-1.99-.97-2.89-.01-.02-.05,0-.04.02.39.79.51,1.66.73,2.5.22.86.59,1.66.97,2.46.69,1.45,1.53,3.17.87,4.79-.3.75-.98,1.49-1.83,1.52-.03,0-.03.06,0,.05.71-.1,1.31-.45,1.74-1.04.47-.64.63-1.43.57-2.21Z"
            />
            <path
              class="cls-67"
              d="M787.77,645.32c.21-.65.25-1.36.05-2.02-.2-.66-.64-1.21-1.1-1.71-.52-.58-1.08-1.15-1.32-1.91,0-.03-.06-.01-.05.02.36,1.26,1.43,2.08,2.01,3.21.66,1.29.27,2.83-.68,3.87-.58.64-1.34,1.1-2.15,1.4-.01,0,0,.03,0,.02,1.39-.48,2.74-1.41,3.22-2.87Z"
            />
            <path
              class="cls-23"
              d="M784.15,648.42c2.06,2.87,4.53,10.15,5.64,10.82,4.91,2.97,8.36,5.25,9.28,5.97,1.22.96-3.69,7.5-4.42,6.73-.51-.54-5.42-4.32-9.08-8.43-1.75-1.96-2.35-7.12-3.1-12.76-.46-3.44.73-3.65,1.67-2.33Z"
            />
            <path
              class="cls-23"
              d="M794.18,671.48c.54.76,2.96,2.87,5.04,4.19,1.01.64,4.1,2.17,4.65,1.43.55-.74-.31-1.26-.31-1.26,0,0,1.4.45,1.89-.34.49-.79-.88-1.57-.88-1.57,0,0,1.47.36,1.9-.47.43-.82-1.08-1.37-1.08-1.37,0,0,1.33.39,1.4-.44.08-.99-2.46-1.44-3.53-2.2-.25-.17-4.72-3.86-4.72-3.86l-4.34,5.89Z"
            />
            <path
              class="cls-23"
              d="M798.77,664.96s2.31.55,3.27,1.02c.96.47,3.9,3.52,3.28,4.19-.8.87-2.85-.56-3.76-1.39,0,0-1.86,2.01-3.55,1.3-1.69-.71.76-5.12.76-5.12Z"
            />
            <path
              class="cls-89"
              d="M791.66,672.49l6.34-8.5s-7.76-4.47-8.37-5.14c-.62-.67-3.25-6.74-4.85-9.73-1.61-2.99-2.83-1.64-2.74,1.24.09,2.88,1.62,11.88,2.41,13.28.79,1.4,7.22,8.84,7.22,8.84Z"
            />
            <path
              class="cls-84"
              d="M788.11,659.59l1.7,11.08s-17.07-.25-20.87-.58c0,0,4.15-16.24,8.56-21.57.1-.12.2-.24.3-.35.02-.03.04-.04.06-.07,2.06-2.21,4.59-1.56,6.3-.15.42.35,4.47,4.98,4.92,7.32.39,2.06-.97,4.31-.97,4.31Z"
            />
            <path
              class="cls-89"
              d="M788.11,659.59l1.7,11.08s-17.07-.25-20.87-.58c0,0,4.15-16.24,8.56-21.57.1-.12.2-.24.3-.35.02-.03.04-.04.06-.07,2.06-2.21,4.59-1.56,6.3-.15.42.35,4.47,4.98,4.92,7.32.39,2.06-.97,4.31-.97,4.31Z"
            />
            <path
              class="cls-23"
              d="M779.07,650.47c-.88,7.14-3.73,13.48-5.01,15.13-1.96,2.54-8.32,7.51-11.24,8.44-1.1.35-5.63-7.35-4.52-7.9,2.13-1.07,9.98-5.23,10.39-5.87.29-.44,4.21-5.6,6.77-9.51,3.17-4.84,3.84-2.16,3.61-.29Z"
            />
            <path
              class="cls-23"
              d="M749.49,677.31c.16.1.31.11.45.06-.13.79-.04,1.46.53,1.68.33.13.66,0,.96-.29,0,.4.15.69.53.77.66.14,1.61-1.04,2.42-2.32-.42.96-.6,1.83-.02,1.98,1.55.39,3.07-2.66,4.39-4.58.39-.57.93-1.25,1.43-1.63.09-.07.18-.13.27-.18.26-.14.51-.17.69-.01.33.28-.08,1.19-.52,1.68-.85.94-1.09,2.87-.51,3.41.85.79,2.51-1.62,3.29-2.32,1.05-.93,2.22-3.03,2.33-3.16,0,0-.45-.75-1.12-1.76-1.29-1.93-3.42-4.79-4.86-5.13,0,0-4.49,1.7-8.09,4.59-1.22.98-3.55,6.37-2.18,7.2Z"
            />
            <path
              class="cls-37"
              d="M770.07,669.93s-.06-.01-.09-.03l-7.14-5.67c-.06-.05-.07-.14-.02-.2.05-.06.14-.07.2-.02l7.14,5.67c.06.05.07.14.02.2-.03.04-.07.05-.11.05Z"
            />
            <path
              class="cls-37"
              d="M789.63,670.25c-.07,0-.13-.05-.14-.12l-1.54-10.67h.15c.58-.07.69-1.33.68-1.81,0-.08.06-.14.14-.15.09,0,.14.06.15.14,0,.19,0,1.81-.79,2.06l1.5,10.39c.01.08-.04.15-.12.16,0,0-.01,0-.02,0Z"
            />
            <path
              class="cls-37"
              d="M790.96,670.81s-.06,0-.09-.03c-.06-.05-.08-.14-.03-.2l5.49-7.33c.05-.06.14-.07.2-.03.06.05.08.14.03.2l-5.49,7.33s-.07.06-.11.06Z"
            />
            <path
              class="cls-37"
              d="M804.52,670.53c-1.32,0-2.52-.97-2.92-1.33-.76,1.18-3.17,1.22-3.27,1.23-.1,0-.14-.06-.14-.14,0-.08.06-.14.14-.14.03,0,2.56-.05,3.11-1.23l.09-.19.15.15s1.68,1.67,3.31,1.33c.08-.01.15.03.17.11.02.08-.03.15-.11.17-.17.04-.35.05-.52.05Z"
            />
            <path
              class="cls-37"
              d="M805.34,672.3h0c-2.01-.12-4.04-2.06-4.13-2.14-.06-.05-.06-.15,0-.2.06-.06.15-.06.2,0,.02.02,2.04,1.95,3.94,2.06.08,0,.14.07.13.15,0,.08-.07.13-.14.13Z"
            />
            <path
              class="cls-37"
              d="M804.58,674.2s-.04,0-.06-.01c-.03-.01-2.55-1.19-3.92-2.06-.07-.04-.09-.13-.04-.2.04-.07.13-.09.2-.04,1.35.86,3.86,2.03,3.89,2.04.07.03.1.12.07.19-.02.05-.08.08-.13.08Z"
            />
            <path
              class="cls-37"
              d="M803.42,675.98c-2.07,0-4.35-2.74-4.45-2.86-.05-.06-.04-.15.02-.2s.15-.04.2.02c.02.03,2.39,2.88,4.35,2.75.09,0,.15.06.15.13,0,.08-.06.15-.13.15-.05,0-.09,0-.14,0Z"
            />
            <path
              class="cls-37"
              d="M750.07,677.34s-.01,0-.02,0c-.08,0-.14-.08-.13-.16.02-.21.6-5.2,4.05-7.13.07-.04.16-.01.19.05.04.07.01.16-.06.19-3.32,1.86-3.9,6.86-3.9,6.91,0,.07-.07.13-.14.13Z"
            />
            <path
              class="cls-37"
              d="M751.6,678.65c-.08,0-.14-.06-.14-.14,0-.05-.01-4.92,3.84-7.08.07-.04.16-.01.19.05.04.07.01.16-.06.19-3.71,2.08-3.7,6.78-3.7,6.83,0,.08-.06.14-.14.14h0Z"
            />
            <path
              class="cls-37"
              d="M755.2,675.69s-.03,0-.05,0c-.07-.03-.11-.11-.09-.18.04-.1.92-2.48,2.21-3.21.07-.04.16-.01.2.05.04.07.01.16-.05.2-1.2.68-2.08,3.03-2.09,3.06-.02.06-.08.09-.13.09Z"
            />
            <path
              class="cls-37"
              d="M761.25,722.16s-.05,0-.07-.02c-.07-.04-.09-.13-.05-.2.09-.15,9.15-15.4,9.26-21.6.04-2.04.17-4.67.31-7.46.27-5.48.58-11.7.07-12.46-.9-1.33-1.73-7.24,1.04-10.04.06-.06.15-.06.2,0,.06.06.06.15,0,.2-2.61,2.65-1.84,8.43-1,9.68.53.79.34,5.52-.02,12.64-.14,2.79-.27,5.42-.31,7.45-.12,6.27-8.93,21.11-9.3,21.74-.03.04-.07.07-.12.07Z"
            />
            <path
              class="cls-37"
              d="M773.25,674.02c-.86,0-1.52-.21-1.56-.22-.08-.02-.12-.11-.09-.18.02-.08.11-.12.18-.09.02,0,1.84.58,3.33-.22.82-.44,1.4-1.21,1.72-2.3.02-.08.1-.12.18-.1.08.02.12.1.1.18-.34,1.17-.96,2-1.86,2.47-.66.35-1.38.46-1.99.46Z"
            />
            <path
              class="cls-37"
              d="M784.02,675.77s-.02,0-.02,0c-.08-.01-.13-.09-.12-.16l.79-4.87c.01-.08.09-.13.16-.12.08.01.13.09.12.16l-.79,4.87c-.01.07-.07.12-.14.12Z"
            />
            <path
              class="cls-37"
              d="M785.38,730.54c-.07,0-.14-.06-.14-.14,0-.29.18-28.66-2.08-32.43-.04-.07-.02-.16.05-.2.07-.04.16-.02.2.05,2.31,3.84,2.13,31.41,2.12,32.58,0,.08-.06.14-.14.14Z"
            />
            <path
              class="cls-37"
              d="M782.03,704.64s0,0-.01,0c-.08,0-.14-.07-.13-.15l2.04-27.12c0-.08.07-.15.15-.13.08,0,.14.07.13.15l-2.04,27.12c0,.08-.07.13-.14.13Z"
            />
            <path
              class="cls-67"
              d="M754.36,679.19c-.13-.05-.24-.14-.29-.26-.06-.12-.07-.26-.06-.39.02-.27.1-.53.18-.79.04-.13.09-.26.12-.39,0,0,0-.02,0-.03,0,0,0,0,0-.03,0-.03-.03-.04-.05-.03-.04.02-.03.02-.04.03,0,0-.01.02-.02.02l-.06.09-.1.18c-.14.23-.28.47-.43.69-.3.44-.65.89-1.11,1.12-.23.11-.49.12-.72,0-.23-.1-.33-.37-.27-.6l.08-.29-.21.22c-.16.16-.38.28-.6.29-.23.01-.45-.07-.57-.27-.12-.19-.18-.43-.21-.67-.02-.24-.02-.49.03-.71l.04-.17-.16.08c-.11.06-.29.03-.42-.06-.14-.08-.22-.21-.27-.38-.1-.32-.1-.68-.08-1.02.05-.7.24-1.34.46-2,.46-1.33,1.16-2.61,2.05-3.7-.94,1.05-1.71,2.28-2.19,3.62-.24.67-.42,1.36-.47,2.08-.02.36-.02.72.08,1.08.03.09.06.18.12.26.05.09.14.15.21.2.16.1.37.17.59.07l-.12-.09c-.06.26-.06.52-.04.77.03.25.09.51.24.74.07.11.18.21.31.27.13.05.26.07.4.07.27-.02.52-.15.71-.35l-.13-.07c-.04.15-.03.31.03.45.06.14.18.25.32.32.13.07.27.1.42.1.15,0,.29-.04.42-.11.51-.27.84-.74,1.14-1.19.15-.23.29-.47.42-.7l.1-.18c.02-.06.1-.13.02-.11-.02.13-.07.26-.1.39-.07.26-.15.53-.16.8,0,.14,0,.28.08.4.06.12.18.21.31.26Z"
            />
            <path
              class="cls-64"
              d="M755.13,674.03c.52-1.03,5.21.75,4.4,2.44s-4.99-1.28-4.4-2.44Z"
            />
            <path
              class="cls-64"
              d="M754.21,675.56c.52-1.03,5.21.75,4.4,2.44-.8,1.69-4.99-1.28-4.4-2.44Z"
            />
            <path
              class="cls-64"
              d="M753.33,676.26c.62-.86,4.63,1.41,3.66,2.83-.97,1.43-4.36-1.86-3.66-2.83Z"
            />
            <path
              class="cls-64"
              d="M752.29,676.76c.81-.63,3.9,2.61,2.6,3.66-1.3,1.05-3.52-2.95-2.6-3.66Z"
            />
            <path
              class="cls-67"
              d="M755.64,675.32c.26.07.5.19.74.3.26.12.52.24.76.38.23.14.47.28.69.44.23.17.44.38.68.55.03.02,0,.06-.03.04-.22-.17-.48-.3-.72-.44-.24-.14-.47-.28-.71-.42-.23-.14-.46-.28-.7-.41-.24-.13-.49-.25-.73-.4-.02-.01,0-.04.01-.04Z"
            />
            <path
              class="cls-67"
              d="M754.24,676.13c.24.2,1.1,1,1.35,1.19.25.19.5.38.76.56.26.18.52.39.79.55.03.01,0,.05-.02.04-.28-.16-.57-.3-.84-.47-.27-.17-.53-.36-.78-.56-.25-.2-1.11-1.04-1.3-1.29-.02-.02.02-.05.04-.03Z"
            />
            <path
              class="cls-67"
              d="M753.33,676.99c.28.32.54.66.83.98.14.16.28.32.42.47.07.08.13.16.2.23.07.08.15.2.23.26.02.02-.01.06-.04.03-.08-.1-.2-.17-.29-.26-.08-.07-.15-.14-.22-.21-.15-.15-.29-.31-.43-.47-.27-.32-.54-.65-.75-1.01-.02-.03.02-.06.04-.04Z"
            />
            <g>
              <path
                class="cls-67"
                d="M755.11,673.94c.41-.51,1.29-.31,1.83-.18.67.16,1.31.46,1.85.89.49.39,1.02.94.91,1.62-.1.59-.72.87-1.26.73-.03,0-.01-.05.02-.04.32.1.62-.04.85-.27.26-.27.28-.66.14-1-.26-.61-.94-1.05-1.51-1.34-.6-.31-1.29-.51-1.97-.52-.38,0-.95.16-.83.66.08.36.36.67.61.92,0,0,0,.03-.02.02-.39-.29-1.01-.98-.61-1.48Z"
              />
              <path
                class="cls-67"
                d="M754.48,675.21c.21-.07.44-.07.66-.03.11.02.21.05.32.09.06.02.11.04.17.07.06.02.15.09.06.07-.1-.02-.38-.1-.48-.11-.19-.03-.38-.03-.57.01-.08.02-.17.04-.24.09-.08.05-.13.12-.18.2-.11.19-.04.4.02.6,0,0-.01.01-.01,0-.08-.19-.15-.4-.13-.61.03-.2.2-.32.38-.38Z"
              />
              <path
                class="cls-67"
                d="M753.21,676.28c.1-.31.56-.39,1.01-.09,0,0,.03.03,0,.02-.35-.17-.64-.11-.78-.03-.14.09-.19.3-.19.46,0,.18.04.35.14.5,0,0,0,.01,0,0-.17-.24-.27-.58-.18-.86Z"
              />
              <path
                class="cls-67"
                d="M752.44,676.63c.33-.03.68.19.92.48.02.03.03.06,0,.03-.21-.21-.64-.51-.96-.41-.29.09-.32.46-.32.71,0,.65.33,1.21.64,1.76,0,.01-.01.02-.02.01-.22-.32-.4-.62-.55-.98-.13-.32-.23-.7-.19-1.05.03-.26.16-.53.45-.56Z"
              />
            </g>
            <path
              class="cls-64"
              d="M747.75,674.02c.5-.52.87-3.32,2.21-3.81.89-.32,1.62-.26,3.24.31,1.74.62,1.18,1.73.22,1.74-1.63.02-3.19-.17-3.19-.17-.39.72-.75,1.64-.75,1.64l-1.73.28Z"
            />
            <path
              class="cls-67"
              d="M749.88,671.96c.65.1,1.3.21,1.97.24.32.01,1.49.09,1.92-.1.36-.16.52-.49.34-.85-.14-.27-.41-.46-.66-.61-.54-.33-1.08-.43-1.73-.57-.03,0,0-.04.03-.03.67.11,1.31.21,1.9.55.47.27,1.03.9.58,1.44-.2.23-.5.31-.79.34-.4.04-.8.04-1.2.02-.79-.04-1.61-.15-2.36-.41-.01,0,0-.02,0-.02Z"
            />
            <path
              class="cls-89"
              d="M760.05,664.78l8.94,7.02s4.21-3.87,5.9-6.52c1.69-2.66,3.66-9.5,4.2-13.76.54-4.26-.29-5.2-3.19-1.67s-7.16,9.89-7.58,10.32c-.42.43-8.26,4.62-8.26,4.62Z"
            />
            <path
              class="cls-37"
              d="M770.58,670.42s-.08-.02-.11-.05c-.05-.06-.04-.15.02-.2.05-.04,4.69-3.91,5.5-7.46.82-3.61,2.46-8.12,2.48-8.17.03-.07.11-.11.18-.09.07.03.11.11.09.18-.02.04-1.65,4.54-2.47,8.13-.83,3.65-5.4,7.46-5.6,7.62-.03.02-.06.03-.09.03Z"
            />
            <path
              class="cls-23"
              d="M777.14,648.47s4.02,2.63,5.96,2.55c1.87-.07,2.03-2,2.03-2,0,0-1.91-2.74-4.33-2.43-2.03.26-3.67,1.88-3.67,1.88Z"
            />
            <path
              class="cls-23"
              d="M779.72,647.81c.12.3,1.91,2.09,3.32,1.81.46-.09.07-2.62.07-2.62v-.19s.21-2.71.21-2.71l-3.37-1.51-.48-.19s0,.74,0,1.67c0,.04,0,.09,0,.13,0,.05,0,.1,0,.15,0,.14,0,.28,0,.42,0,.11,0,.21,0,.32,0,.11,0,.22.01.34.05,1.11.2,2.25.25,2.38Z"
            />
            <path
              class="cls-85"
              d="M783.31,644.11l-.11,1.48c-1.45.85-3.12.54-3.7.39-.01-.18-.02-.36-.03-.54,0-.11,0-.22-.01-.34,0-.11,0-.22,0-.32,0-.14,0-.28,0-.42,0-.05,0-.1,0-.15v-.13c0-.92,0-1.67,0-1.67l.48.2,3.38,1.51Z"
            />
            <path
              class="cls-23"
              d="M775.72,640.91c.37,4.75,3.26,5.06,4.28,4.98.93-.07,4.08-.44,4.2-5.2.12-4.76-2.2-6.09-4.34-6.03-2.13.06-4.52,1.51-4.15,6.26Z"
            />
            <g>
              <path
                class="cls-67"
                d="M776.43,639.91c.11-.03.2-.07.31-.11.12-.04.22-.07.29-.17.04-.06.02-.16-.03-.2-.12-.11-.28-.09-.42-.04-.16.05-.27.13-.35.27-.09.13.06.3.2.26Z"
              />
              <path
                class="cls-67"
                d="M779.48,639.65c-.11,0-.22-.01-.33-.02-.13-.01-.23,0-.33-.09-.06-.04-.07-.15-.03-.2.09-.13.25-.16.4-.15.16,0,.29.06.41.16.12.11.02.3-.13.31Z"
              />
              <path
                class="cls-67"
                d="M779.2,640.31c.51-.1.67.94.19,1.03-.47.09-.62-.95-.19-1.03Z"
              />
              <path
                class="cls-67"
                d="M776.83,640.57c-.52.03-.42,1.07.06,1.04.48-.03.37-1.07-.06-1.04Z"
              />
              <path
                class="cls-67"
                d="M779.47,643.06c-.06.09-.12.21-.23.24-.11.03-.25,0-.36-.01-.01,0-.02.01-.01.02.11.11.3.15.44.09.14-.05.19-.19.19-.33,0-.02-.02-.02-.03,0Z"
              />
              <path
                class="cls-67"
                d="M779.14,642.44c-.16.29-.41.45-.69.52-.12.03-.26.05-.39.04-.03,0-.05,0-.07,0-.02,0-.04,0-.07,0-.04,0-.06-.03-.07-.07h0s0-.02,0-.03h0s0-.03,0-.03c-.02-.24-.02-.62-.02-.62-.09.05-.53.28-.53.16,0-1.06,0-2.23.21-3.29,0-.04.06-.03.06,0,.04,1.02-.09,2.03-.07,3.06.14-.06.37-.18.5-.19.04,0-.01.72,0,.83,0,0,0,0,0,.01.41.03.71-.12,1.09-.42.02-.02.05,0,.03.03Z"
              />
            </g>
            <path
              class="cls-67"
              d="M784.02,640.57c-.76.18-1.19-1.41-1.19-1.41,0,0-1.56.25-2.43-1.92,0,0,.2,1.04.98,1.75,0,0-2.8.13-4.32-2,0,0,.64,1.1,1.14,1.46,0,0-1.21-.14-1.92-1,0,0-.28,1.41-.59,1.83,0,0-.63-4.84,3.92-5.02,0,0,2.83-.25,4.18,1.81,1.35,2.06.22,4.49.22,4.49Z"
            />
            <g>
              <g>
                <path
                  class="cls-23"
                  d="M783.48,641.11s.78-1.64,1.51-1.38c.73.25.31,2.51-.42,2.93-.73.42-1.14-.25-1.14-.25l.05-1.3Z"
                />
                <path
                  class="cls-23"
                  d="M784.85,640.37s.02.01,0,.02c-.51.31-.71.87-.83,1.43.13-.23.33-.38.64-.23.02,0,0,.03,0,.03-.23-.01-.39.06-.51.26-.09.15-.13.32-.19.48-.02.05-.11.04-.1-.02,0,0,0,0,0-.01-.13-.7.25-1.76.99-1.96Z"
                />
              </g>
              <path
                class="cls-23"
                d="M783.99,642.54c.02.13.14.22.27.19s.22-.14.19-.27c-.02-.13-.14-.22-.27-.19-.13.02-.22.14-.19.27Z"
              />
            </g>
          </g>
        </g>
        <rect
          class="cls-5"
          x="753.31"
          y="604.64"
          width="6"
          height="111"
          rx=".29"
          ry=".29"
        />
        <g>
          <g class="cls-99">
            <g>
              <rect
                class="cls-24"
                x="516"
                y="431.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="516.5"
                  y1="431.14"
                  x2="516.5"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="523.73"
                  y1="431.14"
                  x2="523.73"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="530.95"
                  y1="431.14"
                  x2="530.95"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="538.18"
                  y1="431.14"
                  x2="538.18"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="545.4"
                  y1="431.14"
                  x2="545.4"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="552.63"
                  y1="431.14"
                  x2="552.63"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="559.85"
                  y1="431.14"
                  x2="559.85"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="567.08"
                  y1="431.14"
                  x2="567.08"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="574.31"
                  y1="431.14"
                  x2="574.31"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="581.53"
                  y1="431.14"
                  x2="581.53"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="588.76"
                  y1="431.14"
                  x2="588.76"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="595.98"
                  y1="431.14"
                  x2="595.98"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="603.21"
                  y1="431.14"
                  x2="603.21"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="610.44"
                  y1="431.14"
                  x2="610.44"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="617.66"
                  y1="431.14"
                  x2="617.66"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="624.89"
                  y1="431.14"
                  x2="624.89"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="632.11"
                  y1="431.14"
                  x2="632.11"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="639.34"
                  y1="431.14"
                  x2="639.34"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="646.56"
                  y1="431.14"
                  x2="646.56"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="653.79"
                  y1="431.14"
                  x2="653.79"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="661.02"
                  y1="431.14"
                  x2="661.02"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="668.24"
                  y1="431.14"
                  x2="668.24"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="675.47"
                  y1="431.14"
                  x2="675.47"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="682.69"
                  y1="431.14"
                  x2="682.69"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="689.92"
                  y1="431.14"
                  x2="689.92"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="697.15"
                  y1="431.14"
                  x2="697.15"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="704.37"
                  y1="431.14"
                  x2="704.37"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="711.6"
                  y1="431.14"
                  x2="711.6"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="718.82"
                  y1="431.14"
                  x2="718.82"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="726.05"
                  y1="431.14"
                  x2="726.05"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="733.27"
                  y1="431.14"
                  x2="733.27"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="740.5"
                  y1="431.14"
                  x2="740.5"
                  y2="655.14"
                />
              </g>
            </g>
            <g>
              <rect
                class="cls-24"
                x="516"
                y="655.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="516.5"
                  y1="655.14"
                  x2="516.5"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="523.73"
                  y1="655.14"
                  x2="523.73"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="530.95"
                  y1="655.14"
                  x2="530.95"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="538.18"
                  y1="655.14"
                  x2="538.18"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="545.4"
                  y1="655.14"
                  x2="545.4"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="552.63"
                  y1="655.14"
                  x2="552.63"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="559.85"
                  y1="655.14"
                  x2="559.85"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="567.08"
                  y1="655.14"
                  x2="567.08"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="574.31"
                  y1="655.14"
                  x2="574.31"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="581.53"
                  y1="655.14"
                  x2="581.53"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="588.76"
                  y1="655.14"
                  x2="588.76"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="595.98"
                  y1="655.14"
                  x2="595.98"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="603.21"
                  y1="655.14"
                  x2="603.21"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="610.44"
                  y1="655.14"
                  x2="610.44"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="617.66"
                  y1="655.14"
                  x2="617.66"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="624.89"
                  y1="655.14"
                  x2="624.89"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="632.11"
                  y1="655.14"
                  x2="632.11"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="639.34"
                  y1="655.14"
                  x2="639.34"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="646.56"
                  y1="655.14"
                  x2="646.56"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="653.79"
                  y1="655.14"
                  x2="653.79"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="661.02"
                  y1="655.14"
                  x2="661.02"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="668.24"
                  y1="655.14"
                  x2="668.24"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="675.47"
                  y1="655.14"
                  x2="675.47"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="682.69"
                  y1="655.14"
                  x2="682.69"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="689.92"
                  y1="655.14"
                  x2="689.92"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="697.15"
                  y1="655.14"
                  x2="697.15"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="704.37"
                  y1="655.14"
                  x2="704.37"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="711.6"
                  y1="655.14"
                  x2="711.6"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="718.82"
                  y1="655.14"
                  x2="718.82"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="726.05"
                  y1="655.14"
                  x2="726.05"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="733.27"
                  y1="655.14"
                  x2="733.27"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="740.5"
                  y1="655.14"
                  x2="740.5"
                  y2="879.14"
                />
              </g>
            </g>
          </g>
          <path
            class="cls-75"
            d="M681.31,716.14h-11.62c-.38,0-.69-.31-.69-.69v-110.62c0-.38.31-.69.69-.69h11.62c.38,0,.69.31.69.69v110.62c0,.38-.31.69-.69.69ZM670,715.14h11v-110h-11v110Z"
          />
        </g>
        <rect
          class="cls-4"
          x="830.5"
          y="604.64"
          width="12"
          height="111"
          rx=".19"
          ry=".19"
        />
        <g>
          <g class="cls-102">
            <g>
              <rect
                class="cls-24"
                x="677"
                y="431.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="677.5"
                  y1="431.14"
                  x2="677.5"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="684.73"
                  y1="431.14"
                  x2="684.73"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="691.95"
                  y1="431.14"
                  x2="691.95"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="699.18"
                  y1="431.14"
                  x2="699.18"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="706.4"
                  y1="431.14"
                  x2="706.4"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="713.63"
                  y1="431.14"
                  x2="713.63"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="720.85"
                  y1="431.14"
                  x2="720.85"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="728.08"
                  y1="431.14"
                  x2="728.08"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="735.31"
                  y1="431.14"
                  x2="735.31"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="742.53"
                  y1="431.14"
                  x2="742.53"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="749.76"
                  y1="431.14"
                  x2="749.76"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="756.98"
                  y1="431.14"
                  x2="756.98"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="764.21"
                  y1="431.14"
                  x2="764.21"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="771.44"
                  y1="431.14"
                  x2="771.44"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="778.66"
                  y1="431.14"
                  x2="778.66"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="785.89"
                  y1="431.14"
                  x2="785.89"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="793.11"
                  y1="431.14"
                  x2="793.11"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="800.34"
                  y1="431.14"
                  x2="800.34"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="807.56"
                  y1="431.14"
                  x2="807.56"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="814.79"
                  y1="431.14"
                  x2="814.79"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="822.02"
                  y1="431.14"
                  x2="822.02"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="829.24"
                  y1="431.14"
                  x2="829.24"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="836.47"
                  y1="431.14"
                  x2="836.47"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="843.69"
                  y1="431.14"
                  x2="843.69"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="850.92"
                  y1="431.14"
                  x2="850.92"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="858.15"
                  y1="431.14"
                  x2="858.15"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="865.37"
                  y1="431.14"
                  x2="865.37"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="872.6"
                  y1="431.14"
                  x2="872.6"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="879.82"
                  y1="431.14"
                  x2="879.82"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="887.05"
                  y1="431.14"
                  x2="887.05"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="894.27"
                  y1="431.14"
                  x2="894.27"
                  y2="655.14"
                />
                <line
                  class="cls-6"
                  x1="901.5"
                  y1="431.14"
                  x2="901.5"
                  y2="655.14"
                />
              </g>
            </g>
            <g>
              <rect
                class="cls-24"
                x="677"
                y="655.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="677.5"
                  y1="655.14"
                  x2="677.5"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="684.73"
                  y1="655.14"
                  x2="684.73"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="691.95"
                  y1="655.14"
                  x2="691.95"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="699.18"
                  y1="655.14"
                  x2="699.18"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="706.4"
                  y1="655.14"
                  x2="706.4"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="713.63"
                  y1="655.14"
                  x2="713.63"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="720.85"
                  y1="655.14"
                  x2="720.85"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="728.08"
                  y1="655.14"
                  x2="728.08"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="735.31"
                  y1="655.14"
                  x2="735.31"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="742.53"
                  y1="655.14"
                  x2="742.53"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="749.76"
                  y1="655.14"
                  x2="749.76"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="756.98"
                  y1="655.14"
                  x2="756.98"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="764.21"
                  y1="655.14"
                  x2="764.21"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="771.44"
                  y1="655.14"
                  x2="771.44"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="778.66"
                  y1="655.14"
                  x2="778.66"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="785.89"
                  y1="655.14"
                  x2="785.89"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="793.11"
                  y1="655.14"
                  x2="793.11"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="800.34"
                  y1="655.14"
                  x2="800.34"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="807.56"
                  y1="655.14"
                  x2="807.56"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="814.79"
                  y1="655.14"
                  x2="814.79"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="822.02"
                  y1="655.14"
                  x2="822.02"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="829.24"
                  y1="655.14"
                  x2="829.24"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="836.47"
                  y1="655.14"
                  x2="836.47"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="843.69"
                  y1="655.14"
                  x2="843.69"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="850.92"
                  y1="655.14"
                  x2="850.92"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="858.15"
                  y1="655.14"
                  x2="858.15"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="865.37"
                  y1="655.14"
                  x2="865.37"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="872.6"
                  y1="655.14"
                  x2="872.6"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="879.82"
                  y1="655.14"
                  x2="879.82"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="887.05"
                  y1="655.14"
                  x2="887.05"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="894.27"
                  y1="655.14"
                  x2="894.27"
                  y2="879.14"
                />
                <line
                  class="cls-6"
                  x1="901.5"
                  y1="655.14"
                  x2="901.5"
                  y2="879.14"
                />
              </g>
            </g>
          </g>
          <path
            class="cls-68"
            d="M842.31,716.14h-11.62c-.38,0-.69-.31-.69-.69v-110.62c0-.38.31-.69.69-.69h11.62c.38,0,.69.31.69.69v110.62c0,.38-.31.69-.69.69ZM831,715.14h11v-110h-11v110Z"
          />
        </g>
        <path
          class="cls-49"
          d="M718.06,617.42v-1.66h-1.19v-10.62h-.39v10.62h-1.19v1.66c-2.55,1.45-4.09,6.69-4.28,10.16h11.34c-.19-3.47-1.73-8.71-4.28-10.16Z"
        />
        <path
          class="cls-49"
          d="M801.7,617.24v-1.66h-1.19v-10.62h-.39v10.62h-1.19v1.66c-2.55,1.45-4.09,6.69-4.28,10.16h11.34c-.19-3.47-1.73-8.71-4.28-10.16Z"
        />
      </g>
      <g
        id="fenetre_bas_droit"
        data-name="fenetre bas droit"
      >
        <path
          class="cls-1"
          d="M1003.03,756.64h121.21c.14,0,.26.12.26.26v138.48c0,.14-.12.26-.26.26h-121.48c-.14,0-.26-.12-.26-.26v-138.21c0-.29.24-.53.53-.53Z"
        />
        <polygon
          class="cls-28"
          points="1086 876.14 1087.77 756.64 1124.5 756.9 1126.29 896.14 1086 876.14"
        />
        <polygon
          class="cls-25"
          points="1124.5 895.64 1080.42 874.81 1002.5 874.14 1002.5 895.46 1124.5 895.64"
        />
        <g>
          <g class="cls-103">
            <g>
              <rect
                class="cls-24"
                x="1127"
                y="654.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="1127.5"
                  y1="654.14"
                  x2="1127.5"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1134.73"
                  y1="654.14"
                  x2="1134.73"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1141.95"
                  y1="654.14"
                  x2="1141.95"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1149.18"
                  y1="654.14"
                  x2="1149.18"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1156.4"
                  y1="654.14"
                  x2="1156.4"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1163.63"
                  y1="654.14"
                  x2="1163.63"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1170.85"
                  y1="654.14"
                  x2="1170.85"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1178.08"
                  y1="654.14"
                  x2="1178.08"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1185.31"
                  y1="654.14"
                  x2="1185.31"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1192.53"
                  y1="654.14"
                  x2="1192.53"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1199.76"
                  y1="654.14"
                  x2="1199.76"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1206.98"
                  y1="654.14"
                  x2="1206.98"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1214.21"
                  y1="654.14"
                  x2="1214.21"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1221.44"
                  y1="654.14"
                  x2="1221.44"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1228.66"
                  y1="654.14"
                  x2="1228.66"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1235.89"
                  y1="654.14"
                  x2="1235.89"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1243.11"
                  y1="654.14"
                  x2="1243.11"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1250.34"
                  y1="654.14"
                  x2="1250.34"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1257.56"
                  y1="654.14"
                  x2="1257.56"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1264.79"
                  y1="654.14"
                  x2="1264.79"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1272.02"
                  y1="654.14"
                  x2="1272.02"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1279.24"
                  y1="654.14"
                  x2="1279.24"
                  y2="878.14"
                />
              </g>
            </g>
            <g>
              <rect
                class="cls-24"
                x="1127"
                y="878.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="1127.5"
                  y1="878.14"
                  x2="1127.5"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1134.73"
                  y1="878.14"
                  x2="1134.73"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1141.95"
                  y1="878.14"
                  x2="1141.95"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1149.18"
                  y1="878.14"
                  x2="1149.18"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1156.4"
                  y1="878.14"
                  x2="1156.4"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1163.63"
                  y1="878.14"
                  x2="1163.63"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1170.85"
                  y1="878.14"
                  x2="1170.85"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1178.08"
                  y1="878.14"
                  x2="1178.08"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1185.31"
                  y1="878.14"
                  x2="1185.31"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1192.53"
                  y1="878.14"
                  x2="1192.53"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1199.76"
                  y1="878.14"
                  x2="1199.76"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1206.98"
                  y1="878.14"
                  x2="1206.98"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1214.21"
                  y1="878.14"
                  x2="1214.21"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1221.44"
                  y1="878.14"
                  x2="1221.44"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1228.66"
                  y1="878.14"
                  x2="1228.66"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1235.89"
                  y1="878.14"
                  x2="1235.89"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1243.11"
                  y1="878.14"
                  x2="1243.11"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1250.34"
                  y1="878.14"
                  x2="1250.34"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1257.56"
                  y1="878.14"
                  x2="1257.56"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1264.79"
                  y1="878.14"
                  x2="1264.79"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1272.02"
                  y1="878.14"
                  x2="1272.02"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1279.24"
                  y1="878.14"
                  x2="1279.24"
                  y2="1102.14"
                />
              </g>
            </g>
            <g>
              <rect
                class="cls-24"
                x="902"
                y="654.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="902.5"
                  y1="654.14"
                  x2="902.5"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="909.73"
                  y1="654.14"
                  x2="909.73"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="916.95"
                  y1="654.14"
                  x2="916.95"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="924.18"
                  y1="654.14"
                  x2="924.18"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="931.4"
                  y1="654.14"
                  x2="931.4"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="938.63"
                  y1="654.14"
                  x2="938.63"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="945.85"
                  y1="654.14"
                  x2="945.85"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="953.08"
                  y1="654.14"
                  x2="953.08"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="960.31"
                  y1="654.14"
                  x2="960.31"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="967.53"
                  y1="654.14"
                  x2="967.53"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="974.76"
                  y1="654.14"
                  x2="974.76"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="981.98"
                  y1="654.14"
                  x2="981.98"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="989.21"
                  y1="654.14"
                  x2="989.21"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="996.44"
                  y1="654.14"
                  x2="996.44"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1003.66"
                  y1="654.14"
                  x2="1003.66"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1010.89"
                  y1="654.14"
                  x2="1010.89"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1018.11"
                  y1="654.14"
                  x2="1018.11"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1025.34"
                  y1="654.14"
                  x2="1025.34"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1032.56"
                  y1="654.14"
                  x2="1032.56"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1039.79"
                  y1="654.14"
                  x2="1039.79"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1047.02"
                  y1="654.14"
                  x2="1047.02"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1054.24"
                  y1="654.14"
                  x2="1054.24"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1061.47"
                  y1="654.14"
                  x2="1061.47"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1068.69"
                  y1="654.14"
                  x2="1068.69"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1075.92"
                  y1="654.14"
                  x2="1075.92"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1083.15"
                  y1="654.14"
                  x2="1083.15"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1090.37"
                  y1="654.14"
                  x2="1090.37"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1097.6"
                  y1="654.14"
                  x2="1097.6"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1104.82"
                  y1="654.14"
                  x2="1104.82"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1112.05"
                  y1="654.14"
                  x2="1112.05"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1119.27"
                  y1="654.14"
                  x2="1119.27"
                  y2="878.14"
                />
                <line
                  class="cls-6"
                  x1="1126.5"
                  y1="654.14"
                  x2="1126.5"
                  y2="878.14"
                />
              </g>
            </g>
            <g>
              <rect
                class="cls-24"
                x="902"
                y="878.14"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="902.5"
                  y1="878.14"
                  x2="902.5"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="909.73"
                  y1="878.14"
                  x2="909.73"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="916.95"
                  y1="878.14"
                  x2="916.95"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="924.18"
                  y1="878.14"
                  x2="924.18"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="931.4"
                  y1="878.14"
                  x2="931.4"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="938.63"
                  y1="878.14"
                  x2="938.63"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="945.85"
                  y1="878.14"
                  x2="945.85"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="953.08"
                  y1="878.14"
                  x2="953.08"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="960.31"
                  y1="878.14"
                  x2="960.31"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="967.53"
                  y1="878.14"
                  x2="967.53"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="974.76"
                  y1="878.14"
                  x2="974.76"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="981.98"
                  y1="878.14"
                  x2="981.98"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="989.21"
                  y1="878.14"
                  x2="989.21"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="996.44"
                  y1="878.14"
                  x2="996.44"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1003.66"
                  y1="878.14"
                  x2="1003.66"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1010.89"
                  y1="878.14"
                  x2="1010.89"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1018.11"
                  y1="878.14"
                  x2="1018.11"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1025.34"
                  y1="878.14"
                  x2="1025.34"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1032.56"
                  y1="878.14"
                  x2="1032.56"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1039.79"
                  y1="878.14"
                  x2="1039.79"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1047.02"
                  y1="878.14"
                  x2="1047.02"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1054.24"
                  y1="878.14"
                  x2="1054.24"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1061.47"
                  y1="878.14"
                  x2="1061.47"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1068.69"
                  y1="878.14"
                  x2="1068.69"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1075.92"
                  y1="878.14"
                  x2="1075.92"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1083.15"
                  y1="878.14"
                  x2="1083.15"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1090.37"
                  y1="878.14"
                  x2="1090.37"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1097.6"
                  y1="878.14"
                  x2="1097.6"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1104.82"
                  y1="878.14"
                  x2="1104.82"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1112.05"
                  y1="878.14"
                  x2="1112.05"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1119.27"
                  y1="878.14"
                  x2="1119.27"
                  y2="1102.14"
                />
                <line
                  class="cls-6"
                  x1="1126.5"
                  y1="878.14"
                  x2="1126.5"
                  y2="1102.14"
                />
              </g>
            </g>
          </g>
          <path
            class="cls-75"
            d="M1140.95,896.14h-16.19c-.42,0-.76-.34-.76-.76v-138.48c0-.42.34-.76.76-.76h16.19c.58,0,1.05.47,1.05,1.05v137.89c0,.58-.47,1.05-1.05,1.05ZM1125,895.14h15.95s.05-.02.05-.05v-137.89l-16-.05v138Z"
          />
        </g>
        <g
          id="personnage_droite"
          data-name="personnage droite"
        >
          <g>
            <path
              class="cls-72"
              d="M1096.31,805.61c6.56,8.24,10.51,19.63,10.38,22.3-.14,2.93-7.36,13.26-10.85,18.01-.45.61-3.06.27-5.24-1.08-2.3-1.43-4.15-3.92-3.67-4.63,1.79-2.66,9.58-13.16,9.58-14.81,0-1.52-3.1-10.93-4.24-16.36-1.09-5.21.99-7.27,4.04-3.44Z"
            />
            <path
              class="cls-78"
              d="M1098.3,845.93l-10.76-7.56s8.68-11.65,8.72-12.92c.04-1.26-2.97-11.26-4.08-15.87-1.11-4.61.34-9.65,5.54-2.58,5.2,7.07,8.8,17.41,9.26,20.16.46,2.75-8.69,18.77-8.69,18.77Z"
            />
            <path
              class="cls-65"
              d="M1099.46,843.51c-.36-.36-.81-.65-1.21-.97-.36-.29-.72-.58-1.09-.86-.8-.61-1.6-1.24-2.4-1.85-.8-.61-1.6-1.22-2.4-1.82-.8-.6-1.59-1.23-2.42-1.78-.03-.02-.07.03-.04.06.72.71,1.5,1.35,2.27,1.99.76.63,1.54,1.24,2.32,1.84.8.61,1.61,1.2,2.43,1.78.4.28.8.54,1.2.81.42.28.85.62,1.31.84.02.01.05-.02.03-.04Z"
            />
            <g>
              <g>
                <path
                  class="cls-72"
                  d="M1108.14,902.26s1.77,17.51,1.77,17.52c-.06,3.23-.17,6.07-.35,7.53,0,0,0,.02,0,.02-.07.55-.15.9-.24.99,0,0-.01.02-.02.02-.92.63-18.85.87-19.71.58-.86-.29-.13-2.9.81-3.71.95-.81,3.76-5.33,3.76-5.33l-1.62-17.5,15.6-.13Z"
                />
                <g>
                  <g>
                    <path
                      class="cls-65"
                      d="M1093.26,920.68c1.55-.58,3.55-.65,4.95.35.05.04,0,.12-.05.11-1.66-.26-3.18-.35-4.86-.25-.12,0-.15-.17-.04-.21Z"
                    />
                    <path
                      class="cls-65"
                      d="M1092.22,921.61c1.55-.58,3.55-.65,4.95.35.05.04,0,.12-.05.11-1.66-.26-3.18-.35-4.86-.25-.12,0-.15-.17-.04-.21Z"
                    />
                    <path
                      class="cls-65"
                      d="M1091.17,922.54c1.55-.58,3.55-.65,4.95.35.05.04,0,.12-.05.11-1.66-.26-3.18-.35-4.86-.25-.12,0-.15-.17-.04-.21Z"
                    />
                  </g>
                  <path
                    class="cls-84"
                    d="M1089.17,929.03c.86.3,19.19-.05,20.12-.68.36-.23.53-4.01.62-8.57,0-.05,0-.1,0-.14l-15.76-.03v.28s-3.21,4.63-4.16,5.44c-.94.81-1.67,3.41-.81,3.71Z"
                  />
                  <path
                    class="cls-60"
                    d="M1109.91,919.64v.15c-.09,4.56-.26,8.33-.62,8.57-.42.29-5.72.49-11.44.61-6.85.13-8.21.24-8.68.08-.86-.3-.12-2.9.82-3.71.95-.81,4.17-5.44,4.17-5.44v-.28s5.25,0,5.25,0l10.51.02Z"
                  />
                </g>
              </g>
              <path
                class="cls-65"
                d="M1111,919.95l-17.67-.14s-1.36-34.36-2.27-44.47c-1.14-12.65-2.59-44.22-2.59-44.22h15.03s3.42,7.73,1.26,16.33l2.2,31.04,4.04,41.45Z"
              />
            </g>
            <g>
              <g>
                <g>
                  <path
                    class="cls-65"
                    d="M1068.96,919.88c1.63-.25,3.6.09,4.8,1.36.05.05-.02.12-.07.1-1.58-.6-3.06-1-4.72-1.24-.12-.02-.12-.2,0-.22Z"
                  />
                  <path
                    class="cls-65"
                    d="M1067.77,920.58c1.63-.25,3.6.09,4.8,1.36.05.05-.02.12-.07.1-1.58-.6-3.06-1-4.72-1.24-.12-.02-.12-.2,0-.22Z"
                  />
                  <path
                    class="cls-65"
                    d="M1066.57,921.28c1.63-.25,3.6.09,4.8,1.36.05.05-.02.12-.07.1-1.58-.6-3.06-1-4.72-1.24-.12-.02-.12-.2,0-.22Z"
                  />
                </g>
                <path
                  class="cls-60"
                  d="M1059.38,928.94c.86.3,25.29.06,26.21-.58.36-.23.53-4.01.62-8.57,0-.05,0-.1,0-.14l-15.76-.03v.28s-9.3,4.52-10.25,5.33c-.94.81-1.67,3.41-.81,3.71Z"
                />
              </g>
              <path
                class="cls-65"
                d="M1095.55,848.89s-5.19,24.06-5.4,28.51c-.17,3.79-2.77,42.69-2.77,42.69l-18.35-.21s4.62-39.64,4.97-43.58c.65-7.38,4.65-27.55,9.31-45.53l19.79.35s-.32,9.46-4.49,16.23c0,0-1.85.87-3.04,1.55Z"
              />
            </g>
            <path
              class="cls-40"
              d="M1088.65,808.11c1.07.21,3.58-1.59,4.69-3.25.08-.11.04-1.42.06-3,.02-.96.06-2.03.16-3.01l-5.93.79s.35,2.11.16,3.81c-.02.14-.04.27-.08.4,0,.02-.01.04-.02.07-.23,2.43-.71,3.88.96,4.2Z"
            />
            <g>
              <path
                class="cls-20"
                d="M1091.78,802.14s0,0,0,0"
              />
              <path
                class="cls-40"
                d="M1094.55,790.59c.65,2.18-.39,8.49-1.85,9.9-2.11,2.06-5.59,2.28-7.24-.41-1.6-2.61-.11-10.81,1.51-12.1,2.4-1.9,6.62-.61,7.58,2.6Z"
              />
              <path
                class="cls-40"
                d="M1085.45,791.34s-.71,2.33-1.43,4.64l.77-.02-.28,1.05s.77.33,1.63-.16l-.69-5.52Z"
              />
              <g>
                <g>
                  <path
                    class="cls-65"
                    d="M1086.01,794.01s.03.03.02.04c-.1.42-.14.92.19,1.14.01,0,0,.03,0,.02-.43-.17-.36-.83-.2-1.21Z"
                  />
                  <path
                    class="cls-65"
                    d="M1086.46,793.65c.65.09.43,1.47-.18,1.38-.59-.09-.37-1.46.18-1.38Z"
                  />
                </g>
                <path
                  class="cls-65"
                  d="M1087.06,793.22c-.17-.08-.31-.18-.47-.28-.18-.11-.33-.18-.43-.38-.05-.11,0-.28.1-.34.22-.15.48-.07.7.05.24.13.39.3.5.56.1.25-.18.49-.4.39Z"
                />
                <path
                  class="cls-65"
                  d="M1085.97,798.08c-.11.08-.23.2-.38.19-.14-.01-.29-.11-.41-.19-.01,0-.03,0-.02.02.08.18.28.33.47.32.19,0,.3-.15.38-.32.01-.02-.02-.04-.04-.03Z"
                />
                <path
                  class="cls-65"
                  d="M1086.27,796.79c-.44.39-.82.52-1.46.32-.03,0-.04-.04-.03-.04.51.03.9-.02,1.47-.33.03-.02.04.02.01.05Z"
                />
              </g>
              <g>
                <path
                  class="cls-65"
                  d="M1085.71,786.56c-.77,1.34-.37,4.13,3.66,4.04,0,0-.42.93-.25,2.08.09.63.64.8.64.8-.16.52-.39,1.54-.33,1.64.2.3.56.24.59.24,0,0,2.51,3.7,3.62,3.44.62-1.34,3.39-5.42,2.47-8.38-.47-1.52-2.25-2.25-2.25-2.25-3.26-3.7-6.91-3.76-8.15-1.62Z"
                />
                <path
                  class="cls-65"
                  d="M1089.37,790.61c-.2.55-.39,1.1-.42,1.66-.02.27.02.55.16.77.15.22.4.34.66.45-.27-.02-.57-.1-.78-.35-.21-.24-.26-.59-.24-.89.02-.31.1-.6.21-.88.11-.27.25-.54.42-.77Z"
                />
                <path
                  class="cls-65"
                  d="M1093.86,788.19c.8.19,1.57.61,2.12,1.28.28.33.48.74.59,1.18.1.44.12.88.09,1.32-.07.88-.33,1.73-.66,2.52-.34.79-.76,1.55-1.26,2.24.43-.74.8-1.51,1.11-2.31.3-.8.54-1.63.6-2.47.03-.42.03-.85-.06-1.26-.09-.41-.28-.78-.52-1.12-.5-.66-1.23-1.11-2-1.39Z"
                />
              </g>
              <path
                class="cls-40"
                d="M1090.02,795.37s1.37-2.02,2.24-1.5c.87.52-.18,3.46-1.21,3.85-1.03.39-1.39-.61-1.39-.61l.36-1.74Z"
              />
            </g>
            <path
              class="cls-78"
              d="M1106.33,839.15c-.06.07-26.36.61-26.6.33-.34-.4,3.08-27.95,8.12-33.25,1.24-1.31,4.52-4.08,5.72-3,4.71,4.22,6.07,9.08,7.24,12.15.87,2.28,1.92,6.16,2.87,10.14,1.57,6.56,2.87,13.37,2.65,13.64Z"
            />
            <path
              class="cls-40"
              d="M1093.34,806.9c5.08,9.33,7.09,21.29,6.51,23.88-.63,2.86-6.06,12.22-10.29,16.26-.54.52-3.06-.3-4.98-2.04-2.03-1.84-3.44-4.63-2.85-5.24,2.21-2.29,8.23-11.72,8.51-13.34.26-1.5-1.24-11.34-1.45-16.89-.21-5.33,2.18-6.97,4.55-2.63Z"
            />
            <path
              class="cls-56"
              d="M1093.74,847.15l-11.09-9.09s7.1-10.4,7.35-11.64c.25-1.24-1.05-11.64-1.38-16.38-.33-4.74,1.94-9.44,5.88-1.51,3.94,7.93,5.76,18.78,5.76,21.57s-6.53,17.05-6.53,17.05Z"
            />
          </g>
          <path
            class="cls-65"
            d="M1082.48,838.35c-.06,0-.11-.02-.16-.06-.11-.09-.13-.27-.04-.39.08-.1,7.62-10.17,7.68-12.95.06-2.83-1.73-10.61-1.75-10.68-.03-.15.05-.3.19-.33.14-.04.28.05.31.2.07.32,1.83,7.93,1.76,10.83-.07,2.96-7.48,12.86-7.79,13.28-.05.07-.13.1-.2.1Z"
          />
          <path
            class="cls-65"
            d="M1097.04,839.73s-.09-.01-.13-.03c-.13-.07-.17-.24-.1-.38.04-.08,4.12-7.87,3.37-11.08-.78-3.32-2.66-11.72-2.67-11.81-.03-.15.05-.3.19-.33.14-.04.28.06.31.2.02.08,1.89,8.49,2.67,11.8.8,3.42-3.25,11.15-3.42,11.48-.05.09-.14.14-.23.14Z"
          />
          <path
            class="cls-65"
            d="M1105.08,832.04c-.11,0-.22-.08-.25-.2l-5.35-19.45c-.04-.15.04-.3.18-.34.14-.04.28.04.32.19l5.35,19.45c.04.15-.04.3-.18.34-.02,0-.05.01-.07.01Z"
          />
          <path
            class="cls-53"
            d="M1073.92,912.98s-.02,0-.02,0c-.14-.01-.25-.15-.24-.3.2-2.39,5-58.68,9.9-68.61.07-.14.22-.19.35-.12.13.07.18.24.11.37-4.85,9.84-9.79,67.82-9.84,68.41-.01.14-.13.25-.26.25Z"
          />
          <path
            class="cls-65"
            d="M1091.93,849.58c-.59,0-.94-.02-.95-.02-.14-.01-.25-.14-.24-.29,0-.15.14-.26.28-.26.05,0,4.88.33,9.51-1.56.13-.05.28.02.34.16.05.14-.02.3-.15.36-3.5,1.43-7.12,1.62-8.79,1.62Z"
          />
          <path
            class="cls-53"
            d="M1090.82,872.77s-.03,0-.05,0c-.14-.03-.23-.17-.2-.32l4.38-23.35c.03-.15.16-.25.31-.22.14.03.23.17.2.32l-4.38,23.35c-.02.13-.13.22-.25.22Z"
          />
          <path
            class="cls-53"
            d="M1095.81,913.96c-.13,0-.25-.11-.26-.25l-3.66-47.87c-.01-.15.1-.28.24-.3.14,0,.27.1.28.25l3.66,47.87c.01.15-.1.28-.24.3,0,0-.01,0-.02,0Z"
          />
        </g>
        <g id="panneau">
          <g>
            <polygon
              class="cls-10"
              points="1036.17 797.64 1019.17 817.54 1052.31 816.61 1036.17 797.64"
            />
            <g>
              <polygon
                class="cls-4"
                points="1054 836.35 1018.36 837.35 1017.9 817.57 1053.54 816.57 1054 836.35 1054 836.35"
              />
              <path
                class="cls-31"
                d="M1019.57,836.07v-.11s-.4-17.17-.4-17.17l33.18-.93.4,17.28-33.18.93ZM1019.38,819.01l.39,16.83,32.76-.92-.39-16.83-32.76.92Z"
              />
            </g>
            <path
              class="cls-56"
              d="M1037.2,796.99c0,.73-.53,1.31-1.19,1.31s-1.19-.59-1.19-1.31.53-1.31,1.19-1.31,1.19.59,1.19,1.31Z"
            />
          </g>
          <g>
            <path
              class="cls-31"
              d="M1027.33,824.03c.51,0,.99-.21,1.33-.57.36-.34.55-.81.53-1.29,0-.48-.22-.94-.6-1.26-.36-.33-.85-.51-1.36-.49l-3.12.09,1.12,2.02-.76,1.58.61-.02,1.53-3.18.66-.02s.03,0,.04,0l-1.53,3.18,1.53-.04ZM1026.65,823.56l1.21-2.52c.21.12.38.28.5.48.13.2.2.43.21.66,0,.34-.12.67-.35.92-.21.27-.54.43-.9.44l-.67.02ZM1024.99,820.96l1-.03-.48,1-.53-.97Z"
            />
            <path
              class="cls-31"
              d="M1031.94,822.91c-.03.16-.12.3-.25.4-.15.11-.33.16-.52.16-.22.01-.43-.06-.6-.19-.18-.17-.28-.4-.27-.64l2.3-.07s.01-.08.01-.12v-.14c0-.12-.02-.23-.06-.35-.03-.11-.08-.22-.14-.32-.13-.19-.31-.35-.52-.45-.24-.11-.5-.16-.77-.15-.14,0-.28.02-.41.06-.12.03-.24.08-.35.15-.22.12-.4.3-.51.51-.12.24-.18.51-.17.77,0,.14.02.28.06.41.04.12.09.24.16.35.12.21.31.37.53.48.24.11.51.16.77.15.12,0,.24-.02.36-.05.11-.03.22-.06.32-.11.19-.08.36-.21.48-.37.12-.16.2-.34.23-.53l-.66.02ZM1030.53,821.76c.16-.15.38-.23.6-.23.07,0,.15,0,.22.02.07.01.14.03.2.06.13.06.24.15.31.27.08.14.12.3.11.46l-1.7.05c0-.23.08-.45.25-.62Z"
            />
            <path
              class="cls-31"
              d="M1035.31,822.59c-.1-.1-.23-.18-.37-.23-.18-.06-.36-.1-.55-.13l-.23-.05c-.07-.01-.12-.03-.17-.04-.09-.02-.17-.06-.24-.12-.06-.05-.1-.13-.1-.21,0-.11.03-.21.12-.29.1-.08.23-.12.36-.11.16-.01.33.03.46.12.12.09.2.23.22.37l.58-.02c-.04-.26-.18-.5-.4-.67-.24-.17-.55-.25-.85-.23-.28,0-.56.08-.78.24-.18.14-.29.36-.27.59,0,.08.02.17.04.25.02.07.06.13.12.18.09.1.21.18.35.22.18.06.36.1.54.14.09.01.17.03.23.04s.12.03.17.04c.09.03.18.07.25.13.07.06.11.14.1.23,0,.1-.04.21-.12.28-.1.08-.22.12-.35.12-.18.02-.36-.03-.5-.12-.13-.09-.21-.22-.23-.37l-.6.02c.04.27.2.51.43.67.27.17.59.24.91.22.28,0,.54-.08.76-.24.18-.14.29-.36.27-.58,0-.09-.02-.17-.05-.25-.03-.07-.07-.14-.12-.2Z"
            />
            <rect
              class="cls-31"
              x="1036.07"
              y="820.95"
              width=".62"
              height="2.81"
              transform="translate(-22.98 29.83) rotate(-1.63)"
            />
            <path
              class="cls-31"
              d="M1036.33,820.47c.11,0,.21-.03.29-.1.07-.06.11-.15.1-.24,0-.09-.04-.18-.12-.24-.08-.06-.19-.1-.29-.09-.11,0-.21.04-.29.11-.07.07-.11.16-.1.25,0,.09.05.18.13.24.08.06.18.09.28.08Z"
            />
            <path
              class="cls-31"
              d="M1039.77,824.88c.21-.12.37-.29.48-.49.11-.22.16-.46.15-.7l-.08-2.84-.62.02.02.65c-.08-.2-.23-.37-.42-.49-.21-.12-.45-.18-.7-.17-.12,0-.25.02-.37.05-.11.03-.22.08-.32.15-.21.12-.37.3-.47.51-.11.24-.17.51-.15.77,0,.14.02.28.05.41.03.12.08.24.14.35.11.2.28.37.49.48.21.11.46.16.7.15.25,0,.49-.07.69-.21.18-.13.32-.31.39-.51l.02.68c.02.23-.06.46-.22.63-.16.15-.38.23-.6.23-.19.01-.39-.03-.56-.12-.15-.09-.25-.22-.3-.38l-.62.02c.06.3.25.56.51.74.3.19.66.28,1.03.25.14,0,.28-.02.41-.06.12-.03.24-.08.34-.14ZM1039.72,822.52c-.02.08-.05.16-.08.23-.07.14-.18.25-.32.33-.14.08-.3.13-.46.13-.25.02-.49-.07-.67-.23-.18-.18-.27-.43-.27-.68-.02-.25.06-.5.23-.69.17-.17.4-.27.65-.27.08,0,.17,0,.25.02.08.02.15.04.22.08.14.07.26.19.34.32.09.15.13.31.13.48,0,.09,0,.18-.02.27Z"
            />
            <path
              class="cls-31"
              d="M1043.3,821.99l.04,1.58.62-.02-.05-1.64c-.01-.39-.12-.69-.34-.89-.22-.21-.53-.31-.84-.29-.23,0-.45.07-.65.19-.19.12-.32.3-.39.51l-.02-.62-.62.02.08,2.81.62-.02-.04-1.5c-.02-.24.05-.47.2-.66.15-.15.36-.24.59-.24.21-.02.42.05.57.19.15.16.23.37.22.58Z"
            />
            <polygon
              class="cls-31"
              points="1026.72 828.24 1026.35 827.57 1027.49 825.21 1026.87 825.22 1026.02 826.99 1025.08 825.27 1024.46 825.29 1024.46 825.3 1024.56 828.9 1025.18 828.88 1025.11 826.47 1026.43 828.85 1027.05 828.83 1028.22 826.38 1028.29 828.8 1028.91 828.78 1028.81 825.17 1028.81 825.17 1028.19 825.19 1026.72 828.24"
            />
            <path
              class="cls-31"
              d="M1031.75,827.37c.02.24-.05.47-.2.66-.15.16-.36.24-.58.24-.21.02-.42-.05-.57-.19-.15-.16-.23-.37-.22-.58l-.04-1.57-.62.02.05,1.63c.01.39.12.69.34.9.22.21.53.31.84.29.23,0,.46-.07.66-.2.18-.12.32-.29.38-.49l.02.62.62-.02-.08-2.81-.62.02.04,1.49Z"
            />
            <path
              class="cls-31"
              d="M1035.22,827.39c-.1-.1-.23-.18-.37-.23-.18-.06-.36-.1-.55-.13l-.23-.05c-.07-.02-.12-.03-.17-.04-.09-.02-.17-.06-.24-.12-.06-.05-.1-.13-.1-.21,0-.11.03-.22.12-.29.1-.08.23-.12.36-.12.16-.01.33.03.46.12.12.09.2.23.22.37l.58-.02c-.04-.26-.18-.51-.4-.67-.24-.17-.55-.25-.85-.23-.28,0-.56.08-.78.24-.18.14-.29.36-.27.59,0,.08.02.17.04.25.02.07.06.13.12.18.09.1.21.18.35.22.17.05.35.09.53.12.09.02.16.03.23.05l.17.04c.09.03.18.07.25.13.07.06.11.15.1.24,0,.1-.04.21-.12.28-.1.08-.22.12-.35.12-.18.01-.36-.03-.5-.13-.13-.09-.21-.22-.23-.37l-.6.02c.04.27.2.51.43.67.27.17.59.24.91.22.27,0,.54-.08.76-.24.18-.14.29-.36.27-.58,0-.09-.02-.17-.05-.26-.03-.07-.06-.14-.11-.2Z"
            />
            <path
              class="cls-31"
              d="M1038.56,826.29c-.12-.19-.3-.35-.52-.45-.24-.11-.51-.16-.77-.15-.14,0-.27.02-.41.05-.12.03-.24.08-.35.15-.22.12-.4.3-.51.52-.12.24-.18.51-.17.77,0,.14.02.28.06.41.04.12.09.24.16.35.12.21.31.37.53.48.24.11.5.16.77.15.12,0,.24-.02.36-.05.11-.02.22-.06.32-.11.19-.08.36-.21.48-.37.12-.16.2-.34.24-.53l-.66.02c-.02.16-.12.3-.25.4-.15.11-.33.16-.52.16-.22.01-.43-.06-.6-.19-.18-.17-.28-.4-.27-.64l2.3-.07s.01-.08.01-.12,0-.08,0-.14c0-.12-.02-.23-.05-.34-.03-.11-.08-.22-.14-.32ZM1036.43,827.01c-.01-.23.08-.46.25-.63.16-.15.38-.23.6-.23.07,0,.15,0,.22.02.07.01.14.03.21.06.13.06.24.15.31.27.08.14.12.3.11.46l-1.69.05Z"
            />
            <path
              class="cls-31"
              d="M1041.49,827.1c.02.24-.05.47-.2.66-.15.16-.36.24-.58.24-.21.02-.42-.05-.57-.19-.15-.16-.23-.37-.22-.58l-.04-1.57-.62.02.05,1.63c.01.39.12.69.34.9.22.21.53.31.84.29.23,0,.46-.07.65-.2.18-.12.32-.29.38-.49l.02.62.62-.02-.08-2.81-.62.02.04,1.49Z"
            />
            <path
              class="cls-31"
              d="M1047.41,825.71c-.23-.21-.54-.32-.86-.29-.23,0-.46.07-.65.2-.19.12-.33.3-.41.5-.08-.2-.22-.37-.41-.49-.2-.11-.42-.17-.65-.16-.22,0-.44.06-.62.18-.18.12-.31.29-.37.48l-.02-.58-.62.02.08,2.81.62-.02-.04-1.5c-.02-.23.05-.46.2-.64.15-.15.36-.24.58-.23.2-.02.4.05.54.19.14.16.22.36.21.56l.04,1.58.62-.02-.04-1.5c-.02-.23.05-.46.2-.64.15-.15.36-.24.58-.23.2-.02.4.05.54.19.14.16.22.36.21.56l.04,1.58.62-.02-.05-1.64c-.02-.39-.13-.68-.35-.89Z"
            />
            <path
              class="cls-31"
              d="M1028.49,831.73v-.43s-2.7.08-2.7.08l.25.42.59,1.04h-.12c-.12,0-.25,0-.37-.02-.11-.02-.22-.06-.32-.11-.2-.09-.36-.24-.47-.42-.12-.21-.18-.45-.18-.69,0-.12,0-.24.03-.36.02-.11.06-.21.11-.31.09-.19.24-.35.42-.46.19-.11.41-.17.64-.18.24-.01.47.04.68.15.19.1.34.26.42.45l.65-.02c-.09-.34-.32-.64-.63-.85-.34-.21-.74-.31-1.15-.28-.18,0-.35.03-.52.07-.16.04-.31.1-.45.18-.28.16-.5.39-.64.66-.15.3-.22.62-.21.95,0,.17.03.33.07.49.04.15.11.29.19.42.16.27.39.49.68.63.31.15.65.23,1,.21l1.08-.03-.29-.51h0l-.05-.08-.53-.96.69-.02.86,1.55.62-.02-.87-1.56h.52Z"
            />
            <path
              class="cls-31"
              d="M1031.82,831c-.12-.19-.3-.35-.52-.45-.24-.11-.51-.16-.77-.15-.14,0-.27.02-.41.05-.12.03-.24.08-.35.14-.22.12-.4.3-.51.51-.12.24-.18.51-.16.78,0,.14.02.28.06.41.04.12.09.24.16.35.13.21.31.38.54.49.24.11.5.16.77.15.12,0,.24-.02.36-.04.11-.02.22-.06.32-.11.19-.08.35-.21.48-.37.12-.16.2-.34.24-.53l-.66.02c-.02.16-.12.3-.25.4-.15.1-.33.16-.51.16-.22.01-.43-.06-.6-.19-.18-.17-.28-.4-.27-.64l2.3-.07s.01-.08.01-.12,0-.08,0-.14c0-.12-.02-.23-.05-.35-.03-.11-.08-.21-.14-.31ZM1029.69,831.71c-.01-.23.08-.46.25-.63.16-.15.38-.23.6-.23.07,0,.15,0,.22.02.07.01.14.03.21.06.13.06.24.15.31.27.08.14.12.3.11.46l-1.7.06Z"
            />
            <path
              class="cls-31"
              d="M1034.24,830.27c-.23,0-.46.07-.65.19-.18.12-.32.3-.39.5l-.02-.61-.62.02.08,2.81.62-.02-.04-1.49c-.02-.24.05-.47.21-.66.15-.15.36-.24.58-.24.21-.02.42.05.57.19.15.16.23.37.22.58l.04,1.58.62-.02-.05-1.63c-.01-.39-.12-.69-.34-.9-.22-.21-.53-.32-.84-.31Z"
            />
            <path
              class="cls-31"
              d="M1037.05,832.46c-.08-.09-.11-.21-.1-.33l-.04-1.39.73-.02v-.5s-.74.02-.74.02l-.02-.7-.62.02.02.7h-.43s.01.51.01.51h.43s.04,1.37.04,1.37c0,.34.1.57.27.71.21.15.47.22.73.2h.38s-.01-.52-.01-.52h-.29c-.12.03-.25,0-.35-.07Z"
            />
          </g>
        </g>
        <path
          class="cls-49"
          d="M1038.39,766.79v-1.37h-1.15v-8.73h-.38v8.73h-1.15v1.37c-2.46,1.19-3.94,5.5-4.13,8.35h10.94c-.19-2.85-1.67-7.16-4.13-8.35Z"
        />
        <path
          class="cls-49"
          d="M1088.87,766.79v-1.37h-1.15v-8.73h-.38v8.73h-1.15v1.37c-2.46,1.19-3.94,5.5-4.13,8.35h10.94c-.19-2.85-1.67-7.16-4.13-8.35Z"
        />
      </g>
      <g
        id="fenêtre_bas_gauche"
        data-name="fenêtre bas gauche"
      >
        <rect
          class="cls-14"
          x="599.5"
          y="756.64"
          width="242"
          height="140"
          rx=".26"
          ry=".26"
        />
        <rect
          class="cls-8"
          x="604.5"
          y="761.14"
          width="232"
          height="135.5"
          rx=".26"
          ry=".26"
        />
        <path
          class="cls-49"
          d="M652.22,768.13v-1.15h-1.05v-7.33h-.35v7.33h-1.05v1.15c-2.25,1-3.6,4.62-3.78,7.01h10c-.17-2.39-1.52-6.01-3.78-7.01Z"
        />
        <path
          class="cls-49"
          d="M708.69,767.61v-1.15h-1.05v-7.33h-.35v7.33h-1.05v1.15c-2.25,1-3.6,4.62-3.78,7.01h10c-.17-2.39-1.52-6.01-3.78-7.01Z"
        />
        <path
          class="cls-49"
          d="M766.69,767.61v-1.15h-1.05v-7.33h-.35v7.33h-1.05v1.15c-2.25,1-3.6,4.62-3.78,7.01h10c-.17-2.39-1.52-6.01-3.78-7.01Z"
        />
        <g>
          <rect
            class="cls-73"
            x="646.32"
            y="781"
            width="33.76"
            height="25.59"
            transform="translate(1457 130.59) rotate(90)"
          />
          <rect
            class="cls-89"
            x="651.23"
            y="777.73"
            width="23.96"
            height="32.14"
          />
          <rect
            class="cls-81"
            x="654.46"
            y="787.53"
            width="17.49"
            height="12.54"
            transform="translate(1457 130.59) rotate(90)"
          />
          <path
            class="cls-73"
            d="M668.55,801.03c-.42.78-10.8-3.14-10.52-3.98.28-.85,8.11-1.55,8.8-2.69s-8.3-2.67-8.14-3.44c.16-.77,8.67-.09,8.83-.87.16-.77-8.96-2.12-8.35-3.28s8.18-.33,9.01,1.64c.83,1.97-3.75,1.84-3.88,3.14s4.89,1.56,4.25,3.66-7.23.59-6.61,2.41c.61,1.83,7.41,1.93,6.61,3.41Z"
          />
          <path
            class="cls-79"
            d="M660.61,800.93c-1.36.32-2.92-2.1-1.31-1.56,1.61.54,2.67,1.25,1.31,1.56Z"
          />
          <path
            class="cls-79"
            d="M666.73,797.86c-.07.68,1.93.56,1.95,0,.02-.56-1.88-.7-1.95,0Z"
          />
          <path
            class="cls-79"
            d="M659.17,793.8c.73,1.21,2.89.69,2.86.13-.02-.56-3.65-1.43-2.86-.13Z"
          />
        </g>
        <polygon
          class="cls-29"
          points="604.5 896.38 641.77 868.14 808.08 868.1 836.24 896.64 604.5 896.38"
        />
        <g>
          <g>
            <g>
              <path
                class="cls-41"
                d="M646.09,818.63c0,1.37-1.21,2.48-2.7,2.48s-2.7-1.11-2.7-2.48,1.21-2.48,2.7-2.48,2.7,1.11,2.7,2.48Z"
              />
              <rect
                class="cls-41"
                x="642.84"
                y="818.63"
                width="1.09"
                height="47.19"
              />
              <path
                class="cls-41"
                d="M640.32,865.82h6.13c.73,0,1.32.59,1.32,1.32h-8.78c0-.73.59-1.32,1.32-1.32Z"
              />
            </g>
            <g>
              <ellipse
                class="cls-41"
                cx="805.61"
                cy="818.63"
                rx="2.7"
                ry="2.48"
              />
              <rect
                class="cls-41"
                x="805.06"
                y="818.63"
                width="1.09"
                height="47.19"
              />
              <path
                class="cls-41"
                d="M802.54,865.82h6.13c.73,0,1.32.59,1.32,1.32h-8.78c0-.73.59-1.32,1.32-1.32Z"
              />
            </g>
            <g>
              <path
                class="cls-41"
                d="M700.16,818.63c0,1.37-1.21,2.48-2.7,2.48s-2.7-1.11-2.7-2.48,1.21-2.48,2.7-2.48,2.7,1.11,2.7,2.48Z"
              />
              <rect
                class="cls-41"
                x="696.92"
                y="818.63"
                width="1.09"
                height="47.19"
              />
              <path
                class="cls-41"
                d="M694.4,865.82h6.13c.73,0,1.32.59,1.32,1.32h-8.78c0-.73.59-1.32,1.32-1.32Z"
              />
            </g>
            <g>
              <ellipse
                class="cls-41"
                cx="751.54"
                cy="818.63"
                rx="2.7"
                ry="2.48"
              />
              <rect
                class="cls-41"
                x="750.99"
                y="818.63"
                width="1.09"
                height="47.19"
              />
              <path
                class="cls-41"
                d="M748.47,865.82h6.13c.73,0,1.32.59,1.32,1.32h-8.78c0-.73.59-1.32,1.32-1.32Z"
              />
            </g>
          </g>
          <path
            class="cls-41"
            d="M724.5,834.88c-14.79,0-27.26-6.06-27.26-9.86h.45c0,3.15,11.59,9.45,26.81,9.45s26.81-6.3,26.81-9.45h.45c0,3.8-12.48,9.86-27.26,9.86Z"
          />
          <path
            class="cls-41"
            d="M670.43,834.88c-14.79,0-27.26-6.06-27.26-9.86h.45c0,3.15,11.59,9.45,26.81,9.45s26.81-6.3,26.81-9.45h.45c0,3.8-12.48,9.86-27.26,9.86Z"
          />
          <path
            class="cls-41"
            d="M778.57,834.88c-14.79,0-27.26-6.06-27.26-9.86h.45c0,3.15,11.59,9.45,26.81,9.45s26.81-6.3,26.81-9.45h.45c0,3.8-12.48,9.86-27.26,9.86Z"
          />
        </g>
        <rect
          class="cls-5"
          x="718.5"
          y="762.64"
          width="5"
          height="135"
          rx=".26"
          ry=".26"
        />
        <g
          id="personnage_bas"
          data-name="personnage bas"
        >
          <path
            class="cls-83"
            d="M675.36,800.4c-3.52,5.94-7.77,13.22-11.43,20.34-1.6,3.11-5.14,9.57-6.16,11.38-1.25,2.23,10.41,6.07,11.12,4.46.46-1.04,2.56-7.2,4.21-12.45,2.12-6.74,5.49-15.57,5.7-21.97.19-5.72-2.08-4.07-3.44-1.77Z"
          />
          <g>
            <path
              class="cls-83"
              d="M658.42,831.09c-.72,1.03-3.67,6.09-4.16,7.66-.49,1.57-1.57,6.21-.4,6.7,1.17.5,1.59-.83,1.59-.83,0,0-.15,2.03,1.07,2.42,1.22.39,1.81-1.7,1.81-1.7,0,0,0,2.09,1.25,2.4,1.25.31,1.49-1.9,1.49-1.9,0,0-.09,1.91,1.04,1.73,1.36-.22,1.13-3.77,1.8-5.46.15-.39,3.65-7.59,3.65-7.59l-9.14-3.44Z"
            />
            <path
              class="cls-83"
              d="M668.38,833.1s.81,3.18.86,4.65c.05,1.47-1.79,7.03-3.01,6.7-1.58-.43-1.15-3.84-.72-5.49,0,0-3.65-.98-3.88-3.5-.22-2.52,6.75-2.36,6.75-2.36Z"
            />
          </g>
          <path
            class="cls-22"
            d="M667.73,810.16l9.1,3.1s2.13-7.15,2.63-11.64c.49-4.49-1.04-6.19-5.12-.99-4.07,5.2-6.61,9.53-6.61,9.53Z"
          />
          <path
            class="cls-22"
            d="M667.73,810.16l9.1,3.1s2.13-7.15,2.63-11.64c.49-4.49-1.04-6.19-5.12-.99-4.07,5.2-6.61,9.53-6.61,9.53Z"
          />
          <path
            class="cls-65"
            d="M676.85,811.54c-1.23-.55-2.48-1.08-3.75-1.57-.62-.24-1.24-.49-1.87-.72-.65-.24-1.31-.43-1.96-.67-.05-.02-.08.05-.03.07.62.25,1.21.55,1.83.81.63.26,1.28.51,1.92.76,1.26.49,2.54.96,3.83,1.39.04.01.06-.04.03-.06Z"
          />
          <path
            class="cls-50"
            d="M669.36,810.72l7.47,2.55s2.13-7.15,2.63-11.64c.28-2.52-.09-4.17-1.18-4.19-2.02,2.94-6.66,9.71-8.92,13.29Z"
          />
          <path
            class="cls-83"
            d="M687.86,800.21c7.71,6.32,15.37,14.09,15.02,17.12-.47,4.08-6.68,11.98-9.85,15.92-.93,1.16-9.78-6.28-8.79-7.51,1.2-1.5,8.39-8.96,8.46-9.14.15-.38-5.82-10.81-7.11-13.23-2.15-4.04-1.15-5.95,2.27-3.15Z"
          />
          <path
            class="cls-26"
            d="M687.97,838.91c2.1-1.3,5.36-5.64,5.74-6.98.38-1.35-6.81-7.13-8.2-6.8-1.4.33-8.13,5.26-8.98,7.63-.84,2.37,9.26,7.49,11.44,6.15Z"
          />
          <g>
            <path
              class="cls-26"
              d="M678.56,829.37c1.31-.01.57,1.54.57,1.54,0,0,1.59-1.98,2.95-1.47,1.3.49.35,2.33.29,2.47.09-.1,1.6-1.88,2.91-1.23,1.36.68.09,2.36,0,2.47.11-.07,1.6-1.01,2.48-.29,1.51,1.24-2.22,3.74-2.46,5.3,0,0,2.61.71,2.68.75,0,0-3.51,2.45-5.6,2.01-1.1-.23-1.1-1.31-1.1-1.31,0,0-1.04.92-2.09.44-.54-.25-.62-1.33-.62-1.33,0,0-.87.7-1.77.21-.72-.38-.69-1.41-.69-1.41,0,0-1.14.28-1.75-.35-1.23-1.27,1.41-7.78,4.21-7.81Z"
            />
            <g>
              <path
                class="cls-65"
                d="M676.08,837.36s-.04.02-.04,0c.35-2.35,1.45-4.83,3.12-6.54.05-.06.17,0,.12.08-1.39,2.09-2.45,4.06-3.21,6.46Z"
              />
              <path
                class="cls-65"
                d="M678.53,838.74s-.05.01-.05-.02c.37-2.42,1.69-5.17,3.85-6.92.07-.06.2-.04.12.04-1.35,1.27-3.25,4.73-3.92,6.9Z"
              />
              <path
                class="cls-65"
                d="M685.47,833.07c-2,1.75-3.25,3.97-4.19,6.43-.01.03-.06.01-.05-.02.14-1.33.9-2.84,1.6-3.96.67-1.07,1.48-1.91,2.59-2.53.04-.02.1.03.06.07Z"
              />
            </g>
            <path
              class="cls-65"
              d="M679.13,830.9c.34-.35.71-.67,1.11-.95.4-.27.84-.51,1.29-.54.22-.01.44.05.61.18.17.14.31.32.39.52.16.4.06.89-.14,1.27l-.51.95.8-.71c.35-.31.77-.59,1.2-.77.43-.18.9-.24,1.28-.06.4.19.62.56.54.99-.06.43-.31.87-.59,1.22l-.79,1,1.07-.68c.29-.18.62-.34.95-.45.33-.1.68-.15.98-.06.29.09.54.34.57.63.04.3-.09.65-.25.97-.33.64-.8,1.23-1.24,1.82-.22.3-.44.6-.65.91-.2.31-.42.64-.47,1.01.09-.36.34-.66.56-.95.23-.29.47-.57.72-.85.49-.56.97-1.13,1.36-1.8.18-.34.36-.71.33-1.15-.04-.46-.4-.83-.81-.96-.42-.13-.84-.07-1.22.04-.38.12-.73.27-1.07.48l.28.32c.34-.42.62-.87.72-1.44.05-.28,0-.6-.15-.87-.16-.27-.39-.45-.65-.57-.54-.25-1.15-.14-1.62.07-.49.22-.91.51-1.3.87l.3.23c.24-.49.32-1.06.1-1.57-.11-.25-.3-.46-.51-.62-.22-.17-.52-.23-.78-.2-.54.06-.97.36-1.35.67-.39.31-.73.67-1.03,1.06Z"
            />
          </g>
          <g>
            <path
              class="cls-26"
              d="M684.21,825.77s-10.36,1.56-7.77,5.31c.77,1.11,5.27,4.77,6.02,3.88.97-1.15-.62-3.02-1.81-4.04,0,0,3.6-.03,4.32-2.55.45-1.58-.77-2.6-.77-2.6Z"
            />
            <path
              class="cls-65"
              d="M676.24,830.75c.23.48.59.89.95,1.29.36.39.76.75,1.17,1.09.83.67,1.68,1.32,2.63,1.84.24.13.49.25.79.32.15.03.32.05.49,0,.08-.02.16-.04.25-.1.08-.05.15-.11.2-.17.22-.26.3-.58.3-.88,0-.3-.08-.59-.19-.85-.21-.53-.54-.98-.9-1.39-.36-.41-.76-.78-1.16-1.13l-.12.33c.42-.02.82-.08,1.22-.17.4-.09.78-.22,1.15-.39.37-.17.71-.4,1.01-.67.3-.27.55-.6.72-.96-.22.33-.49.62-.81.86-.31.24-.66.41-1.02.56-.36.14-.74.25-1.12.31-.38.07-.78.1-1.15.1h-.48s.35.33.35.33c.38.36.76.72,1.09,1.12.33.4.64.82.81,1.28.17.44.23.98-.04,1.29-.21.29-.76.09-1.2-.13-.46-.23-.9-.52-1.35-.8-.44-.29-.88-.58-1.31-.89-.83-.64-1.68-1.29-2.29-2.16Z"
            />
          </g>
          <path
            class="cls-22"
            d="M697.27,807.22l-8.06,5.25s-3.83-6.41-5.41-10.64c-1.58-4.23-.51-6.25,4.72-2.22,5.23,4.04,8.75,7.61,8.75,7.61Z"
          />
          <path
            class="cls-21"
            d="M697.27,807.22l-8.06,5.25s-3.83-6.41-5.41-10.64c-1.58-4.23-.51-6.25,4.72-2.22,5.23,4.04,8.75,7.61,8.75,7.61Z"
          />
          <path
            class="cls-65"
            d="M688.77,810.8c1.06-.84,2.14-1.66,3.24-2.44.54-.39,1.08-.78,1.63-1.16.57-.39,1.16-.74,1.73-1.13.04-.03.09.03.05.06-.53.4-1.04.83-1.57,1.23-.55.41-1.12.8-1.67,1.2-1.1.79-2.23,1.55-3.37,2.29-.03.02-.07-.02-.04-.05Z"
          />
          <path
            class="cls-26"
            d="M668.74,916c0,1.12-.01,2.23,0,3.3,0,.67-1.6,6.55-1.43,8.69.1,1.27,19.84.85,20.84.55.99-.3-1.26-8.82-1.26-8.82l.17-3.3.79-15.03-18.83-.43s-.22,7.74-.27,15.04Z"
          />
          <g>
            <path
              class="cls-32"
              d="M667.31,928c.1,1.27,19.85.84,20.84.54.99-.3-1.26-8.82-1.26-8.82l.13-2.44h-18.27c0,.68,0,1.36,0,2.03,0,.67-1.6,6.55-1.43,8.7Z"
            />
            <path
              class="cls-32"
              d="M688.55,928.43c-2.6.39-17.63,1.13-21.42-.43"
            />
            <path
              class="cls-48"
              d="M667.31,928c.06.79,7.85.92,13.89.84-1.35-3.74-3.17-8.81-4.2-11.56h-8.26c0,.68,0,1.36,0,2.03,0,.66-1.61,6.55-1.43,8.69Z"
            />
          </g>
          <path
            class="cls-84"
            d="M688.58,916.85c.2-.1.24-26.05-.18-39.52-.29-9.26-.26-51.05-.17-53.18,0-.02-19.21,0-19.21,0,0,0-3.88,9.79-3.34,13.23,0,0,3.46,38.85,3.19,43.1-.47,7.57-.97,36.61-1.34,36.8l21.04-.42Z"
          />
          <g>
            <path
              class="cls-65"
              d="M668.65,912.64c1.23-.09,6.09-.24,7.29-.28,2.46-.08,10.17.01,11.57.11.05,0,.06.09,0,.09-2.41.28-4.85.36-7.28.41-2.46.05-10.86-.16-11.58-.21-.06,0-.08-.12-.01-.12Z"
            />
            <path
              class="cls-65"
              d="M685.01,844.36c.05-6.13.14-12.27.42-18.39,0-.1.15-.09.15,0,.12,10.93-.06,21.86-.05,32.79,0,10.87.14,21.74.3,32.61.09,6.13.26,12.26.24,18.39,0,.04-.06.04-.06,0-.34-5.46-.46-10.93-.61-16.39-.15-5.46-.23-10.93-.3-16.39-.14-10.87-.17-21.74-.08-32.61Z"
            />
          </g>
          <path
            class="cls-83"
            d="M657.41,911.82c-1.93,2.17-3.34,4.8-3.28,5.2.5,3.09,4.13,4.21,8.83,8.3,4.7,4.09,7.79,7.5,10.69,8.82,3.2,1.45,4.1-4.51,3.73-5.86-.15-.55-1.43-5.28-2.04-8.41-.16-.8.44-2.46.44-2.46l6.53-12.98-16.31-8.99s-8.17,15.92-8.59,16.39Z"
          />
          <g>
            <path
              class="cls-21"
              d="M654.14,917.02c.5,3.1,4.13,4.21,8.83,8.31,4.7,4.1,7.8,7.5,10.69,8.82,3.19,1.45,4.1-4.51,3.73-5.86-.16-.55-1.43-5.28-2.04-8.42-.06-.31,0-.76.09-1.19h0c.06-1.21-9.51-8.85-10.17-9.04-.41-.12-3.47-1.25-5.75-1.68-1.12,2.13-1.97,3.72-2.1,3.86-1.93,2.17-3.34,4.79-3.28,5.2Z"
            />
            <path
              class="cls-62"
              d="M654.14,917.02c.5,3.1,4.13,4.21,8.83,8.31,4.7,4.1,7.8,7.5,10.69,8.82,1.12.51,1.96.11,2.56-.69.76-1.79-11.35-13.6-14.54-15.91-3.33-2.4-5.89-3.06-7.13-1.59-.28.54-.43.93-.4,1.06Z"
            />
          </g>
          <path
            class="cls-84"
            d="M675.53,875.27c-.07.28-16.07,31.22-16.07,31.22l19.15,8.58s15.45-31.89,15.45-36.68c0-3.08,3.41-18.9,2.55-39.87-.19-4.55-2.95-12-3.28-14.37h-20.79s1.3,9.72,6.09,17.35c0,0-2.64,31.99-3.12,33.77Z"
          />
          <path
            class="cls-26"
            d="M679.08,797.75c.18.43.72,2.47,2.76,2.19,1.91-.26,2.08-3.42,2.08-3.42l.02-.28.22-3.89-4.87-2.1-.7-.27s.01,1.07.04,2.4c0,.06,0,.12,0,.19,0,.08,0,.15,0,.22,0,.2,0,.4.01.6,0,.15,0,.3.02.46,0,.16.02.32.02.48.1,1.6.33,3.23.4,3.41Z"
          />
          <path
            class="cls-65"
            d="M678.62,792.38c1.57,2.8,4.15,3.63,5.31,3.85l.22-3.89-4.87-2.1-.7-.27s.01,1.07.04,2.4Z"
          />
          <path
            class="cls-26"
            d="M687.75,786.25c1.56,6.65-2.22,8.4-3.69,8.67-1.31.24-5.78,1.17-8.01-5.29-2.23-6.46.37-9.28,3.31-10.13,2.94-.85,6.83.1,8.39,6.75Z"
          />
          <path
            class="cls-21"
            d="M693.34,824.15s-18.59.4-24.31,0c0,0,2.38-17.96,7.65-25.25,2.66-3.68,8.33-3.64,10.55,1.76,4.96,12.07,6.11,23.49,6.11,23.49Z"
          />
          <path
            class="cls-65"
            d="M684.99,779.26s-4.18-2.41-7.97-.15c-3.79,2.26-5.69,7.98-5.14,12.82.55,4.84-3.44,7.95-3.93,11.53-.49,3.58,1.83,5.28,2.58,7.18.86,2.17-2.9,9.75,6.28,11.7,11.49,2.44,16.03-4.57,14.97-10.46-.52-2.88-2.1-4.95-2.03-7.28.07-2.32,1.75-4.14.95-7.11-.8-2.96-1.94-2.58-2.32-7.22-.38-4.63.68-10.15-3.39-11.01Z"
          />
          <path
            class="cls-65"
            d="M677.82,779.01c-2.53,1.58-4.44,3.83-5.58,6.46-.58,1.33-.94,2.74-1.06,4.18-.15,1.88.1,3.65-.63,5.47-1.18,2.91-3.47,5.31-3.43,8.58.02,1.51.47,2.99,1.31,4.28.97,1.49,2.37,2.68,3.17,4.28.03.07.14.01.11-.05-.67-1.42-1.78-2.51-2.69-3.78-1.09-1.52-1.69-3.32-1.61-5.16.15-3.1,2.41-5.44,3.5-8.25.49-1.27.55-2.51.53-3.85-.02-1.59.18-3.14.69-4.66,1-2.99,3.06-5.56,5.73-7.44.02-.02,0-.06-.03-.04Z"
          />
          <path
            class="cls-65"
            d="M672.31,814.16s-.01.02,0,.02c.01,0,.01-.02,0-.02Z"
          />
          <path
            class="cls-65"
            d="M691.76,811.04c-.26-1.39-.97-2.66-1.23-4.05-.32-1.67.13-3.32.48-4.95.5-2.32.49-4.53-.5-6.74-.64-1.43-1.42-2.78-1.89-4.28-.5-1.63-.77-3.33-.79-5.03,0-.04-.06-.04-.06,0-.06,2.5.36,4.87,1.41,7.18.6,1.32,1.36,2.57,1.7,3.99.4,1.71.2,3.35-.13,5.05-.22,1.13-.48,2.28-.49,3.44-.01,1.2.35,2.28.75,3.41,1.05,2.93.97,5.92-.22,8.8-.02.05.07.09.09.04.98-2.16,1.31-4.53.87-6.85Z"
          />
          <path
            class="cls-65"
            d="M667.65,803.03c.15-2.55,1.96-4.26,3.09-6.45.85-1.66,1.44-3.43,1.2-5.28,0-.03-.06-.02-.06,0,.09,2.67-1.08,5.07-2.6,7.28-1.01,1.47-1.85,2.88-1.89,4.67-.04,1.75.63,3.24,1.6,4.71.69,1.05,1.37,2.02,1.65,3.25.28,1.22.19,2.5.1,3.73,0,.06.1.07.11,0,.21-1.91.27-3.77-.66-5.53-1.14-2.17-2.69-3.78-2.54-6.38Z"
          />
          <path
            class="cls-65"
            d="M692.24,809.23c-.37-.88-.89-1.69-1.42-2.5-.95-1.46-1.09-2.62-.73-4.32,0-.04-.05-.06-.06-.02-.5,1.4-.63,2.56.18,3.87,1.13,1.83,2.24,3.5,2.44,5.66.35,3.83-1.88,7.36-5.42,9.23-.05.03,0,.1.04.07,2.97-1.39,5.08-3.97,5.57-7.06.26-1.65.06-3.37-.59-4.93Z"
          />
          <path
            class="cls-65"
            d="M679.15,839.25c.11,0,.2-.08.2-.19.11-2.65.82-13.88.82-14,0-.11-.08-.21-.19-.21-.11-.01-.21.08-.21.19,0,.11-.71,11.34-.82,14,0,.11.08.2.19.21h0Z"
          />
          <path
            class="cls-65"
            d="M683.56,842.55c2.49,0,4.26-.63,4.28-.64.1-.04.16-.15.12-.26s-.15-.16-.26-.12c-.04.02-4.26,1.52-8.78-.21-.08-.03-.16,0-.22.05-.01.01-1.36,1.28-6.8-.44-.11-.03-.22.03-.25.13-.03.11.03.22.13.25,4.95,1.57,6.68.72,7.1.42,1.66.62,3.28.82,4.67.82Z"
          />
          <path
            class="cls-65"
            d="M671.65,839.56c-.3-.04-3.3-1.88-4.58-2.67-.07-.04-.1-.12-.09-.2l1.07-8.48c.01-.1.1-.17.21-.18l8.93.3c.11,0,.19.09.19.2v8.13c0,.07-.04.14-.11.18-3.43,1.8-5.32,2.71-5.61,2.71,0,0-.01,0-.01,0ZM676.98,828.74l-8.55-.29-1.03,8.17c1.54.95,3.95,2.4,4.31,2.54.42-.1,3.4-1.62,5.28-2.6v-7.81Z"
          />
          <path
            class="cls-65"
            d="M688.33,839.26l-4.88-1.81c-.07-.03-.12-.09-.13-.16l-1.2-8.47c0-.05,0-.11.04-.15.03-.04.08-.07.14-.08l9.62-.9c.11,0,.2.06.22.17l1.41,8.24c.01.08-.02.16-.1.21l-4.94,2.94s-.07.03-.1.03c-.02,0-.05,0-.07-.01ZM691.77,828.11l-9.22.87,1.15,8.14,4.68,1.73,4.74-2.82-1.35-7.92Z"
          />
          <path
            class="cls-65"
            d="M668.75,888.79c.08,0,.15-.04.18-.12,2.65-5.68,6.69-14.26,6.95-14.62.32-.4,2.13-22.32,2.9-31.73,0-.11-.07-.21-.18-.22-.11,0-.21.07-.22.18-.69,8.48-2.53,30.61-2.83,31.54-.5.78-6.31,13.24-6.98,14.68-.05.1,0,.22.1.27.03.01.06.02.08.02Z"
          />
          <path
            class="cls-65"
            d="M678.96,910.96c.08,0,.15-.05.18-.12.04-.1,0-.22-.1-.26l-16.71-7.23c-.1-.04-.22,0-.26.1-.04.1,0,.22.1.26l16.71,7.23s.05.02.08.02Z"
          />
          <path
            class="cls-65"
            d="M678.11,908.92c.07,0,.13-.03.17-.09.15-.24,15.29-24.58,15.76-36.14.12-2.91.39-6.69.67-10.7.86-12.1,1.93-27.15-.21-30.99-.05-.1-.18-.13-.27-.08-.1.05-.13.18-.08.27,2.09,3.73,1.02,18.72.16,30.77-.29,4.01-.56,7.8-.67,10.72-.47,11.45-15.55,35.7-15.7,35.94-.06.09-.03.22.06.28.03.02.07.03.11.03Z"
          />
          <path
            class="cls-65"
            d="M685.94,908.92h0c.11,0,.2-.1.19-.21l-.34-7.77c0-.11-.1-.18-.21-.19-.11,0-.2.1-.19.21l.34,7.77c0,.11.09.19.2.19Z"
          />
          <path
            class="cls-65"
            d="M661.08,846.05s.02,0,.03,0c.11-.01.19-.12.17-.23-.24-1.84,1.32-5.76,1.34-5.8.04-.1,0-.22-.11-.26-.1-.04-.22,0-.26.11-.07.16-1.62,4.05-1.36,6,.01.1.1.17.2.17Z"
          />
          <path
            class="cls-65"
            d="M658.36,845.76h0c.11,0,.2-.1.19-.21-.15-3.71,1.43-6.29,1.45-6.31.06-.09.03-.22-.06-.28-.09-.06-.22-.03-.28.06-.07.11-1.67,2.7-1.51,6.54,0,.11.09.19.2.19Z"
          />
          <path
            class="cls-65"
            d="M655.45,844.83s0,0,.01,0c.11,0,.2-.1.19-.21-.24-3.81,1.93-6.31,1.95-6.34.07-.08.07-.21-.02-.28-.08-.07-.21-.07-.28.02-.09.11-2.3,2.64-2.05,6.63,0,.11.1.19.2.19Z"
          />
          <path
            class="cls-65"
            d="M665.52,844.12s.02,0,.04,0c.11-.02.18-.12.16-.23,0-.02-.32-1.82-.25-4.76,0-.09-.06-.17-.15-.2-.03,0-3.05-.89-3.41-3-.02-.11-.12-.18-.23-.16-.11.02-.18.12-.16.23.36,2.1,2.89,3.06,3.55,3.27-.06,2.9.24,4.62.26,4.69.02.1.1.17.2.17Z"
          />
        </g>
        <g>
          <rect
            class="cls-2"
            x="748.98"
            y="779.64"
            width="38.12"
            height="28.89"
            transform="translate(1562.12 26.04) rotate(90)"
          />
          <rect
            class="cls-89"
            x="754.51"
            y="775.94"
            width="27.05"
            height="36.28"
            transform="translate(1536.08 1588.16) rotate(180)"
          />
          <rect
            class="cls-81"
            x="766.94"
            y="784.93"
            width="10.31"
            height="17.36"
          />
          <path
            class="cls-2"
            d="M765.77,790.65c.1-.35.43-.63.79-.67-1.6,1.92-3.21,3.84-4.81,5.76l5.28-3.62c-4.3,4.26-6.55,10.18-10.49,14.78,1.04-.85,2.07-1.7,3.11-2.55-.9,1.69-1.8,3.38-2.7,5.08,3.75-4.29,7.5-8.57,11.25-12.86-.38.85-.76,1.7-1.14,2.55,1.36-.72,2.37-1.95,3.33-3.16,1.4-1.75,2.8-3.5,4.2-5.25-.64.45-1.28.89-1.92,1.34,1.51-2.44,3.36-4.68,5.48-6.61-.94.2-1.83.66-2.54,1.31.81-1.41,1.62-2.82,2.42-4.22-1.25.19-2.46.63-3.54,1.28.6-1.19,1.2-2.38,1.79-3.57-1.64,1.41-3.14,2.98-4.46,4.7.38-.33.77-.69.89-1.17.34-1.33-.8-.92-1.37-.48-.76.6-1.39,1.71-1.99,2.48-1.02,1.31-3.15,3.29-3.59,4.89Z"
          />
          <path
            class="cls-2"
            d="M763.29,783.88c0,1.04-.84,1.88-1.88,1.88s-1.88-.84-1.88-1.88.84-1.88,1.88-1.88,1.88.84,1.88,1.88Z"
          />
          <rect
            class="cls-81"
            x="763.43"
            y="806.27"
            width="4.61"
            height="1.37"
          />
        </g>
        <g>
          <g>
            <path
              class="cls-54"
              d="M782.45,794.6c-5.94,3.36-11.58,7.15-12.36,9.37-1.09,3.07.99,4.24,1.99,4.39,2.72.39,9.4-8.49,11.78-11.91,2.31-3.32-.1-2.58-1.41-1.85Z"
            />
            <path
              class="cls-54"
              d="M783.36,794.29s-2.92,4.19-4.89,9.7c-1.27,3.56-4.93,14.76-5.19,17.1-.26,2.34,4.18,10.9,6.53,10.49,2.35-.41,3.54-37.28,3.54-37.28Z"
            />
            <path
              class="cls-54"
              d="M783.36,794.29s-2.92,4.19-4.89,9.7c-1.27,3.56-4.93,14.76-5.19,17.1-.26,2.34,4.18,10.9,6.53,10.49,2.35-.41,3.54-37.28,3.54-37.28Z"
            />
            <path
              class="cls-27"
              d="M795.32,847.15s4.98,5.64,7.42,9.78c1.11,1.88,1.89,3.31,1.79,3.49-.35.65-16.95,8.13-17.62,8.22-.67.1-1.03-1.55-.66-2.27.37-.73,5.15-5.97,5.15-5.97l-6.5-8.53,10.42-4.72Z"
            />
            <path
              class="cls-54"
              d="M786.91,868.65c.67-.09,17.28-7.57,17.62-8.22.09-.17-.63-1.51-1.68-3.3-1.15.88-2.99,2.31-4.45,3.07-1.43.75-3.63,1.65-3.63,1.65,0,0-2.07-.58-2.84-.68-.32-.04-1.02.2-1.61.42-1.43,1.59-3.82,4.28-4.08,4.79-.37.72-.01,2.37.66,2.27Z"
            />
            <path
              class="cls-47"
              d="M786.91,868.65c.67-.09,17.28-7.57,17.62-8.22.09-.17-.63-1.51-1.68-3.3-1.15.88-2.99,2.31-4.45,3.07-1.43.75-3.63,1.65-3.63,1.65,0,0-2.07-.58-2.84-.68-.32-.04-1.02.2-1.61.42-1.43,1.59-3.82,4.28-4.08,4.79-.37.72-.01,2.37.66,2.27Z"
            />
            <path
              class="cls-54"
              d="M786.31,868.16c-.23.23.34,1.01.59.98.25-.03,17.77-8.35,18.03-8.55.26-.2-.41-1.04-.79-.92-.38.12-17.84,8.5-17.84,8.5Z"
            />
            <path
              class="cls-65"
              d="M801.86,855.19l-10.86,5.23s-1.27-.39-1.82-1.08c-3.45-4.28-15.22-19.88-15.48-24.06-.41-6.7,6.2-27.96,6.2-27.96l10.56-.06s-4.29,21.87-3.94,25.6c.15,1.62,11.38,15.26,14.86,20.08.7.97.48,2.25.48,2.25Z"
            />
            <g>
              <path
                class="cls-84"
                d="M789.49,858.29c.61-.38,6.24-3.2,10.53-5,.03-.01.05.02.02.04-1.3.74-9.7,4.72-10.52,5-.03,0-.06-.02-.03-.04Z"
              />
              <path
                class="cls-84"
                d="M785.05,828.18c.49-3.2,1.03-6.39,1.65-9.58.62-3.2,1.27-6.39,2.04-9.57.09-.39.19-.77.29-1.16.02-.06.12-.04.11.02-.65,3.15-1.32,6.29-1.92,9.45-.6,3.16-1.16,6.32-1.66,9.49-.12.78-.24,1.57-.36,2.35-.12.81-.26,1.62-.27,2.44-.01.79.13,1.55.45,2.29.31.72.76,1.4,1.22,2.06,1.91,2.79,12,16.82,12.23,17.18.01.02-.02.05-.04.02-2.05-2.75-9.96-13.37-11.9-16.21-.87-1.28-1.88-2.58-2.16-4.07-.3-1.55.09-3.18.32-4.72Z"
              />
            </g>
            <path
              class="cls-27"
              d="M788.1,853.11s.44,15.3-.13,15.68c-.66.44-19.39.41-20.03.22-.65-.18-.08-1.78.63-2.28.72-.49,7.77-3.23,7.77-3.23v-10.4s11.76,0,11.76,0Z"
            />
            <path
              class="cls-54"
              d="M767.93,869.01c.64.19,19.37.21,20.03-.22.18-.12.26-1.59.28-3.59-1.49.32-3.89.84-5.58.94-1.67.09-4.1,0-4.1,0,0,0-1.52-1.34-2.15-1.74-.27-.17-1-.23-1.66-.27-2.12.84-5.68,2.26-6.19,2.61-.72.49-1.28,2.09-.64,2.28Z"
            />
            <path
              class="cls-47"
              d="M767.93,869.01c.64.19,19.37.21,20.03-.22.18-.12.26-1.59.28-3.59-1.49.32-3.89.84-5.58.94-1.67.09-4.1,0-4.1,0,0,0-1.52-1.34-2.15-1.74-.27-.17-1-.23-1.66-.27-2.12.84-5.68,2.26-6.19,2.61-.72.49-1.28,2.09-.64,2.28Z"
            />
            <path
              class="cls-54"
              d="M767.66,867.98c-.33.1-.26,1.03-.02,1.1.24.07,20.23.07,20.57,0,.34-.06.22-1.08-.18-1.14-.39-.05-20.37.03-20.37.03Z"
            />
            <path
              class="cls-65"
              d="M780.04,807.29s0,0,0,0c.04.11.48,6.67,2.45,8.82.2.22,1.62.44,1.78.5.4.16-8.38,12.91-8.9,18.84-.27,3.03-.07,18.81.09,25.08.04,1.58.78,2.69.78,2.69h12.02s1.06-1.13,1.01-2.94c-.18-6.16-1.42-20.27-1.65-24.99-.11-2.37,8.82-14.16,8.93-21.5.03-2.31-1.89-6.54-1.89-6.54l-14.62.04Z"
            />
            <g>
              <path
                class="cls-84"
                d="M775.36,835.59c.03-.81.09-1.63.26-2.43.17-.78.45-1.54.79-2.28.71-1.55,1.55-3.05,2.35-4.57.81-1.53,1.64-3.06,2.5-4.57.48-.85.97-1.7,1.45-2.55.49-.86,1.03-1.7,1.54-2.55.02-.03.08,0,.06.03-.82,1.53-1.64,3.06-2.46,4.59-.82,1.53-1.63,3.06-2.44,4.59-.8,1.51-1.59,3.02-2.34,4.54-.36.73-.69,1.47-.92,2.25-.23.79-.32,1.6-.38,2.42-.12,1.9-.19,3.8-.4,5.69,0,.02-.05.02-.05,0-.07-1.71-.03-3.43.03-5.15Z"
              />
              <path
                class="cls-84"
                d="M776.61,861.03c.75-.08,6.44-.25,11.2-.08.03,0,.03.04,0,.04-1.55.12-10.32.17-11.19.08-.03,0-.04-.04,0-.05Z"
              />
              <g>
                <path
                  class="cls-84"
                  d="M782.49,816.12c1.37.28,2.72.72,4.02,1.2.05.02.03.09-.03.07-1.35-.36-2.72-.71-4.04-1.14-.1-.03-.05-.16.05-.14Z"
                />
                <path
                  class="cls-84"
                  d="M781.19,808.51s.08-.05.08-.01c.15,1.33.38,2.48.66,3.71.13.57,1.04,3.7,2.17,3.36.19-.06.27-.23.27-.48,0-.31-.18-.66-.27-.96-.21-.65-.39-1.31-.53-1.98-.27-1.24-.43-2.5-.4-3.76,0-.04.07-.04.07,0,.2,1.74.46,3.46.97,5.16.24.81.87,2.01-.11,2.23-1,.22-1.91-1.81-2.1-2.36-.54-1.56-.75-3.28-.8-4.9Z"
                />
                <path
                  class="cls-84"
                  d="M784.08,815.66c.13.2.24.42.34.64.08.17.17.35.17.53,0,.04-.05.04-.08.02-.15-.14-.23-.33-.33-.5-.11-.2-.23-.39-.33-.59-.07-.13.15-.22.23-.1Z"
                />
              </g>
              <path
                class="cls-84"
                d="M786.23,838.4c-.07-1.58-.27-3.23.33-4.76.3-.76.75-1.45,1.17-2.16.45-.74.88-1.49,1.31-2.24,1.72-3,3.33-6.04,4.78-9.14.7-1.49,1.32-3.03,1.57-4.63.26-1.68.07-3.39-.36-5.03-.11-.41-.22-.82-.35-1.23,0-.03.04-.05.05-.02.58,1.56.98,3.17,1,4.81.02,1.58-.38,3.11-.97,4.6-.62,1.55-1.39,3.06-2.15,4.55-.78,1.55-1.6,3.08-2.44,4.6-.84,1.51-1.74,3-2.62,4.5-.43.72-.82,1.46-.99,2.27-.17.82-.14,1.66-.11,2.48.15,3.49.5,17.65.55,21.13,0,.44.01.88.02,1.33,0,.04-.07.04-.07,0-.26-3.47-.58-17.6-.73-21.08Z"
              />
              <path
                class="cls-84"
                d="M789.11,809.56s.04-.02.05,0c.15.96.24,1.96.77,2.83.49.8,1.35,1.32,2.29,1.68.54.21,1.1.37,1.67.53.04.01.03.07-.01.06-1.06-.19-2.14-.4-3.07-.92-.99-.55-1.5-1.44-1.66-2.42-.1-.58-.09-1.17-.04-1.75Z"
              />
            </g>
            <path
              class="cls-65"
              d="M800.6,806.1c.59,1.79,1.78,2.88,2.3,3.21.52.34,2.07.77,2.1.85.03.08-1.04.95-1.11.97-.07.03-1.39-.65-2.27-1.28-.88-.63-1.77-3.31-1.77-3.31l.75-.45Z"
            />
            <path
              class="cls-60"
              d="M793.1,808.96c-.82-.53-1.59-4-3.21-7.53-1.62-3.53-3.84-7.74-3.62-8.04.33-.44,3.29-.37,4.5.32,1.54.87,4.44,3.74,4.44,3.74,0,0,1.57.62,2.02,1.26.12.17.41.74.78,1.49.1.21,1.09.7,1.2.94.64,1.35,1.28,2.6,1.74,3.68.26.63-.33,1.22-.34,1.28-.06.27-.46,2.82-.86,3.15-.4.33-3.31,1.88-6.64-.29Z"
            />
            <path
              class="cls-65"
              d="M794.03,807.47c-.16-.54-.11-.37-.27-.9-.16-.53-.34-1.05-.47-1.58-.02-.06-.03-.11.05-.15.12-.06.36-.08.5-.11.42-.08.84-.15,1.27-.22.88-.14,1.87-.28,2.76-.35.08,0,.11.08.02.09-1.38.13-2.85.34-4.2.6-.07.01-.25.03-.28.09,0,.01.03.11.04.12.04.12.07.23.11.35.07.23.14.47.22.7.14.47.08.23.22.7.07.21.13.43.2.64.04.12.07.23.11.35.02.06.03.12.05.18.05.12.09.16.26.21.28.07.6.1.89.15.33.06.66.11.99.17.16.03.36.09.53.08.18,0,.35-.18.46-.27l1.07-.79c.09-.07.22-.2.27-.28.07-.11-.69-2.55-.96-3.04-.01-.02.07-.04.08-.02.25.47,1.1,2.77,1.12,3.01.01.2-.2.33-.39.47-.27.2-.54.39-.8.59-.14.1-.28.21-.42.31-.1.07-.2.14-.34.16-.13.01-.26-.02-.38-.05-.19-.03-.39-.07-.58-.1l-1.11-.19c-.25-.04-.63-.06-.78-.23-.07-.08-.08-.18-.11-.27-.04-.14-.08-.27-.12-.41Z"
            />
            <path
              class="cls-65"
              d="M793.5,805.12c.8.21,1.6.41,2.42.58.11.02.21.05.32.07.21.04.29,0,.43-.1.13-.1.26-.21.4-.32.31-.24.62-.48.93-.72.02-.02.07,0,.05.02-.32.29-.63.57-.96.85-.22.19-.42.46-.83.38-.46-.08-.91-.21-1.35-.33-.48-.13-.95-.26-1.41-.41-.02,0,0-.02.01-.02Z"
            />
            <path
              class="cls-65"
              d="M796.16,805.47s.02-.1.08-.12c.07-.03.15-.02.22,0,.03,0,.01.05-.02.04-.03,0-.06-.02-.09-.01-.01,0-.03,0-.04.01,0,0-.01.01-.02.01,0,0-.01.02-.02.03,0,0,0,.01,0,.02,0,0,0,0,0,0,0,.02,0,.05,0,.07,0,.04.04.07.1.08.03,0,.06,0,.08-.02.02-.02.03-.05.03-.07,0,0,.02,0,.02,0,0,.04,0,.09-.06.11-.06.03-.13,0-.18-.02-.06-.03-.09-.08-.09-.13Z"
            />
            <path
              class="cls-65"
              d="M798.06,800.31s.87,2.23.91,2.46c.04.23.98,2.7,1.2,2.84.23.14.33.27.33.27"
            />
            <path
              class="cls-65"
              d="M795.21,797.44s1.51,2.82,1.64,3.01c.12.19,1.4,2.82,1.58,3.04.18.22.62.7.74.75"
            />
            <path
              class="cls-79"
              d="M780.94,803.42l-1.03,3.9,14.75-.06s-2.58-9.58-6.58-12.82c-1.59-1.29-3.71-.91-4.84.08-.26.22-3.36,4.65-3.62,6.23-.21,1.3,1.31,2.67,1.31,2.67Z"
            />
            <g>
              <path
                class="cls-65"
                d="M782.9,802.69c.7.03,1.41.08,2.11.22.35.07.69.16,1.03.25.17.05.34.09.52.13.18.04.37.08.55.07.02,0,.02.03,0,.03-.17.02-.34.04-.51.03-.17,0-.34-.03-.5-.07-.35-.07-.7-.15-1.06-.22-.71-.14-1.42-.29-2.14-.38-.03,0-.03-.07,0-.06Z"
              />
              <path
                class="cls-65"
                d="M781.25,803.51c.56-.11,1.14-.19,1.72-.23.29-.02.58-.02.87,0,.14,0,.28.01.42.02.15,0,.31.04.46.05.02,0,.02.03,0,.03-.14,0-.29.02-.43.03-.14,0-.29.01-.43.02-.29.01-.58.03-.87.04-.58.02-1.15.05-1.73.1-.03,0-.03-.05,0-.05Z"
              />
            </g>
            <path
              class="cls-54"
              d="M786.87,793.8c.71,1.51,1.06,6.24.52,9.94-.53,3.69-2.66,14.96-2.81,17.31-.16,2.34,10.51,10.93,12.84,10.44,2.33-.49,3.56-6.35-.42-19.73-1.05-3.52-4.47-12.23-7.25-15.89-1.95-2.56-2.88-2.06-2.88-2.06Z"
            />
            <path
              class="cls-65"
              d="M795.54,807.27c-.21-.18-6.64-7.02-7.59-10.69-.62-2.41,1.63-2.01,1.63-2.01l-.37-.71s-.8-.34-2.34.8c-2.8,2.08,4.45,12.05,8.85,14.13l-.18-1.51Z"
            />
            <path
              class="cls-54"
              d="M788.82,794.48c5.03,3.29,10.03,9.02,10.13,12.27.1,3.21-1.2,2.92-1.56,2.9-2.25-.09-7.73-8.94-9.41-12.56-1.68-3.59-.4-3.43.84-2.62Z"
            />
            <path
              class="cls-65"
              d="M794.35,807.2c-.27-.4-.55-.8-.81-1.2l-.8-1.2c-.53-.8-1.06-1.6-1.58-2.41-.53-.8-1.04-1.61-1.55-2.43-.25-.41-.5-.81-.75-1.23-.25-.41-.48-.82-.71-1.24.36.87.81,1.71,1.28,2.55.47.83.98,1.65,1.5,2.46.53.8,1.07,1.61,1.63,2.39.57.79,1.14,1.57,1.78,2.31Z"
            />
            <path
              class="cls-65"
              d="M788.71,798.56c-.09-.15-.2-.28-.31-.41-.06-.06-.11-.13-.17-.19-.06-.06-.12-.13-.19-.19.04.17.14.32.25.45.12.13.25.26.42.35Z"
            />
            <path
              class="cls-27"
              d="M786.73,794.97c-.11.23-1.68,1.59-2.92,1.38-.4-.07-.06-1.99-.06-1.99v-.15s-.18-2.06-.18-2.06l2.97-1.15.43-.15s0,.57,0,1.27c0,.03,0,.07,0,.1,0,.04,0,.08,0,.11,0,.11,0,.21,0,.32,0,.08,0,.16,0,.25,0,.09,0,.17,0,.26-.04.85-.17,1.71-.22,1.81Z"
            />
            <path
              class="cls-65"
              d="M786.96,792.13c-.94,1.5-2.51,1.95-3.22,2.08l-.17-2.06,2.97-1.15.43-.15s0,.57,0,1.27Z"
            />
            <path
              class="cls-27"
              d="M780.82,789.93c.09,3.62,2.61,3.98,3.51,3.97.82-.02,3.61-.16,3.95-3.77.35-3.61-1.63-4.72-3.51-4.77-1.88-.05-4.05.95-3.96,4.57Z"
            />
            <g>
              <path
                class="cls-65"
                d="M781.84,789.46c.1-.01.19-.04.28-.06.11-.02.2-.03.27-.11.04-.04.04-.12,0-.16-.09-.09-.23-.09-.37-.07-.14.02-.24.08-.34.17-.09.09.02.23.15.22Z"
              />
              <path
                class="cls-65"
                d="M784.6,789.43c-.1,0-.19-.03-.28-.05-.11-.02-.2-.02-.28-.1-.04-.04-.04-.12,0-.16.09-.09.23-.1.36-.08.14.02.25.07.34.16.09.09,0,.23-.14.22Z"
              />
              <path
                class="cls-65"
                d="M784.32,790.1c.46-.03.49.77.07.79-.42.03-.45-.77-.07-.79Z"
              />
              <path
                class="cls-65"
                d="M782.14,790.1c-.46-.01-.46.78-.03.79.42.01.41-.78.03-.79Z"
              />
              <path
                class="cls-65"
                d="M784.05,792.33c-.06.06-.12.15-.23.16-.1.01-.22-.02-.31-.04,0,0-.02,0-.01.01.08.09.24.14.37.11.13-.03.18-.13.2-.23,0-.01-.02-.02-.03,0Z"
              />
              <path
                class="cls-65"
                d="M782.83,791.47s-.05.37-.04.54c0,.02.05.02.12.02,0,0,0,0,0,0,.36.04.71-.07.92-.33.01-.02-.01-.03-.03-.02-.26.17-.55.22-.87.23-.02-.05.11-.63.08-.63-.11,0-.32.06-.45.1.08-.77.29-1.53.35-2.3,0-.03-.04-.03-.05-.01-.29.78-.4,1.66-.5,2.46-.01.1.4-.04.48-.07Z"
              />
              <g>
                <path
                  class="cls-65"
                  d="M783.08,791.96s.18.2.41.26c.09.02.18.03.28,0,.2-.05.2-.21.16-.34-.03-.11-.1-.21-.1-.21,0,0-.29.24-.75.28Z"
                />
                <path
                  class="cls-52"
                  d="M783.49,792.23c.09.02.18.03.28,0,.2-.05.2-.21.16-.34-.21.02-.42.15-.44.34Z"
                />
              </g>
            </g>
            <g>
              <path
                class="cls-27"
                d="M787.63,790.41s.77-1.21,1.39-.98c.62.23.14,1.92-.52,2.2-.66.29-.98-.24-.98-.24l.11-.98Z"
              />
              <path
                class="cls-65"
                d="M788.87,789.91s.01.01,0,.02c-.46.22-.67.63-.8,1.05.13-.17.31-.27.57-.15.01,0,0,.02-.01.02-.2-.02-.34.02-.46.18-.08.11-.13.24-.19.35-.02.04-.1.03-.09-.02,0,0,0,0,0-.01-.08-.53.31-1.33.97-1.44Z"
              />
            </g>
            <path
              class="cls-84"
              d="M780.92,788.7s1.35-.56,2.09-.56c1.57-.01,5.15,1.81,5.15,1.81,0,0,1.34-4.11-2.97-4.68-1.89-.25-4.08,1.02-4.27,3.44Z"
            />
            <g>
              <path
                class="cls-54"
                d="M794.08,796.84c-.37-.42-2.66-2.34-3.01-2.81-.34-.47-1.21-1.59-1.21-1.59.17-.37.02-2.22-.35-3.5-.48-1.66-1.73-3.36-3.95-3.74-2.22-.37-3.97.83-4.75,2.81-.78,1.98-.56,4.04-.22,4.7.34.66,1.24,1.43,1.24,1.43,0,0,.21,1.1.05,1.21-.18.11-.41.45-.42.55-.02.1,1.26,1.03,2.45,1.53,1.19.5,4.12-1.06,4.12-1.06,0,0,.4,3.59,1.37,4.66,0,0,2.2,1.2,3.2,1.09,1-.11,2.59-2.15,2.59-2.15,0,0-.71-2.67-1.11-3.12ZM786.93,790.38c-.09,1.51-1.51,3.59-3.85,3.1-2.29-.49-2.34-3.32-2.04-4.2.72-2.13,2.36-2.54,2.48-2.55.12,0,3.55,1.29,3.41,3.65Z"
              />
              <path
                class="cls-47"
                d="M794.08,796.84c-.37-.42-2.66-2.34-3.01-2.81-.34-.47-1.21-1.59-1.21-1.59.17-.37.02-2.22-.35-3.5-.48-1.66-1.73-3.36-3.95-3.74-2.22-.37-3.97.83-4.75,2.81-.78,1.98-.56,4.04-.22,4.7.34.66,1.24,1.43,1.24,1.43,0,0,.21,1.1.05,1.21-.18.11-.41.45-.42.55-.02.1,1.26,1.03,2.45,1.53,1.19.5,4.12-1.06,4.12-1.06,0,0,.4,3.59,1.37,4.66,0,0,2.2,1.2,3.2,1.09,1-.11,2.59-2.15,2.59-2.15,0,0-.71-2.67-1.11-3.12ZM786.93,790.38c-.09,1.51-1.51,3.59-3.85,3.1-2.29-.49-2.34-3.32-2.04-4.2.72-2.13,2.36-2.54,2.48-2.55.12,0,3.55,1.29,3.41,3.65Z"
              />
            </g>
            <path
              class="cls-27"
              d="M772.4,799.51c.51-1.46,1.37-3.48,2.07-3.83.73-.37,3.36-1.58,4.07-1.7.72-.11,3.92-.7,4.43-.35.41.28-.3,1.22-1.83,1.51-1.34.26-2.07.57-2.45.65-.39.09-1.47,1-1.31,1.49.09.29.95.73,1.55.58.6-.14.92-1.09,1.64-1.46.73-.37,1.85-.16,1.87.11.02.27-.38.35-1.12,1.17-.48.53-.75,1.92-1.78,2.8-.52.44-1.5,1.68-1.5,1.68l-5.63-2.68Z"
            />
            <path
              class="cls-65"
              d="M781.25,796.09c.21-.01.43-.04.6-.14.07-.05.13-.11.16-.18.02-.04.03-.08.03-.12,0-.04,0-.1-.03-.13,0,0,0-.02.01,0,0,.02.03.04.04.07.01.02.02.04.02.06.01.04.01.08,0,.12-.02.09-.08.17-.16.23-.19.14-.45.15-.68.11,0,0,0-.01,0-.01Z"
            />
            <path
              class="cls-27"
              d="M774.47,795.69c.68-.67,2.33-1.83,3.8-2.1,1-.19,3.99,1.61,3.8,2.13-.19.52-.74.45-1.55.26-.29-.07-1.78-.77-2.1-.52-.46.36-1.2,1.7-1.2,1.7l-2.75-1.46Z"
            />
            <path
              class="cls-27"
              d="M774.47,795.69c.68-.67,2.33-1.83,3.8-2.1,1-.19,3.24,1.9,3.05,2.42-.19.52-.99.46-1.82.08-.27-.12-1.12-.83-1.44-.58-.46.36-1.58,1.25-1.58,1.25l-2.01-1.07Z"
            />
            <path
              class="cls-27"
              d="M773.95,796.28c.27-.33.87-1.74,1.27-2.15.41-.4,2.17-1.75,2.86-1.59.86.2-.3,1.44-.85,1.94-.56.5-.65,1.46-.65,1.46l-2.62.34Z"
            />
            <path
              class="cls-27"
              d="M772.35,808.28c1.74.01,3.27-2.31,5.94-6.41.47-.72-3.21-5.95-3.93-5.33-.91.78-3.79,5.42-4.22,6.73-.87,2.58.19,4.99,2.22,5Z"
            />
            <path
              class="cls-54"
              d="M776.86,804.17l-4.73-5.3s-2.23,3.78-2.36,5.46c-.13,1.68.22,3.67,2.53,4.06,1.72.29,4.56-4.22,4.56-4.22Z"
            />
            <path
              class="cls-84"
              d="M783.18,795.93l2.48,6.23c.1.18,0,.34-.21.36l-3.8.28c-.21.02-.46-.12-.56-.3l-2.48-6.23c-.1-.18,0-.34.21-.36l3.8-.28c.21-.02.46.12.56.3Z"
            />
            <path
              class="cls-60"
              d="M782.72,795.96l2.48,6.23c.1.18,0,.34-.21.36l-3.8.28c-.21.02-.46-.12-.56-.3l-2.48-6.23c-.1-.18,0-.34.21-.36l3.8-.28c.21-.02.46.12.56.3Z"
            />
            <path
              class="cls-65"
              d="M781.71,796.32c.02.15.18.27.36.25.18-.02.31-.15.29-.31-.02-.15-.18-.27-.36-.25-.18.02-.31.15-.29.31Z"
            />
            <path
              class="cls-27"
              d="M797.91,809.65c-1.66.22-3.75-.86-9.19-4.16-.75-.46,1.55-5.92,2.38-5.46,1.05.57,4.98,2.98,5.24,3.18,2.21,1.75,2.7,6.29,1.57,6.44Z"
            />
            <path
              class="cls-27"
              d="M793.05,801.64s-1.57-1.83-2.74-2.57c-1.56-.99-3.39-1.29-4.16-1.38-1.61-.18-5.66.35-5.68,1.39-.02.94,4.08.21,4.08.21,0,0-4.32.14-4.11,1.27.21,1.13,4.92.06,4.92.06,0,0-4.44.23-4.01,1.37.33.86,4.65.09,4.65.09,0,0-3.81.22-3.52,1.12.32.99,4.37.5,4.37.5,1.18,2.17,2.83,2.76,4.02,3.08.29.08,2.19-5.14,2.19-5.14Z"
            />
            <path
              class="cls-54"
              d="M793.03,800.9l-1.97,6.7s5.74,2.8,6.98,2.01c1.24-.78.33-4.62-1.12-6.06-.6-.6-3.89-2.65-3.89-2.65Z"
            />
          </g>
          <path
            class="cls-65"
            d="M776.49,796.06s0,0,0,0c.07,0,.12-.05.11-.11,0-.02-.1-1.54,1.35-2.11,1.43-.56,3.21,1.64,3.23,1.66.04.05.11.06.17.03.05-.03.07-.1.03-.14-.08-.1-1.92-2.37-3.53-1.73-1.6.63-1.49,2.29-1.49,2.31,0,.05.06.1.12.1Z"
          />
          <path
            class="cls-65"
            d="M777.77,799.95s.02,0,.04,0c.06-.02.1-.08.08-.13l-1.29-3.42c-.02-.05-.09-.09-.15-.07-.06.02-.1.08-.08.13l1.29,3.42s.06.07.11.07Z"
          />
          <path
            class="cls-65"
            d="M798.29,805.98s.03,0,.05,0c.06-.02.09-.08.07-.14-.08-.18-2.1-4.33-5.09-5.05-.06-.01-.13.02-.15.07-.02.06.02.11.08.13,2.88.69,4.92,4.89,4.94,4.93.02.04.06.06.11.06Z"
          />
          <path
            class="cls-65"
            d="M780.82,799.95c.05,0,.1-.03.11-.07.18-.17,2.6-.45,4.82-.62.07,0,.12-.06.11-.11,0-.06-.07-.1-.13-.09-1.82.14-4.9.42-5.03.76-.02.05.01.11.08.13.01,0,.03,0,.04,0Z"
          />
          <path
            class="cls-65"
            d="M783.87,802.47s0,0,.01,0l2.82-.27c.07,0,.11-.06.11-.11,0-.06-.06-.1-.13-.09l-2.82.27c-.07,0-.11.06-.11.11,0,.05.06.09.12.09Z"
          />
          <path
            class="cls-65"
            d="M782.42,801.18s0,0,.01,0l3.32-.34c.07,0,.11-.06.11-.12,0-.06-.07-.1-.13-.09l-3.32.34c-.07,0-.11.06-.11.12,0,.05.06.09.12.09Z"
          />
          <path
            class="cls-65"
            d="M774.55,807.25s.07-.02.1-.04l2.08-2.52s.03-.11-.03-.14c-.05-.03-.13-.02-.17.02l-2.08,2.52s-.03.11.03.14c.02.01.05.02.07.02Z"
          />
          <path
            class="cls-65"
            d="M775.54,804.93s.06,0,.08-.03c.05-.04.06-.1.01-.15l-3.92-3.92s-.12-.05-.17-.01c-.05.04-.06.1-.01.15l3.92,3.92s.06.04.09.04Z"
          />
          <path
            class="cls-65"
            d="M793.63,817.09s.09-.03.11-.07c.02-.05,0-.11-.07-.13-.05-.02-4.67-1.54-5.87-3.32-.03-.05-.11-.07-.16-.04-.06.03-.08.09-.04.14,1.24,1.83,5.8,3.34,5.99,3.41.01,0,.03,0,.04,0Z"
          />
          <path
            class="cls-65"
            d="M792.94,817.81s.09-.02.11-.06c.03-.05,0-.11-.07-.14-.04-.01-3.81-1.37-5.58-3.39-.04-.05-.12-.05-.17-.02-.05.03-.06.1-.02.15,1.81,2.07,5.64,3.44,5.68,3.46.02,0,.03,0,.05,0Z"
          />
          <path
            class="cls-65"
            d="M791.37,821.8c.71,0,1.26-.18,1.63-.53.95-.89.41-2.56.39-2.63-.02-.06-.08-.09-.15-.07-.06.02-.1.07-.08.13,0,.02.52,1.63-.33,2.43-.46.43-1.25.56-2.34.38-1.6-.27-2.64-1.39-3.07-3.35-.33-1.48-.17-2.89-.17-2.9,0-.06-.04-.11-.11-.11-.06,0-.12.04-.13.09,0,.01-.16,1.46.17,2.96.45,2.02,1.57,3.23,3.26,3.51.34.06.65.08.93.08Z"
          />
        </g>
      </g>
      <g
        id="fenêtre_gauche_haut"
        data-name="fenêtre gauche haut"
      >
        <rect
          class="cls-7"
          x="519.19"
          y="110.36"
          width="13"
          height="216"
          rx=".43"
          ry=".43"
        />
        <path
          class="cls-49"
          d="M526.61,119.41v-1.21h-.82v-7.74h-.27v7.74h-.82v1.21c-1.75,1.06-2.8,4.88-2.94,7.4h7.77c-.13-2.53-1.18-6.35-2.94-7.4Z"
        />
        <g>
          <g class="cls-101">
            <g>
              <rect
                class="cls-24"
                x="445.69"
                y="49.86"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="446.19"
                  y1="49.86"
                  x2="446.19"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="453.41"
                  y1="49.86"
                  x2="453.41"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="460.64"
                  y1="49.86"
                  x2="460.64"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="467.87"
                  y1="49.86"
                  x2="467.87"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="475.09"
                  y1="49.86"
                  x2="475.09"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="482.32"
                  y1="49.86"
                  x2="482.32"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="489.54"
                  y1="49.86"
                  x2="489.54"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="496.77"
                  y1="49.86"
                  x2="496.77"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="503.99"
                  y1="49.86"
                  x2="503.99"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="511.22"
                  y1="49.86"
                  x2="511.22"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="518.45"
                  y1="49.86"
                  x2="518.45"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="525.67"
                  y1="49.86"
                  x2="525.67"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="532.9"
                  y1="49.86"
                  x2="532.9"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="540.12"
                  y1="49.86"
                  x2="540.12"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="547.35"
                  y1="49.86"
                  x2="547.35"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="554.58"
                  y1="49.86"
                  x2="554.58"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="561.8"
                  y1="49.86"
                  x2="561.8"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="569.03"
                  y1="49.86"
                  x2="569.03"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="576.25"
                  y1="49.86"
                  x2="576.25"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="583.48"
                  y1="49.86"
                  x2="583.48"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="590.7"
                  y1="49.86"
                  x2="590.7"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="597.93"
                  y1="49.86"
                  x2="597.93"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="605.16"
                  y1="49.86"
                  x2="605.16"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="612.38"
                  y1="49.86"
                  x2="612.38"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="619.61"
                  y1="49.86"
                  x2="619.61"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="626.83"
                  y1="49.86"
                  x2="626.83"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="634.06"
                  y1="49.86"
                  x2="634.06"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="641.29"
                  y1="49.86"
                  x2="641.29"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="648.51"
                  y1="49.86"
                  x2="648.51"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="655.74"
                  y1="49.86"
                  x2="655.74"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="662.96"
                  y1="49.86"
                  x2="662.96"
                  y2="273.86"
                />
                <line
                  class="cls-6"
                  x1="670.19"
                  y1="49.86"
                  x2="670.19"
                  y2="273.86"
                />
              </g>
            </g>
            <g>
              <rect
                class="cls-24"
                x="445.69"
                y="273.86"
                width="225"
                height="224"
              />
              <g>
                <line
                  class="cls-6"
                  x1="446.19"
                  y1="273.86"
                  x2="446.19"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="453.41"
                  y1="273.86"
                  x2="453.41"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="460.64"
                  y1="273.86"
                  x2="460.64"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="467.87"
                  y1="273.86"
                  x2="467.87"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="475.09"
                  y1="273.86"
                  x2="475.09"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="482.32"
                  y1="273.86"
                  x2="482.32"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="489.54"
                  y1="273.86"
                  x2="489.54"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="496.77"
                  y1="273.86"
                  x2="496.77"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="503.99"
                  y1="273.86"
                  x2="503.99"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="511.22"
                  y1="273.86"
                  x2="511.22"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="518.45"
                  y1="273.86"
                  x2="518.45"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="525.67"
                  y1="273.86"
                  x2="525.67"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="532.9"
                  y1="273.86"
                  x2="532.9"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="540.12"
                  y1="273.86"
                  x2="540.12"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="547.35"
                  y1="273.86"
                  x2="547.35"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="554.58"
                  y1="273.86"
                  x2="554.58"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="561.8"
                  y1="273.86"
                  x2="561.8"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="569.03"
                  y1="273.86"
                  x2="569.03"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="576.25"
                  y1="273.86"
                  x2="576.25"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="583.48"
                  y1="273.86"
                  x2="583.48"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="590.7"
                  y1="273.86"
                  x2="590.7"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="597.93"
                  y1="273.86"
                  x2="597.93"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="605.16"
                  y1="273.86"
                  x2="605.16"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="612.38"
                  y1="273.86"
                  x2="612.38"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="619.61"
                  y1="273.86"
                  x2="619.61"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="626.83"
                  y1="273.86"
                  x2="626.83"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="634.06"
                  y1="273.86"
                  x2="634.06"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="641.29"
                  y1="273.86"
                  x2="641.29"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="648.51"
                  y1="273.86"
                  x2="648.51"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="655.74"
                  y1="273.86"
                  x2="655.74"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="662.96"
                  y1="273.86"
                  x2="662.96"
                  y2="497.86"
                />
                <line
                  class="cls-6"
                  x1="670.19"
                  y1="273.86"
                  x2="670.19"
                  y2="497.86"
                />
              </g>
            </g>
          </g>
          <path
            class="cls-75"
            d="M531.76,326.86h-12.14c-.51,0-.93-.42-.93-.93V110.79c0-.51.42-.93.93-.93h12.14c.51,0,.93.42.93.93v215.14c0,.51-.42.93-.93.93ZM531.69,110.79l-12.07.07.07,215.07,12-.07V110.79Z"
          />
        </g>
        <g class="cls-100">
          <g>
            <rect
              class="cls-5"
              x="529.17"
              y="173.52"
              width="36.13"
              height="41.17"
            />
            <g>
              <rect
                class="cls-49"
                x="536.87"
                y="179.81"
                width="9.57"
                height="24.96"
                transform="translate(733.95 -349.36) rotate(90)"
              />
              <path
                class="cls-58"
                d="M539.24,173.52c.43,2.05.83,4.11,1.28,6.16.43,2.05.86,4.1,1.31,6.15.46,2.04.92,4.08,1.45,6.1.27,1.01.54,2.01.86,3l.25.73c.09.24.18.48.27.71.1.23.2.46.31.68.05.11.11.21.18.31.05.1.13.19.21.29.61.78,1.37,1.49,2.16,2.15.79.66,1.63,1.28,2.48,1.86,1.71,1.16,3.52,2.22,5.43,2.95.48.18.97.33,1.45.4.24.03.48.05.7.01.23-.04.46-.1.69-.2.92-.38,1.76-1.02,2.56-1.67,1.61-1.32,3.06-2.84,4.47-4.39-.63.84-1.29,1.65-1.99,2.44-.7.79-1.42,1.55-2.2,2.27-.79.7-1.61,1.39-2.61,1.87-.25.12-.52.21-.81.27-.3.06-.59.04-.87.02-.56-.07-1.08-.21-1.59-.38-1.02-.34-1.99-.79-2.93-1.29-.94-.5-1.85-1.04-2.74-1.62-.89-.58-1.74-1.21-2.56-1.89-.82-.68-1.61-1.4-2.3-2.27-.08-.11-.17-.22-.25-.35-.08-.13-.16-.25-.21-.38-.13-.25-.24-.5-.34-.75-.1-.25-.19-.5-.29-.75l-.25-.76c-.32-1.01-.6-2.03-.85-3.05-.5-2.05-.94-4.1-1.32-6.17-.79-4.12-1.43-8.27-1.95-12.44Z"
              />
              <path
                class="cls-58"
                d="M545.71,173.52c.59,1.92,1.14,3.85,1.66,5.78.53,1.93,1.03,3.87,1.52,5.81.25.97.48,1.94.72,2.92.24.97.47,1.95.7,2.92.46,1.95.9,3.9,1.33,5.86l-.52-.21,1.86-1.11,1.88-1.09,1.89-1.08c.63-.36,1.27-.71,1.9-1.05-.59.43-1.18.85-1.77,1.26l-1.79,1.23-1.8,1.22-1.81,1.2-.39.26-.12-.47c-.5-1.94-1-3.88-1.47-5.82-.24-.97-.48-1.94-.7-2.92-.23-.98-.46-1.95-.68-2.93-.44-1.95-.87-3.91-1.28-5.87-.41-1.96-.79-3.93-1.13-5.9Z"
              />
              <path
                class="cls-58"
                d="M553.77,189c-.08-1.04.11-2.11.5-3.11.21-.49.48-.97.8-1.41.33-.44.71-.82,1.17-1.16.47-.31.98-.56,1.52-.69.54-.14,1.08-.22,1.63-.24.54-.02,1.09.02,1.62.09.54.08,1.06.17,1.6.33l.4.12-.12.39c-.29.99-.65,1.94-1.11,2.86-.48.9-1.03,1.82-1.97,2.45l-.38.2c-.13.05-.25.09-.38.14-.25.08-.51.14-.76.18-.51.09-1.02.13-1.52.13-1.01,0-2.02-.08-3-.28ZM553.77,189c1,.02,1.99,0,2.97-.13.49-.05.97-.14,1.43-.26.23-.06.46-.14.68-.22.11-.05.22-.09.32-.14l.27-.17c.7-.54,1.2-1.39,1.62-2.26.4-.87.76-1.8,1.01-2.72l.28.51c-.93-.27-1.96-.43-2.94-.42-.99-.01-1.97.19-2.8.68-.4.25-.77.59-1.1.96-.33.37-.61.79-.85,1.23-.47.89-.78,1.89-.88,2.93Z"
              />
              <path
                class="cls-58"
                d="M542.35,186.12c.14-.6.37-1.17.68-1.72.32-.53.7-1.08,1.36-1.4.33-.16.68-.21,1.02-.21.34-.01.66.02.98.08.32.05.63.13.93.23.3.1.59.2.9.33l.28.12-.04.31c-.05.37-.14.68-.26,1.01-.12.32-.27.64-.46.93-.19.29-.43.56-.71.79-.28.23-.61.4-.95.51-.34.09-.69.16-1.04.14-.34-.02-.68-.07-1-.17-.63-.21-1.21-.53-1.69-.97ZM542.35,186.12c.58.27,1.18.47,1.78.55.6.09,1.2.02,1.72-.19.25-.12.48-.26.68-.45.2-.19.37-.41.51-.66.28-.48.48-1.07.57-1.62l.24.43c-.51-.23-1.08-.42-1.62-.55-.28-.07-.55-.11-.82-.12-.27,0-.54,0-.76.08-.47.17-.9.58-1.27,1.03-.38.45-.7.96-1.01,1.49Z"
              />
              <path
                class="cls-58"
                d="M546.22,184.69c.19.77-.11,1.51-.68,1.66-.57.14-1.19-.36-1.39-1.13-.19-.77.11-1.51.68-1.66.57-.14,1.19.36,1.39,1.13Z"
              />
              <path
                class="cls-58"
                d="M560.02,185.48c.36,1.41-.2,2.77-1.25,3.03-1.05.26-2.18-.66-2.54-2.08-.36-1.41.2-2.77,1.25-3.03,1.05-.26,2.18.66,2.54,2.08Z"
              />
              <path
                class="cls-88"
                d="M551.72,182.52s2.5-3.91,4.52-4.71c2.03-.8,6.5.24,6.5.24"
              />
              <rect
                class="cls-88"
                x="554.52"
                y="199.25"
                width="10.78"
                height="10.78"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                class="cls-80"
                d="M512.09,236.64c-6.56,8.24-10.51,19.63-10.38,22.3.14,2.93,7.36,13.26,10.85,18.01.45.61,3.06.27,5.24-1.08,2.3-1.43,4.15-3.92,3.67-4.63-1.79-2.66-9.58-13.16-9.58-14.81,0-1.52,3.1-10.93,4.24-16.36,1.09-5.21-.99-7.27-4.04-3.44Z"
              />
              <path
                class="cls-38"
                d="M510.1,276.96l10.76-7.56s-8.68-11.65-8.72-12.92c-.04-1.26,2.97-11.26,4.08-15.87,1.11-4.61-.34-9.65-5.54-2.58-5.2,7.07-8.8,17.41-9.26,20.16-.46,2.75,8.69,18.77,8.69,18.77Z"
              />
              <path
                class="cls-65"
                d="M508.94,274.55c.36-.36.81-.65,1.21-.97.36-.29.72-.58,1.09-.86.8-.61,1.6-1.24,2.4-1.85.8-.61,1.6-1.22,2.4-1.82.8-.6,1.59-1.23,2.42-1.78.03-.02.07.03.04.06-.72.71-1.5,1.35-2.27,1.99-.76.63-1.54,1.24-2.32,1.84-.8.61-1.61,1.2-2.43,1.78-.4.28-.8.54-1.2.81-.42.28-.85.62-1.31.84-.02.01-.05-.02-.03-.04Z"
              />
              <g>
                <g>
                  <path
                    class="cls-80"
                    d="M500.26,333.3s-1.77,17.51-1.77,17.52c.06,3.23.17,6.07.35,7.53,0,0,0,.02,0,.02.07.55.15.9.24.99,0,0,.01.02.02.02.92.63,18.85.87,19.71.58.86-.29.13-2.9-.81-3.71-.95-.81-3.76-5.33-3.76-5.33l1.62-17.5-15.6-.13Z"
                  />
                  <g>
                    <g>
                      <path
                        class="cls-65"
                        d="M515.13,351.72c-1.55-.58-3.55-.65-4.95.35-.05.04,0,.12.05.11,1.66-.26,3.18-.35,4.86-.25.12,0,.15-.17.04-.21Z"
                      />
                      <path
                        class="cls-65"
                        d="M516.18,352.65c-1.55-.58-3.55-.65-4.95.35-.05.04,0,.12.05.11,1.66-.26,3.18-.35,4.86-.25.12,0,.15-.17.04-.21Z"
                      />
                      <path
                        class="cls-65"
                        d="M517.22,353.58c-1.55-.58-3.55-.65-4.95.35-.05.04,0,.12.05.11,1.66-.26,3.18-.35,4.86-.25.12,0,.15-.17.04-.21Z"
                      />
                    </g>
                    <path
                      class="cls-84"
                      d="M519.23,360.07c-.86.3-19.19-.05-20.12-.68-.36-.23-.53-4.01-.62-8.57,0-.05,0-.1,0-.14l15.76-.03v.28s3.21,4.63,4.16,5.44c.94.81,1.67,3.41.81,3.71Z"
                    />
                    <path
                      class="cls-60"
                      d="M498.49,350.67v.15c.09,4.56.26,8.33.62,8.57.42.29,5.72.49,11.44.61,6.85.13,8.21.24,8.68.08.86-.3.12-2.9-.82-3.71-.95-.81-4.17-5.44-4.17-5.44v-.28s-5.25,0-5.25,0l-10.51.02Z"
                    />
                  </g>
                </g>
                <path
                  class="cls-65"
                  d="M497.4,350.98l17.67-.14s1.36-34.36,2.27-44.47c1.14-12.65,2.59-44.22,2.59-44.22h-15.03s-3.42,7.73-1.26,16.33l-2.2,31.04-4.04,41.45Z"
                />
              </g>
              <g>
                <g>
                  <g>
                    <path
                      class="cls-65"
                      d="M539.43,350.92c-1.63-.25-3.6.09-4.8,1.36-.05.05.02.12.07.1,1.58-.6,3.06-1,4.72-1.24.12-.02.12-.2,0-.22Z"
                    />
                    <path
                      class="cls-65"
                      d="M540.63,351.62c-1.63-.25-3.6.09-4.8,1.36-.05.05.02.12.07.1,1.58-.6,3.06-1,4.72-1.24.12-.02.12-.2,0-.22Z"
                    />
                    <path
                      class="cls-65"
                      d="M541.82,352.31c-1.63-.25-3.6.09-4.8,1.36-.05.05.02.12.07.1,1.58-.6,3.06-1,4.72-1.24.12-.02.12-.2,0-.22Z"
                    />
                  </g>
                  <path
                    class="cls-60"
                    d="M549.01,359.97c-.86.3-25.29.06-26.21-.58-.36-.23-.53-4.01-.62-8.57,0-.05,0-.1,0-.14l15.76-.03v.28s9.3,4.52,10.25,5.33c.94.81,1.67,3.41.81,3.71Z"
                  />
                </g>
                <path
                  class="cls-65"
                  d="M512.85,279.93s5.19,24.06,5.4,28.51c.17,3.79,2.77,42.69,2.77,42.69l18.35-.21s-4.62-39.64-4.97-43.58c-.65-7.38-4.65-27.55-9.31-45.53l-19.79.35s.32,9.46,4.49,16.23c0,0,1.85.87,3.04,1.55Z"
                />
              </g>
              <path
                class="cls-51"
                d="M519.74,239.14c-1.07.21-3.58-1.59-4.69-3.25-.08-.11-.04-1.42-.06-3-.02-.96-.06-2.03-.16-3.01l5.93.79s-.35,2.11-.16,3.81c.02.14.04.27.08.4,0,.02.01.04.02.07.23,2.43.71,3.88-.96,4.2Z"
              />
              <g>
                <path
                  class="cls-66"
                  d="M516.61,233.17s0,0,0,0"
                />
                <path
                  class="cls-51"
                  d="M513.84,221.63c-.65,2.18.39,8.49,1.85,9.9,2.11,2.06,5.59,2.28,7.24-.41,1.6-2.61.11-10.81-1.51-12.1-2.4-1.9-6.62-.61-7.58,2.6Z"
                />
                <path
                  class="cls-51"
                  d="M522.95,222.37s.71,2.33,1.43,4.64l-.77-.02.28,1.05s-.77.33-1.63-.16l.69-5.52Z"
                />
                <g>
                  <path
                    class="cls-65"
                    d="M521.94,224.69c-.65.09-.43,1.47.18,1.38.59-.09.37-1.46-.18-1.38Z"
                  />
                  <path
                    class="cls-76"
                    d="M521.34,224.25c.17-.08.31-.18.47-.28.18-.11.33-.18.43-.38.05-.11,0-.28-.1-.34-.22-.15-.48-.07-.7.05-.24.13-.39.3-.5.56-.1.25.18.49.4.39Z"
                  />
                  <path
                    class="cls-65"
                    d="M522.43,229.12c.11.08.23.2.38.19.14-.01.29-.11.41-.19.01,0,.03,0,.02.02-.08.18-.28.33-.47.32-.19,0-.3-.15-.38-.32-.01-.02.02-.04.04-.03Z"
                  />
                  <path
                    class="cls-65"
                    d="M522.13,227.83c.44.39.82.52,1.46.32.03,0,.04-.04.03-.04-.51.03-.9-.02-1.47-.33-.03-.02-.04.02-.01.05Z"
                  />
                </g>
                <g>
                  <path
                    class="cls-76"
                    d="M522.68,217.6c.77,1.34.37,4.13-3.66,4.04,0,0,.42.93.25,2.08-.09.63-.64.8-.64.8.16.52.39,1.54.33,1.64-.2.3-.56.24-.59.24,0,0-2.51,3.7-3.62,3.44-.62-1.34-3.39-5.42-2.47-8.38.47-1.52,2.25-2.25,2.25-2.25,3.26-3.7,6.91-3.76,8.15-1.62Z"
                  />
                  <path
                    class="cls-76"
                    d="M519.03,221.64c.2.55.39,1.1.42,1.66.02.27-.02.55-.16.77-.15.22-.4.34-.66.45.27-.02.57-.1.78-.35.21-.24.26-.59.24-.89-.02-.31-.1-.6-.21-.88-.11-.27-.25-.54-.42-.77Z"
                  />
                  <path
                    class="cls-76"
                    d="M514.54,219.23c-.8.19-1.57.61-2.12,1.28-.28.33-.48.74-.59,1.18-.1.44-.12.88-.09,1.32.07.88.33,1.73.66,2.52.34.79.76,1.55,1.26,2.24-.43-.74-.8-1.51-1.11-2.31-.3-.8-.54-1.63-.6-2.47-.03-.42-.03-.85.06-1.26.09-.41.28-.78.52-1.12.5-.66,1.23-1.11,2-1.39Z"
                  />
                </g>
                <path
                  class="cls-51"
                  d="M518.37,226.41s-1.37-2.02-2.24-1.5c-.87.52.18,3.46,1.21,3.85,1.03.39,1.39-.61,1.39-.61l-.36-1.74Z"
                />
              </g>
              <path
                class="cls-38"
                d="M502.07,270.18c.06.07,26.36.61,26.6.33.34-.4-3.08-27.95-8.12-33.25-1.24-1.31-4.52-4.08-5.72-3-4.71,4.22-6.07,9.08-7.24,12.15-.87,2.28-1.92,6.16-2.87,10.14-1.57,6.56-2.87,13.37-2.65,13.64Z"
              />
              <path
                class="cls-51"
                d="M515.06,237.94c-5.08,9.33-7.09,21.29-6.51,23.88.63,2.86,6.06,12.22,10.29,16.26.54.52,3.06-.3,4.98-2.04,2.03-1.84,3.44-4.63,2.85-5.24-2.21-2.29-8.23-11.72-8.51-13.34-.26-1.5,1.24-11.34,1.45-16.89.21-5.33-2.18-6.97-4.55-2.63Z"
              />
              <path
                class="cls-38"
                d="M514.66,278.19l11.09-9.09s-7.1-10.4-7.35-11.64c-.25-1.24,1.05-11.64,1.38-16.38.33-4.74-1.94-9.44-5.88-1.51-3.94,7.93-5.76,18.78-5.76,21.57s6.53,17.05,6.53,17.05Z"
              />
            </g>
            <path
              class="cls-65"
              d="M525.91,269.39c.06,0,.11-.02.16-.06.11-.09.13-.27.04-.39-.08-.1-7.62-10.17-7.68-12.95-.06-2.83,1.73-10.61,1.75-10.68.03-.15-.05-.3-.19-.33-.14-.04-.28.05-.31.2-.07.32-1.83,7.93-1.76,10.83.07,2.96,7.48,12.86,7.79,13.28.05.07.13.1.2.1Z"
            />
            <path
              class="cls-65"
              d="M511.35,270.77s.09-.01.13-.03c.13-.07.17-.24.1-.38-.04-.08-4.12-7.87-3.37-11.08.78-3.32,2.66-11.72,2.67-11.81.03-.15-.05-.3-.19-.33-.14-.04-.28.06-.31.2-.02.08-1.89,8.49-2.67,11.8-.8,3.42,3.25,11.15,3.42,11.48.05.09.14.14.23.14Z"
            />
            <path
              class="cls-65"
              d="M503.32,263.08c.11,0,.22-.08.25-.2l5.35-19.45c.04-.15-.04-.3-.18-.34-.14-.04-.28.04-.32.19l-5.35,19.45c-.04.15.04.3.18.34.02,0,.05.01.07.01Z"
            />
            <path
              class="cls-53"
              d="M534.48,344.02s.02,0,.02,0c.14-.01.25-.15.24-.3-.2-2.39-5-58.68-9.9-68.61-.07-.14-.22-.19-.35-.12-.13.07-.18.24-.11.37,4.85,9.84,9.79,67.82,9.84,68.41.01.14.13.25.26.25Z"
            />
            <path
              class="cls-65"
              d="M516.46,280.62c.59,0,.94-.02.95-.02.14-.01.25-.14.24-.29,0-.15-.14-.26-.28-.26-.05,0-4.88.33-9.51-1.56-.13-.05-.28.02-.34.16-.05.14.02.3.15.36,3.5,1.43,7.12,1.62,8.79,1.62Z"
            />
            <path
              class="cls-53"
              d="M517.58,303.81s.03,0,.05,0c.14-.03.23-.17.2-.32l-4.38-23.35c-.03-.15-.16-.25-.31-.22-.14.03-.23.17-.2.32l4.38,23.35c.02.13.13.22.25.22Z"
            />
            <path
              class="cls-53"
              d="M512.58,344.99c.13,0,.25-.11.26-.25l3.66-47.87c.01-.15-.1-.28-.24-.3-.14,0-.27.1-.28.25l-3.66,47.87c-.01.15.1.28.24.3,0,0,.01,0,.02,0Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script setup>
import { computed } from 'vue'
import { get as _get } from 'lodash'

const props = defineProps({
  stage: { type: Object, default: () => ({}) }
})

const currentClass = computed(() => `stage${_get(props, 'stage.index', '0')}`)
</script>

<style lang="scss" scoped>
.cls-1, .cls-2 {
  fill: #c9c9c9;
}

.cls-1, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16 {
  stroke-miterlimit: 10;
}

.cls-1, .cls-4, .cls-5, .cls-8 {
  stroke: #cccbca;
}

.cls-17 {
  fill: #333;
}

.cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-2, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90 {
  stroke-width: 0px;
}

.cls-18 {
  fill: #898989;
}

.cls-19 {
  fill: #3d3d3d;
}

.cls-20 {
  stroke: #d1d1d1;
}

.cls-20, .cls-24, .cls-3, .cls-6, .cls-36, .cls-9, .cls-66, .cls-10, .cls-11, .cls-13 {
  fill: none;
}

.cls-20, .cls-36, .cls-66 {
  stroke-linejoin: round;
}

.cls-20, .cls-36, .cls-66, .cls-11, .cls-13 {
  stroke-linecap: round;
}

.cls-21, .cls-62 {
  fill: #c4c4c4;
}

.cls-22 {
  fill: #c1c1c1;
}

.cls-23 {
  fill: #565656;
}

.cls-3 {
  stroke-width: 1px;
}

.cls-3, .cls-6, .cls-7, .cls-12, .cls-14, .cls-15 {
  stroke: #d6d5d2;
}

.cls-4 {
  fill: #ebebeb;
}

.cls-25 {
  fill: #a5a5a5;
opacity: .5;
}

.cls-26 {
  fill: #bab9b9;
}

.cls-27 {
  fill: #6b6866;
}

.cls-28 {
  fill: #d8c67c;
  opacity: .04;
}

.cls-29 {
  fill: #afafaf;
}

.cls-30 {
  fill: #4c4b4a;
}

.cls-5, .cls-59, .cls-14 {
  fill: #eaeaeb;
}

.cls-31 {
  fill: #263238;
}

.cls-32, .cls-48 {
  fill: #d8d8d8;
}

.cls-33 {
  fill: #666;
}

.cls-34, .cls-15 {
  fill: #e0e0e0;
}

.cls-35 {
  fill: #d2d2d4;
}

.cls-7 {
  fill: #a0a0a0;
}

.cls-36 {
  stroke: #f2a49b;
}

.cls-37 {
  fill: #030705;
}

.cls-38 {
  fill: #dbdbdb;
}

.cls-8 {
  fill: #d3d3d3;
}

.cls-39 {
  fill: #1a1a1a;
}

.cls-40 {
  fill: #4f4f4f;
}

.cls-41 {
  fill: #a0a7aa;
}

.cls-91 {
  clip-path: url(#clippath-1);
}

.cls-92 {
  clip-path: url(#clippath-4);
}

.cls-93 {
  clip-path: url(#clippath-3);
}

.cls-94 {
  clip-path: url(#clippath-2);
}

.cls-95 {
  clip-path: url(#clippath-7);
}

.cls-96 {
  clip-path: url(#clippath-8);
}

.cls-97 {
  clip-path: url(#clippath-6);
}

.cls-98 {
  clip-path: url(#clippath-5);
}

.cls-99 {
  clip-path: url(#clippath-9);
}

.cls-42, .cls-16 {
  fill: #999;
}

.cls-43 {
  fill: #e0e0e0;
}

.cls-44 {
  fill: #a07858;
}

.cls-45, .cls-50 {
  fill: #000;
}

.cls-46 {
  fill: #0f0605;
}

.cls-47 {
  opacity: .6;
}

.cls-47, .cls-82 {
  fill: #fff;
}

.cls-48, .cls-50 {
  opacity: .1;
}

.cls-49 {
  fill: #747e82;
}

.cls-100 {
  clip-path: url(#clippath-14);
}

.cls-101 {
  clip-path: url(#clippath-12);
}

.cls-102 {
  clip-path: url(#clippath-10);
}

.cls-103 {
  clip-path: url(#clippath-11);
}

.cls-51 {
  fill: #ededed;
}

.cls-52 {
  fill: #b2b2b2;
}

.cls-53 {
  fill: #4a5a60;
}

.cls-54 {
  fill: #a8a8a8;
}

.cls-55 {
  fill: #3f3f3f;
}

.cls-56 {
  fill: #777;
}

.cls-57 {
  fill: #6e7070;
}

.cls-58 {
  fill: #c7c7c7;
}

.cls-9 {
  stroke: #acacaf;
}

.cls-60 {
  fill: #455a64;
}

.cls-61 {
  fill: gray;
}

.cls-62 {
  opacity: .2;
}

.cls-63 {
  fill: #bfbebe;
}

.cls-64 {
  fill: #727272;
}

.cls-65 {
  fill: #263238;
}

.cls-66 {
  stroke: #ffa49b;
}

.cls-10 {
  stroke-width: .75px;
}

.cls-10, .cls-11, .cls-13 {
  stroke: #263238;
}

.cls-67 {
  fill: #1c1d1e;
}

.cls-68 {
  fill: #d6d5d2;
}

.cls-69 {
  fill: #dbdbdb;
}

.cls-70 {
  fill: #e8e8e8;
}

.cls-71 {
  fill: #2e3e44;
}

.cls-72 {
  fill: #7f7c7c;
}

.cls-11 {
  stroke-width: .5px;
}

.cls-73 {
  fill: #9b9b9b;
}

.cls-74 {
  fill: #774442;
}

.cls-75 {
  fill: #cccbca;
}

.cls-76 {
  fill: #303030;
}

.cls-77 {
  fill: #fff099;
}

.cls-78 {
  fill: #939393;
}

.cls-79 {
  fill: #ebebeb;
}

.cls-80 {
  fill: #d3766a;
}

.cls-12 {
  fill: #ccc;
}

.cls-81 {
  fill: #fafafa;
}

.cls-83 {
  fill: #efefef;
}

.cls-84 {
  fill: #37474f;
}

.cls-85 {
  fill: #442f1f;
}

.cls-86 {
  fill: #e5e5e5;
}

.cls-87 {
  fill: #ff906e;
}

.cls-88 {
  fill: #ffe96b;
}

.cls-89 {
  fill: #f5f5f5;
}

.cls-90 {
  fill: #684f38;
}

.cls-16 {
  stroke: #999;
  stroke-width: .25px;
}

.stage1 {
  .cls-21 {
    fill: #FFF099;
  }

  .cls-83 {
    fill: #F2C5B1;
  }

  .cls-32 {
    fill: #d6c572;
  }
}

.stage2 {
  @extend .stage1;

  .cls-54 {
    fill: #FF906E;
  }
}

.stage3 {
  @extend .stage2;

  .cls-8 {
    fill: #C5EDE6;
  }

  .cls-29 {
    fill: #AACEC7;
  }

  .cls-73 {
    fill: #FF906E;
  }

  .cls-2 {
    fill: #FFF099;
  }
}

.stage4 {
  @extend .stage3;

  #personnage_droite {
    .cls-56 {
      fill: #FF906E;
    }

    .cls-78 {
      fill: #E87458;
    }

    .cls-40 {
      fill: #A07858;
    }
  }
}

.stage5 {
  @extend .stage4;

  .cls-1 {
    fill: #FFF099;
  }

  .cls-25 {
    fill: #E8D887;
  }
}

.stage6 {
  @extend .stage5;

  #fenêtre_centre_bas {
    .cls-89 {
      fill: #FF906E;
    }

    .cls-23 {
      fill: #684F38;
    }
  }
}

.stage7 {
  @extend .stage6;

  #fenêtre_centre_bas {
    .cls-64 {
      fill: #A07858;
    }
  }
}

.stage8 {
  @extend .stage7;

  #fenêtre_centre_bas {
    .cls-12 {
      fill: #FFF099;
    }
  }
}

.stage9 {
  @extend .stage8;

  #fenêtre_milieu {
    .cls-59 {
      fill: #FFE96B;
    }

    .cls-69 {
      fill: #E2CB5A;
    }
  }
}

.stage10 {
  @extend .stage9;

  #fenêtre_milieu {
    .cls-78 {
      fill: #FFE96B;
    }

    .cls-63 {
      fill: #E5C7C6;
    }
  }
}

.stage11 {
  @extend .stage10;

  #fenêtre_milieu {
    .cls-7 {
      fill: #C5EDE6;
    }
  }
}

.stage12 {
  @extend .stage11;

  #fnetre_gauche_droite {
    .cls-39 {
      fill: #FF906E;
    }

    .cls-75 {
      fill: #F2C5B1;
    }

    .cls-61 {
      fill: #263238;
    }

    .cls-33 {
      fill: #455A64;
    }

    .cls-42 {
      fill: #263238;
    }

    .cls-16 {
      stroke: #263238;
    }
  }
}

.stage13 {
  @extend .stage12;

  #fnetre_gauche_droite {
    .cls-7 {
      fill: #FFF099;
    }

    .cls-18 {
      fill: #FF906E;
    }
  }
}

.stage14 {
  @extend .stage13;

  #fenêtre_gauche_haut {
    .cls-7 {
      fill: #FFF099;
    }

    .cls-76 {
      fill: #FF906E;
    }

    .cls-51 {
      fill: #E5C7C6;
    }
  }
}
</style>